/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: payments/payments.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../google/protobuf/timestamp";
import * as dependency_2 from "./../google/api/annotations";
import * as dependency_3 from "./../tokenizer/tokenizer";
import * as pb_1 from "google-protobuf";
import * as grpc_1 from "@grpc/grpc-js";
import * as grpc_web_1 from "grpc-web";
export namespace payments.v1 {
    export enum ReportStatus {
        REPORT_STATUS_UNSPECIFIED = 0,
        REPORT_STATUS_PROCESSING = 1,
        REPORT_STATUS_COMPLETED = 2,
        REPORT_STATUS_FAILED = 3
    }
    export enum PaymentProvider {
        PAYMENT_PROVIDER_UNKNOWN = 0,
        PAYMENT_PROVIDER_STARKBANK = 1,
        PAYMENT_PROVIDER_BRADESCO = 2,
        PAYMENT_PROVIDER_REDE = 3
    }
    export enum PixType {
        PIX_TYPE_UNSPECIFIED = 0,
        PIX_TYPE_STARKBANK = 1,
        PIX_TYPE_BRADESCO = 2
    }
    export enum PaymentMethod {
        PAYMENT_METHOD_UNSPECIFIED = 0,
        PAYMENT_METHOD_PIX = 1,
        PAYMENT_METHOD_BANK_SLIP = 2,
        PAYMENT_METHOD_BANK_SLIP_AND_PIX = 3,
        PAYMENT_METHOD_CREDIT_CARD = 4,
        PAYMENT_METHOD_DEBIT_CARD = 5,
        PAYMENT_METHOD_COMMITMENT = 6,
        PAYMENT_METHOD_AUTO_SETTLEMENT = 7
    }
    export enum PaymentStatus {
        PAYMENT_STATUS_UNSPECIFIED = 0,
        PAYMENT_STATUS_PENDING = 1,
        PAYMENT_STATUS_APPROVED = 2,
        PAYMENT_STATUS_DECLINED = 3,
        PAYMENT_STATUS_FAILED = 4,
        PAYMENT_STATUS_CANCELLED = 5,
        PAYMENT_STATUS_SETTLED = 6,
        PAYMENT_STATUS_EXPIRED = 7
    }
    export enum CardType {
        CARD_TYPE_UNSPECIFIED = 0,
        CARD_TYPE_CREDIT = 1,
        CARD_TYPE_DEBIT = 2,
        CARD_TYPE_PREPAID = 3,
        CARD_TYPE_OTHER = 4
    }
    export enum ProductType {
        PRODUCT_TYPE_UNSPECIFIED = 0,
        PRODUCT_TYPE_PLAN = 1
    }
    export class StartReportRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            isPdf?: boolean;
            isXlsx?: boolean;
            filter?: FilterReport;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("isPdf" in data && data.isPdf != undefined) {
                    this.isPdf = data.isPdf;
                }
                if ("isXlsx" in data && data.isXlsx != undefined) {
                    this.isXlsx = data.isXlsx;
                }
                if ("filter" in data && data.filter != undefined) {
                    this.filter = data.filter;
                }
            }
        }
        get isPdf() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set isPdf(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        get isXlsx() {
            return pb_1.Message.getFieldWithDefault(this, 2, false) as boolean;
        }
        set isXlsx(value: boolean) {
            pb_1.Message.setField(this, 2, value);
        }
        get filter() {
            return pb_1.Message.getWrapperField(this, FilterReport, 3) as FilterReport;
        }
        set filter(value: FilterReport) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasFilter() {
            return pb_1.Message.getField(this, 3) != null;
        }
        static fromObject(data: {
            isPdf?: boolean;
            isXlsx?: boolean;
            filter?: ReturnType<typeof FilterReport.prototype.toObject>;
        }): StartReportRequest {
            const message = new StartReportRequest({});
            if (data.isPdf != null) {
                message.isPdf = data.isPdf;
            }
            if (data.isXlsx != null) {
                message.isXlsx = data.isXlsx;
            }
            if (data.filter != null) {
                message.filter = FilterReport.fromObject(data.filter);
            }
            return message;
        }
        toObject() {
            const data: {
                isPdf?: boolean;
                isXlsx?: boolean;
                filter?: ReturnType<typeof FilterReport.prototype.toObject>;
            } = {};
            if (this.isPdf != null) {
                data.isPdf = this.isPdf;
            }
            if (this.isXlsx != null) {
                data.isXlsx = this.isXlsx;
            }
            if (this.filter != null) {
                data.filter = this.filter.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.isPdf != false)
                writer.writeBool(1, this.isPdf);
            if (this.isXlsx != false)
                writer.writeBool(2, this.isXlsx);
            if (this.hasFilter)
                writer.writeMessage(3, this.filter, () => this.filter.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StartReportRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StartReportRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.isPdf = reader.readBool();
                        break;
                    case 2:
                        message.isXlsx = reader.readBool();
                        break;
                    case 3:
                        reader.readMessage(message.filter, () => message.filter = FilterReport.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): StartReportRequest {
            return StartReportRequest.deserialize(bytes);
        }
    }
    export class FilterReport extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            organizationId?: string;
            workspaceId?: string;
            customerId?: string;
            status?: PaymentStatus[];
            startDate?: dependency_1.google.protobuf.Timestamp;
            endDate?: dependency_1.google.protobuf.Timestamp;
            orderId?: string;
            paymentType?: PaymentType[];
            productId?: string[];
            customerUsername?: string;
            method?: PaymentMethod[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4, 8, 9, 11], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("customerId" in data && data.customerId != undefined) {
                    this.customerId = data.customerId;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("startDate" in data && data.startDate != undefined) {
                    this.startDate = data.startDate;
                }
                if ("endDate" in data && data.endDate != undefined) {
                    this.endDate = data.endDate;
                }
                if ("orderId" in data && data.orderId != undefined) {
                    this.orderId = data.orderId;
                }
                if ("paymentType" in data && data.paymentType != undefined) {
                    this.paymentType = data.paymentType;
                }
                if ("productId" in data && data.productId != undefined) {
                    this.productId = data.productId;
                }
                if ("customerUsername" in data && data.customerUsername != undefined) {
                    this.customerUsername = data.customerUsername;
                }
                if ("method" in data && data.method != undefined) {
                    this.method = data.method;
                }
            }
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get customerId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set customerId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 4, []) as PaymentStatus[];
        }
        set status(value: PaymentStatus[]) {
            pb_1.Message.setField(this, 4, value);
        }
        get startDate() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 5) as dependency_1.google.protobuf.Timestamp;
        }
        set startDate(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get hasStartDate() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get endDate() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 6) as dependency_1.google.protobuf.Timestamp;
        }
        set endDate(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get hasEndDate() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get orderId() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set orderId(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get paymentType() {
            return pb_1.Message.getRepeatedWrapperField(this, PaymentType, 8) as PaymentType[];
        }
        set paymentType(value: PaymentType[]) {
            pb_1.Message.setRepeatedWrapperField(this, 8, value);
        }
        get productId() {
            return pb_1.Message.getFieldWithDefault(this, 9, []) as string[];
        }
        set productId(value: string[]) {
            pb_1.Message.setField(this, 9, value);
        }
        get customerUsername() {
            return pb_1.Message.getFieldWithDefault(this, 10, "") as string;
        }
        set customerUsername(value: string) {
            pb_1.Message.setField(this, 10, value);
        }
        get method() {
            return pb_1.Message.getFieldWithDefault(this, 11, []) as PaymentMethod[];
        }
        set method(value: PaymentMethod[]) {
            pb_1.Message.setField(this, 11, value);
        }
        static fromObject(data: {
            organizationId?: string;
            workspaceId?: string;
            customerId?: string;
            status?: PaymentStatus[];
            startDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            endDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            orderId?: string;
            paymentType?: ReturnType<typeof PaymentType.prototype.toObject>[];
            productId?: string[];
            customerUsername?: string;
            method?: PaymentMethod[];
        }): FilterReport {
            const message = new FilterReport({});
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.customerId != null) {
                message.customerId = data.customerId;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.startDate != null) {
                message.startDate = dependency_1.google.protobuf.Timestamp.fromObject(data.startDate);
            }
            if (data.endDate != null) {
                message.endDate = dependency_1.google.protobuf.Timestamp.fromObject(data.endDate);
            }
            if (data.orderId != null) {
                message.orderId = data.orderId;
            }
            if (data.paymentType != null) {
                message.paymentType = data.paymentType.map(item => PaymentType.fromObject(item));
            }
            if (data.productId != null) {
                message.productId = data.productId;
            }
            if (data.customerUsername != null) {
                message.customerUsername = data.customerUsername;
            }
            if (data.method != null) {
                message.method = data.method;
            }
            return message;
        }
        toObject() {
            const data: {
                organizationId?: string;
                workspaceId?: string;
                customerId?: string;
                status?: PaymentStatus[];
                startDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                endDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                orderId?: string;
                paymentType?: ReturnType<typeof PaymentType.prototype.toObject>[];
                productId?: string[];
                customerUsername?: string;
                method?: PaymentMethod[];
            } = {};
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.customerId != null) {
                data.customerId = this.customerId;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.startDate != null) {
                data.startDate = this.startDate.toObject();
            }
            if (this.endDate != null) {
                data.endDate = this.endDate.toObject();
            }
            if (this.orderId != null) {
                data.orderId = this.orderId;
            }
            if (this.paymentType != null) {
                data.paymentType = this.paymentType.map((item: PaymentType) => item.toObject());
            }
            if (this.productId != null) {
                data.productId = this.productId;
            }
            if (this.customerUsername != null) {
                data.customerUsername = this.customerUsername;
            }
            if (this.method != null) {
                data.method = this.method;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.organizationId.length)
                writer.writeString(1, this.organizationId);
            if (this.workspaceId.length)
                writer.writeString(2, this.workspaceId);
            if (this.customerId.length)
                writer.writeString(3, this.customerId);
            if (this.status.length)
                writer.writePackedEnum(4, this.status);
            if (this.hasStartDate)
                writer.writeMessage(5, this.startDate, () => this.startDate.serialize(writer));
            if (this.hasEndDate)
                writer.writeMessage(6, this.endDate, () => this.endDate.serialize(writer));
            if (this.orderId.length)
                writer.writeString(7, this.orderId);
            if (this.paymentType.length)
                writer.writeRepeatedMessage(8, this.paymentType, (item: PaymentType) => item.serialize(writer));
            if (this.productId.length)
                writer.writeRepeatedString(9, this.productId);
            if (this.customerUsername.length)
                writer.writeString(10, this.customerUsername);
            if (this.method.length)
                writer.writePackedEnum(11, this.method);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): FilterReport {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new FilterReport();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.organizationId = reader.readString();
                        break;
                    case 2:
                        message.workspaceId = reader.readString();
                        break;
                    case 3:
                        message.customerId = reader.readString();
                        break;
                    case 4:
                        message.status = reader.readPackedEnum();
                        break;
                    case 5:
                        reader.readMessage(message.startDate, () => message.startDate = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 6:
                        reader.readMessage(message.endDate, () => message.endDate = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 7:
                        message.orderId = reader.readString();
                        break;
                    case 8:
                        reader.readMessage(message.paymentType, () => pb_1.Message.addToRepeatedWrapperField(message, 8, PaymentType.deserialize(reader), PaymentType));
                        break;
                    case 9:
                        pb_1.Message.addToRepeatedField(message, 9, reader.readString());
                        break;
                    case 10:
                        message.customerUsername = reader.readString();
                        break;
                    case 11:
                        message.method = reader.readPackedEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): FilterReport {
            return FilterReport.deserialize(bytes);
        }
    }
    export class StartReportResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            reportId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("reportId" in data && data.reportId != undefined) {
                    this.reportId = data.reportId;
                }
            }
        }
        get reportId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set reportId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            reportId?: string;
        }): StartReportResponse {
            const message = new StartReportResponse({});
            if (data.reportId != null) {
                message.reportId = data.reportId;
            }
            return message;
        }
        toObject() {
            const data: {
                reportId?: string;
            } = {};
            if (this.reportId != null) {
                data.reportId = this.reportId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.reportId.length)
                writer.writeString(1, this.reportId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StartReportResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StartReportResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.reportId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): StartReportResponse {
            return StartReportResponse.deserialize(bytes);
        }
    }
    export class GetReportRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            reportId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("reportId" in data && data.reportId != undefined) {
                    this.reportId = data.reportId;
                }
            }
        }
        get reportId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set reportId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            reportId?: string;
        }): GetReportRequest {
            const message = new GetReportRequest({});
            if (data.reportId != null) {
                message.reportId = data.reportId;
            }
            return message;
        }
        toObject() {
            const data: {
                reportId?: string;
            } = {};
            if (this.reportId != null) {
                data.reportId = this.reportId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.reportId.length)
                writer.writeString(1, this.reportId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetReportRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetReportRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.reportId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetReportRequest {
            return GetReportRequest.deserialize(bytes);
        }
    }
    export class GetReportResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            status?: ReportStatus;
            urlPdf?: string;
            urlXlsx?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("urlPdf" in data && data.urlPdf != undefined) {
                    this.urlPdf = data.urlPdf;
                }
                if ("urlXlsx" in data && data.urlXlsx != undefined) {
                    this.urlXlsx = data.urlXlsx;
                }
            }
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 1, ReportStatus.REPORT_STATUS_UNSPECIFIED) as ReportStatus;
        }
        set status(value: ReportStatus) {
            pb_1.Message.setField(this, 1, value);
        }
        get urlPdf() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set urlPdf(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get urlXlsx() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set urlXlsx(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            status?: ReportStatus;
            urlPdf?: string;
            urlXlsx?: string;
        }): GetReportResponse {
            const message = new GetReportResponse({});
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.urlPdf != null) {
                message.urlPdf = data.urlPdf;
            }
            if (data.urlXlsx != null) {
                message.urlXlsx = data.urlXlsx;
            }
            return message;
        }
        toObject() {
            const data: {
                status?: ReportStatus;
                urlPdf?: string;
                urlXlsx?: string;
            } = {};
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.urlPdf != null) {
                data.urlPdf = this.urlPdf;
            }
            if (this.urlXlsx != null) {
                data.urlXlsx = this.urlXlsx;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.status != ReportStatus.REPORT_STATUS_UNSPECIFIED)
                writer.writeEnum(1, this.status);
            if (this.urlPdf.length)
                writer.writeString(2, this.urlPdf);
            if (this.urlXlsx.length)
                writer.writeString(3, this.urlXlsx);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetReportResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetReportResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.status = reader.readEnum();
                        break;
                    case 2:
                        message.urlPdf = reader.readString();
                        break;
                    case 3:
                        message.urlXlsx = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetReportResponse {
            return GetReportResponse.deserialize(bytes);
        }
    }
    export class UpdatePaymentRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            paymentStatus?: PaymentStatus;
            id?: string;
            customer?: Customer;
            invoiceNumber?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("paymentStatus" in data && data.paymentStatus != undefined) {
                    this.paymentStatus = data.paymentStatus;
                }
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("customer" in data && data.customer != undefined) {
                    this.customer = data.customer;
                }
                if ("invoiceNumber" in data && data.invoiceNumber != undefined) {
                    this.invoiceNumber = data.invoiceNumber;
                }
            }
        }
        get paymentStatus() {
            return pb_1.Message.getFieldWithDefault(this, 1, PaymentStatus.PAYMENT_STATUS_UNSPECIFIED) as PaymentStatus;
        }
        set paymentStatus(value: PaymentStatus) {
            pb_1.Message.setField(this, 1, value);
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get customer() {
            return pb_1.Message.getWrapperField(this, Customer, 3) as Customer;
        }
        set customer(value: Customer) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasCustomer() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get invoiceNumber() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set invoiceNumber(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            paymentStatus?: PaymentStatus;
            id?: string;
            customer?: ReturnType<typeof Customer.prototype.toObject>;
            invoiceNumber?: string;
        }): UpdatePaymentRequest {
            const message = new UpdatePaymentRequest({});
            if (data.paymentStatus != null) {
                message.paymentStatus = data.paymentStatus;
            }
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.customer != null) {
                message.customer = Customer.fromObject(data.customer);
            }
            if (data.invoiceNumber != null) {
                message.invoiceNumber = data.invoiceNumber;
            }
            return message;
        }
        toObject() {
            const data: {
                paymentStatus?: PaymentStatus;
                id?: string;
                customer?: ReturnType<typeof Customer.prototype.toObject>;
                invoiceNumber?: string;
            } = {};
            if (this.paymentStatus != null) {
                data.paymentStatus = this.paymentStatus;
            }
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.customer != null) {
                data.customer = this.customer.toObject();
            }
            if (this.invoiceNumber != null) {
                data.invoiceNumber = this.invoiceNumber;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.paymentStatus != PaymentStatus.PAYMENT_STATUS_UNSPECIFIED)
                writer.writeEnum(1, this.paymentStatus);
            if (this.id.length)
                writer.writeString(2, this.id);
            if (this.hasCustomer)
                writer.writeMessage(3, this.customer, () => this.customer.serialize(writer));
            if (this.invoiceNumber.length)
                writer.writeString(4, this.invoiceNumber);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdatePaymentRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdatePaymentRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.paymentStatus = reader.readEnum();
                        break;
                    case 2:
                        message.id = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.customer, () => message.customer = Customer.deserialize(reader));
                        break;
                    case 4:
                        message.invoiceNumber = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdatePaymentRequest {
            return UpdatePaymentRequest.deserialize(bytes);
        }
    }
    export class UpdatePaymentResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): UpdatePaymentResponse {
            const message = new UpdatePaymentResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdatePaymentResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdatePaymentResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdatePaymentResponse {
            return UpdatePaymentResponse.deserialize(bytes);
        }
    }
    export class PIXServiceStarkbank extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            url?: string;
            clientId?: string;
            privateKey?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("url" in data && data.url != undefined) {
                    this.url = data.url;
                }
                if ("clientId" in data && data.clientId != undefined) {
                    this.clientId = data.clientId;
                }
                if ("privateKey" in data && data.privateKey != undefined) {
                    this.privateKey = data.privateKey;
                }
            }
        }
        get url() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set url(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get clientId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set clientId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get privateKey() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set privateKey(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            url?: string;
            clientId?: string;
            privateKey?: string;
        }): PIXServiceStarkbank {
            const message = new PIXServiceStarkbank({});
            if (data.url != null) {
                message.url = data.url;
            }
            if (data.clientId != null) {
                message.clientId = data.clientId;
            }
            if (data.privateKey != null) {
                message.privateKey = data.privateKey;
            }
            return message;
        }
        toObject() {
            const data: {
                url?: string;
                clientId?: string;
                privateKey?: string;
            } = {};
            if (this.url != null) {
                data.url = this.url;
            }
            if (this.clientId != null) {
                data.clientId = this.clientId;
            }
            if (this.privateKey != null) {
                data.privateKey = this.privateKey;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.url.length)
                writer.writeString(1, this.url);
            if (this.clientId.length)
                writer.writeString(2, this.clientId);
            if (this.privateKey.length)
                writer.writeString(3, this.privateKey);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PIXServiceStarkbank {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PIXServiceStarkbank();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.url = reader.readString();
                        break;
                    case 2:
                        message.clientId = reader.readString();
                        break;
                    case 3:
                        message.privateKey = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PIXServiceStarkbank {
            return PIXServiceStarkbank.deserialize(bytes);
        }
    }
    export class PIXServiceBradesco extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            url?: string;
            secretKey?: string;
            certKey?: string;
            certSecret?: string;
            keyPix?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("url" in data && data.url != undefined) {
                    this.url = data.url;
                }
                if ("secretKey" in data && data.secretKey != undefined) {
                    this.secretKey = data.secretKey;
                }
                if ("certKey" in data && data.certKey != undefined) {
                    this.certKey = data.certKey;
                }
                if ("certSecret" in data && data.certSecret != undefined) {
                    this.certSecret = data.certSecret;
                }
                if ("keyPix" in data && data.keyPix != undefined) {
                    this.keyPix = data.keyPix;
                }
            }
        }
        get url() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set url(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get secretKey() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set secretKey(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get certKey() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set certKey(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get certSecret() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set certSecret(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get keyPix() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set keyPix(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            url?: string;
            secretKey?: string;
            certKey?: string;
            certSecret?: string;
            keyPix?: string;
        }): PIXServiceBradesco {
            const message = new PIXServiceBradesco({});
            if (data.url != null) {
                message.url = data.url;
            }
            if (data.secretKey != null) {
                message.secretKey = data.secretKey;
            }
            if (data.certKey != null) {
                message.certKey = data.certKey;
            }
            if (data.certSecret != null) {
                message.certSecret = data.certSecret;
            }
            if (data.keyPix != null) {
                message.keyPix = data.keyPix;
            }
            return message;
        }
        toObject() {
            const data: {
                url?: string;
                secretKey?: string;
                certKey?: string;
                certSecret?: string;
                keyPix?: string;
            } = {};
            if (this.url != null) {
                data.url = this.url;
            }
            if (this.secretKey != null) {
                data.secretKey = this.secretKey;
            }
            if (this.certKey != null) {
                data.certKey = this.certKey;
            }
            if (this.certSecret != null) {
                data.certSecret = this.certSecret;
            }
            if (this.keyPix != null) {
                data.keyPix = this.keyPix;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.url.length)
                writer.writeString(1, this.url);
            if (this.secretKey.length)
                writer.writeString(2, this.secretKey);
            if (this.certKey.length)
                writer.writeString(3, this.certKey);
            if (this.certSecret.length)
                writer.writeString(4, this.certSecret);
            if (this.keyPix.length)
                writer.writeString(5, this.keyPix);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PIXServiceBradesco {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PIXServiceBradesco();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.url = reader.readString();
                        break;
                    case 2:
                        message.secretKey = reader.readString();
                        break;
                    case 3:
                        message.certKey = reader.readString();
                        break;
                    case 4:
                        message.certSecret = reader.readString();
                        break;
                    case 5:
                        message.keyPix = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PIXServiceBradesco {
            return PIXServiceBradesco.deserialize(bytes);
        }
    }
    export class PIXServiceConfig extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            timeout?: number;
            dueTime?: number;
            expirationTime?: number;
            type?: PixType;
            timeJobCheckStatus?: number;
            jobNumberGoRoutines?: number;
            serviceStarkbank?: PIXServiceStarkbank;
            serviceBradesco?: PIXServiceBradesco;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("timeout" in data && data.timeout != undefined) {
                    this.timeout = data.timeout;
                }
                if ("dueTime" in data && data.dueTime != undefined) {
                    this.dueTime = data.dueTime;
                }
                if ("expirationTime" in data && data.expirationTime != undefined) {
                    this.expirationTime = data.expirationTime;
                }
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
                if ("timeJobCheckStatus" in data && data.timeJobCheckStatus != undefined) {
                    this.timeJobCheckStatus = data.timeJobCheckStatus;
                }
                if ("jobNumberGoRoutines" in data && data.jobNumberGoRoutines != undefined) {
                    this.jobNumberGoRoutines = data.jobNumberGoRoutines;
                }
                if ("serviceStarkbank" in data && data.serviceStarkbank != undefined) {
                    this.serviceStarkbank = data.serviceStarkbank;
                }
                if ("serviceBradesco" in data && data.serviceBradesco != undefined) {
                    this.serviceBradesco = data.serviceBradesco;
                }
            }
        }
        get timeout() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set timeout(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get dueTime() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set dueTime(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get expirationTime() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set expirationTime(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 4, PixType.PIX_TYPE_UNSPECIFIED) as PixType;
        }
        set type(value: PixType) {
            pb_1.Message.setField(this, 4, value);
        }
        get timeJobCheckStatus() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set timeJobCheckStatus(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get jobNumberGoRoutines() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set jobNumberGoRoutines(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get serviceStarkbank() {
            return pb_1.Message.getWrapperField(this, PIXServiceStarkbank, 7) as PIXServiceStarkbank;
        }
        set serviceStarkbank(value: PIXServiceStarkbank) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get hasServiceStarkbank() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get serviceBradesco() {
            return pb_1.Message.getWrapperField(this, PIXServiceBradesco, 8) as PIXServiceBradesco;
        }
        set serviceBradesco(value: PIXServiceBradesco) {
            pb_1.Message.setWrapperField(this, 8, value);
        }
        get hasServiceBradesco() {
            return pb_1.Message.getField(this, 8) != null;
        }
        static fromObject(data: {
            timeout?: number;
            dueTime?: number;
            expirationTime?: number;
            type?: PixType;
            timeJobCheckStatus?: number;
            jobNumberGoRoutines?: number;
            serviceStarkbank?: ReturnType<typeof PIXServiceStarkbank.prototype.toObject>;
            serviceBradesco?: ReturnType<typeof PIXServiceBradesco.prototype.toObject>;
        }): PIXServiceConfig {
            const message = new PIXServiceConfig({});
            if (data.timeout != null) {
                message.timeout = data.timeout;
            }
            if (data.dueTime != null) {
                message.dueTime = data.dueTime;
            }
            if (data.expirationTime != null) {
                message.expirationTime = data.expirationTime;
            }
            if (data.type != null) {
                message.type = data.type;
            }
            if (data.timeJobCheckStatus != null) {
                message.timeJobCheckStatus = data.timeJobCheckStatus;
            }
            if (data.jobNumberGoRoutines != null) {
                message.jobNumberGoRoutines = data.jobNumberGoRoutines;
            }
            if (data.serviceStarkbank != null) {
                message.serviceStarkbank = PIXServiceStarkbank.fromObject(data.serviceStarkbank);
            }
            if (data.serviceBradesco != null) {
                message.serviceBradesco = PIXServiceBradesco.fromObject(data.serviceBradesco);
            }
            return message;
        }
        toObject() {
            const data: {
                timeout?: number;
                dueTime?: number;
                expirationTime?: number;
                type?: PixType;
                timeJobCheckStatus?: number;
                jobNumberGoRoutines?: number;
                serviceStarkbank?: ReturnType<typeof PIXServiceStarkbank.prototype.toObject>;
                serviceBradesco?: ReturnType<typeof PIXServiceBradesco.prototype.toObject>;
            } = {};
            if (this.timeout != null) {
                data.timeout = this.timeout;
            }
            if (this.dueTime != null) {
                data.dueTime = this.dueTime;
            }
            if (this.expirationTime != null) {
                data.expirationTime = this.expirationTime;
            }
            if (this.type != null) {
                data.type = this.type;
            }
            if (this.timeJobCheckStatus != null) {
                data.timeJobCheckStatus = this.timeJobCheckStatus;
            }
            if (this.jobNumberGoRoutines != null) {
                data.jobNumberGoRoutines = this.jobNumberGoRoutines;
            }
            if (this.serviceStarkbank != null) {
                data.serviceStarkbank = this.serviceStarkbank.toObject();
            }
            if (this.serviceBradesco != null) {
                data.serviceBradesco = this.serviceBradesco.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.timeout != 0)
                writer.writeInt32(1, this.timeout);
            if (this.dueTime != 0)
                writer.writeInt32(2, this.dueTime);
            if (this.expirationTime != 0)
                writer.writeInt32(3, this.expirationTime);
            if (this.type != PixType.PIX_TYPE_UNSPECIFIED)
                writer.writeEnum(4, this.type);
            if (this.timeJobCheckStatus != 0)
                writer.writeInt32(5, this.timeJobCheckStatus);
            if (this.jobNumberGoRoutines != 0)
                writer.writeInt32(6, this.jobNumberGoRoutines);
            if (this.hasServiceStarkbank)
                writer.writeMessage(7, this.serviceStarkbank, () => this.serviceStarkbank.serialize(writer));
            if (this.hasServiceBradesco)
                writer.writeMessage(8, this.serviceBradesco, () => this.serviceBradesco.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PIXServiceConfig {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PIXServiceConfig();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.timeout = reader.readInt32();
                        break;
                    case 2:
                        message.dueTime = reader.readInt32();
                        break;
                    case 3:
                        message.expirationTime = reader.readInt32();
                        break;
                    case 4:
                        message.type = reader.readEnum();
                        break;
                    case 5:
                        message.timeJobCheckStatus = reader.readInt32();
                        break;
                    case 6:
                        message.jobNumberGoRoutines = reader.readInt32();
                        break;
                    case 7:
                        reader.readMessage(message.serviceStarkbank, () => message.serviceStarkbank = PIXServiceStarkbank.deserialize(reader));
                        break;
                    case 8:
                        reader.readMessage(message.serviceBradesco, () => message.serviceBradesco = PIXServiceBradesco.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PIXServiceConfig {
            return PIXServiceConfig.deserialize(bytes);
        }
    }
    export class TTLConfig extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            payment?: number;
            cachePayment?: number;
            lockPayment?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("payment" in data && data.payment != undefined) {
                    this.payment = data.payment;
                }
                if ("cachePayment" in data && data.cachePayment != undefined) {
                    this.cachePayment = data.cachePayment;
                }
                if ("lockPayment" in data && data.lockPayment != undefined) {
                    this.lockPayment = data.lockPayment;
                }
            }
        }
        get payment() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set payment(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get cachePayment() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set cachePayment(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get lockPayment() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set lockPayment(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            payment?: number;
            cachePayment?: number;
            lockPayment?: number;
        }): TTLConfig {
            const message = new TTLConfig({});
            if (data.payment != null) {
                message.payment = data.payment;
            }
            if (data.cachePayment != null) {
                message.cachePayment = data.cachePayment;
            }
            if (data.lockPayment != null) {
                message.lockPayment = data.lockPayment;
            }
            return message;
        }
        toObject() {
            const data: {
                payment?: number;
                cachePayment?: number;
                lockPayment?: number;
            } = {};
            if (this.payment != null) {
                data.payment = this.payment;
            }
            if (this.cachePayment != null) {
                data.cachePayment = this.cachePayment;
            }
            if (this.lockPayment != null) {
                data.lockPayment = this.lockPayment;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.payment != 0)
                writer.writeInt32(1, this.payment);
            if (this.cachePayment != 0)
                writer.writeInt32(2, this.cachePayment);
            if (this.lockPayment != 0)
                writer.writeInt32(3, this.lockPayment);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): TTLConfig {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TTLConfig();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.payment = reader.readInt32();
                        break;
                    case 2:
                        message.cachePayment = reader.readInt32();
                        break;
                    case 3:
                        message.lockPayment = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): TTLConfig {
            return TTLConfig.deserialize(bytes);
        }
    }
    export class CircuitBreakerConfig extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            checkPaymentDuplicate?: CheckPaymentDuplicateConfig;
            generatePix?: GeneratePixConfig;
            createPayment?: CreatePaymentConfig;
            startPaymentWorkflow?: StartPaymentWorkflowConfig;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("checkPaymentDuplicate" in data && data.checkPaymentDuplicate != undefined) {
                    this.checkPaymentDuplicate = data.checkPaymentDuplicate;
                }
                if ("generatePix" in data && data.generatePix != undefined) {
                    this.generatePix = data.generatePix;
                }
                if ("createPayment" in data && data.createPayment != undefined) {
                    this.createPayment = data.createPayment;
                }
                if ("startPaymentWorkflow" in data && data.startPaymentWorkflow != undefined) {
                    this.startPaymentWorkflow = data.startPaymentWorkflow;
                }
            }
        }
        get checkPaymentDuplicate() {
            return pb_1.Message.getWrapperField(this, CheckPaymentDuplicateConfig, 1) as CheckPaymentDuplicateConfig;
        }
        set checkPaymentDuplicate(value: CheckPaymentDuplicateConfig) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasCheckPaymentDuplicate() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get generatePix() {
            return pb_1.Message.getWrapperField(this, GeneratePixConfig, 2) as GeneratePixConfig;
        }
        set generatePix(value: GeneratePixConfig) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasGeneratePix() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get createPayment() {
            return pb_1.Message.getWrapperField(this, CreatePaymentConfig, 3) as CreatePaymentConfig;
        }
        set createPayment(value: CreatePaymentConfig) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasCreatePayment() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get startPaymentWorkflow() {
            return pb_1.Message.getWrapperField(this, StartPaymentWorkflowConfig, 4) as StartPaymentWorkflowConfig;
        }
        set startPaymentWorkflow(value: StartPaymentWorkflowConfig) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasStartPaymentWorkflow() {
            return pb_1.Message.getField(this, 4) != null;
        }
        static fromObject(data: {
            checkPaymentDuplicate?: ReturnType<typeof CheckPaymentDuplicateConfig.prototype.toObject>;
            generatePix?: ReturnType<typeof GeneratePixConfig.prototype.toObject>;
            createPayment?: ReturnType<typeof CreatePaymentConfig.prototype.toObject>;
            startPaymentWorkflow?: ReturnType<typeof StartPaymentWorkflowConfig.prototype.toObject>;
        }): CircuitBreakerConfig {
            const message = new CircuitBreakerConfig({});
            if (data.checkPaymentDuplicate != null) {
                message.checkPaymentDuplicate = CheckPaymentDuplicateConfig.fromObject(data.checkPaymentDuplicate);
            }
            if (data.generatePix != null) {
                message.generatePix = GeneratePixConfig.fromObject(data.generatePix);
            }
            if (data.createPayment != null) {
                message.createPayment = CreatePaymentConfig.fromObject(data.createPayment);
            }
            if (data.startPaymentWorkflow != null) {
                message.startPaymentWorkflow = StartPaymentWorkflowConfig.fromObject(data.startPaymentWorkflow);
            }
            return message;
        }
        toObject() {
            const data: {
                checkPaymentDuplicate?: ReturnType<typeof CheckPaymentDuplicateConfig.prototype.toObject>;
                generatePix?: ReturnType<typeof GeneratePixConfig.prototype.toObject>;
                createPayment?: ReturnType<typeof CreatePaymentConfig.prototype.toObject>;
                startPaymentWorkflow?: ReturnType<typeof StartPaymentWorkflowConfig.prototype.toObject>;
            } = {};
            if (this.checkPaymentDuplicate != null) {
                data.checkPaymentDuplicate = this.checkPaymentDuplicate.toObject();
            }
            if (this.generatePix != null) {
                data.generatePix = this.generatePix.toObject();
            }
            if (this.createPayment != null) {
                data.createPayment = this.createPayment.toObject();
            }
            if (this.startPaymentWorkflow != null) {
                data.startPaymentWorkflow = this.startPaymentWorkflow.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasCheckPaymentDuplicate)
                writer.writeMessage(1, this.checkPaymentDuplicate, () => this.checkPaymentDuplicate.serialize(writer));
            if (this.hasGeneratePix)
                writer.writeMessage(2, this.generatePix, () => this.generatePix.serialize(writer));
            if (this.hasCreatePayment)
                writer.writeMessage(3, this.createPayment, () => this.createPayment.serialize(writer));
            if (this.hasStartPaymentWorkflow)
                writer.writeMessage(4, this.startPaymentWorkflow, () => this.startPaymentWorkflow.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CircuitBreakerConfig {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CircuitBreakerConfig();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.checkPaymentDuplicate, () => message.checkPaymentDuplicate = CheckPaymentDuplicateConfig.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.generatePix, () => message.generatePix = GeneratePixConfig.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message.createPayment, () => message.createPayment = CreatePaymentConfig.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.startPaymentWorkflow, () => message.startPaymentWorkflow = StartPaymentWorkflowConfig.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CircuitBreakerConfig {
            return CircuitBreakerConfig.deserialize(bytes);
        }
    }
    export class CheckPaymentDuplicateConfig extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            timeout?: number;
            waitBase?: number;
            times?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("timeout" in data && data.timeout != undefined) {
                    this.timeout = data.timeout;
                }
                if ("waitBase" in data && data.waitBase != undefined) {
                    this.waitBase = data.waitBase;
                }
                if ("times" in data && data.times != undefined) {
                    this.times = data.times;
                }
            }
        }
        get timeout() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set timeout(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get waitBase() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set waitBase(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get times() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set times(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            timeout?: number;
            waitBase?: number;
            times?: number;
        }): CheckPaymentDuplicateConfig {
            const message = new CheckPaymentDuplicateConfig({});
            if (data.timeout != null) {
                message.timeout = data.timeout;
            }
            if (data.waitBase != null) {
                message.waitBase = data.waitBase;
            }
            if (data.times != null) {
                message.times = data.times;
            }
            return message;
        }
        toObject() {
            const data: {
                timeout?: number;
                waitBase?: number;
                times?: number;
            } = {};
            if (this.timeout != null) {
                data.timeout = this.timeout;
            }
            if (this.waitBase != null) {
                data.waitBase = this.waitBase;
            }
            if (this.times != null) {
                data.times = this.times;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.timeout != 0)
                writer.writeInt32(1, this.timeout);
            if (this.waitBase != 0)
                writer.writeInt32(2, this.waitBase);
            if (this.times != 0)
                writer.writeInt32(3, this.times);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CheckPaymentDuplicateConfig {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CheckPaymentDuplicateConfig();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.timeout = reader.readInt32();
                        break;
                    case 2:
                        message.waitBase = reader.readInt32();
                        break;
                    case 3:
                        message.times = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CheckPaymentDuplicateConfig {
            return CheckPaymentDuplicateConfig.deserialize(bytes);
        }
    }
    export class GeneratePixConfig extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            timeout?: number;
            waitBase?: number;
            times?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("timeout" in data && data.timeout != undefined) {
                    this.timeout = data.timeout;
                }
                if ("waitBase" in data && data.waitBase != undefined) {
                    this.waitBase = data.waitBase;
                }
                if ("times" in data && data.times != undefined) {
                    this.times = data.times;
                }
            }
        }
        get timeout() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set timeout(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get waitBase() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set waitBase(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get times() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set times(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            timeout?: number;
            waitBase?: number;
            times?: number;
        }): GeneratePixConfig {
            const message = new GeneratePixConfig({});
            if (data.timeout != null) {
                message.timeout = data.timeout;
            }
            if (data.waitBase != null) {
                message.waitBase = data.waitBase;
            }
            if (data.times != null) {
                message.times = data.times;
            }
            return message;
        }
        toObject() {
            const data: {
                timeout?: number;
                waitBase?: number;
                times?: number;
            } = {};
            if (this.timeout != null) {
                data.timeout = this.timeout;
            }
            if (this.waitBase != null) {
                data.waitBase = this.waitBase;
            }
            if (this.times != null) {
                data.times = this.times;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.timeout != 0)
                writer.writeInt32(1, this.timeout);
            if (this.waitBase != 0)
                writer.writeInt32(2, this.waitBase);
            if (this.times != 0)
                writer.writeInt32(3, this.times);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GeneratePixConfig {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GeneratePixConfig();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.timeout = reader.readInt32();
                        break;
                    case 2:
                        message.waitBase = reader.readInt32();
                        break;
                    case 3:
                        message.times = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GeneratePixConfig {
            return GeneratePixConfig.deserialize(bytes);
        }
    }
    export class CreatePaymentConfig extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            timeout?: number;
            waitBase?: number;
            times?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("timeout" in data && data.timeout != undefined) {
                    this.timeout = data.timeout;
                }
                if ("waitBase" in data && data.waitBase != undefined) {
                    this.waitBase = data.waitBase;
                }
                if ("times" in data && data.times != undefined) {
                    this.times = data.times;
                }
            }
        }
        get timeout() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set timeout(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get waitBase() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set waitBase(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get times() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set times(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            timeout?: number;
            waitBase?: number;
            times?: number;
        }): CreatePaymentConfig {
            const message = new CreatePaymentConfig({});
            if (data.timeout != null) {
                message.timeout = data.timeout;
            }
            if (data.waitBase != null) {
                message.waitBase = data.waitBase;
            }
            if (data.times != null) {
                message.times = data.times;
            }
            return message;
        }
        toObject() {
            const data: {
                timeout?: number;
                waitBase?: number;
                times?: number;
            } = {};
            if (this.timeout != null) {
                data.timeout = this.timeout;
            }
            if (this.waitBase != null) {
                data.waitBase = this.waitBase;
            }
            if (this.times != null) {
                data.times = this.times;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.timeout != 0)
                writer.writeInt32(1, this.timeout);
            if (this.waitBase != 0)
                writer.writeInt32(2, this.waitBase);
            if (this.times != 0)
                writer.writeInt32(3, this.times);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreatePaymentConfig {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreatePaymentConfig();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.timeout = reader.readInt32();
                        break;
                    case 2:
                        message.waitBase = reader.readInt32();
                        break;
                    case 3:
                        message.times = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreatePaymentConfig {
            return CreatePaymentConfig.deserialize(bytes);
        }
    }
    export class StartPaymentWorkflowConfig extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            timeout?: number;
            waitBase?: number;
            times?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("timeout" in data && data.timeout != undefined) {
                    this.timeout = data.timeout;
                }
                if ("waitBase" in data && data.waitBase != undefined) {
                    this.waitBase = data.waitBase;
                }
                if ("times" in data && data.times != undefined) {
                    this.times = data.times;
                }
            }
        }
        get timeout() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set timeout(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get waitBase() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set waitBase(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get times() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set times(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            timeout?: number;
            waitBase?: number;
            times?: number;
        }): StartPaymentWorkflowConfig {
            const message = new StartPaymentWorkflowConfig({});
            if (data.timeout != null) {
                message.timeout = data.timeout;
            }
            if (data.waitBase != null) {
                message.waitBase = data.waitBase;
            }
            if (data.times != null) {
                message.times = data.times;
            }
            return message;
        }
        toObject() {
            const data: {
                timeout?: number;
                waitBase?: number;
                times?: number;
            } = {};
            if (this.timeout != null) {
                data.timeout = this.timeout;
            }
            if (this.waitBase != null) {
                data.waitBase = this.waitBase;
            }
            if (this.times != null) {
                data.times = this.times;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.timeout != 0)
                writer.writeInt32(1, this.timeout);
            if (this.waitBase != 0)
                writer.writeInt32(2, this.waitBase);
            if (this.times != 0)
                writer.writeInt32(3, this.times);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StartPaymentWorkflowConfig {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StartPaymentWorkflowConfig();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.timeout = reader.readInt32();
                        break;
                    case 2:
                        message.waitBase = reader.readInt32();
                        break;
                    case 3:
                        message.times = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): StartPaymentWorkflowConfig {
            return StartPaymentWorkflowConfig.deserialize(bytes);
        }
    }
    export class LoggerConfig extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            loggerType?: string;
            loggerLokiUrl?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("loggerType" in data && data.loggerType != undefined) {
                    this.loggerType = data.loggerType;
                }
                if ("loggerLokiUrl" in data && data.loggerLokiUrl != undefined) {
                    this.loggerLokiUrl = data.loggerLokiUrl;
                }
            }
        }
        get loggerType() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set loggerType(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get loggerLokiUrl() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set loggerLokiUrl(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            loggerType?: string;
            loggerLokiUrl?: string;
        }): LoggerConfig {
            const message = new LoggerConfig({});
            if (data.loggerType != null) {
                message.loggerType = data.loggerType;
            }
            if (data.loggerLokiUrl != null) {
                message.loggerLokiUrl = data.loggerLokiUrl;
            }
            return message;
        }
        toObject() {
            const data: {
                loggerType?: string;
                loggerLokiUrl?: string;
            } = {};
            if (this.loggerType != null) {
                data.loggerType = this.loggerType;
            }
            if (this.loggerLokiUrl != null) {
                data.loggerLokiUrl = this.loggerLokiUrl;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.loggerType.length)
                writer.writeString(1, this.loggerType);
            if (this.loggerLokiUrl.length)
                writer.writeString(2, this.loggerLokiUrl);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): LoggerConfig {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LoggerConfig();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.loggerType = reader.readString();
                        break;
                    case 2:
                        message.loggerLokiUrl = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): LoggerConfig {
            return LoggerConfig.deserialize(bytes);
        }
    }
    export class UpdateConfigRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            pix?: PIXServiceConfig;
            ttlConfig?: TTLConfig;
            circuitBreakerConfig?: CircuitBreakerConfig;
            loggerConfig?: LoggerConfig;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("pix" in data && data.pix != undefined) {
                    this.pix = data.pix;
                }
                if ("ttlConfig" in data && data.ttlConfig != undefined) {
                    this.ttlConfig = data.ttlConfig;
                }
                if ("circuitBreakerConfig" in data && data.circuitBreakerConfig != undefined) {
                    this.circuitBreakerConfig = data.circuitBreakerConfig;
                }
                if ("loggerConfig" in data && data.loggerConfig != undefined) {
                    this.loggerConfig = data.loggerConfig;
                }
            }
        }
        get pix() {
            return pb_1.Message.getWrapperField(this, PIXServiceConfig, 2) as PIXServiceConfig;
        }
        set pix(value: PIXServiceConfig) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasPix() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get ttlConfig() {
            return pb_1.Message.getWrapperField(this, TTLConfig, 8) as TTLConfig;
        }
        set ttlConfig(value: TTLConfig) {
            pb_1.Message.setWrapperField(this, 8, value);
        }
        get hasTtlConfig() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get circuitBreakerConfig() {
            return pb_1.Message.getWrapperField(this, CircuitBreakerConfig, 9) as CircuitBreakerConfig;
        }
        set circuitBreakerConfig(value: CircuitBreakerConfig) {
            pb_1.Message.setWrapperField(this, 9, value);
        }
        get hasCircuitBreakerConfig() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get loggerConfig() {
            return pb_1.Message.getWrapperField(this, LoggerConfig, 10) as LoggerConfig;
        }
        set loggerConfig(value: LoggerConfig) {
            pb_1.Message.setWrapperField(this, 10, value);
        }
        get hasLoggerConfig() {
            return pb_1.Message.getField(this, 10) != null;
        }
        static fromObject(data: {
            pix?: ReturnType<typeof PIXServiceConfig.prototype.toObject>;
            ttlConfig?: ReturnType<typeof TTLConfig.prototype.toObject>;
            circuitBreakerConfig?: ReturnType<typeof CircuitBreakerConfig.prototype.toObject>;
            loggerConfig?: ReturnType<typeof LoggerConfig.prototype.toObject>;
        }): UpdateConfigRequest {
            const message = new UpdateConfigRequest({});
            if (data.pix != null) {
                message.pix = PIXServiceConfig.fromObject(data.pix);
            }
            if (data.ttlConfig != null) {
                message.ttlConfig = TTLConfig.fromObject(data.ttlConfig);
            }
            if (data.circuitBreakerConfig != null) {
                message.circuitBreakerConfig = CircuitBreakerConfig.fromObject(data.circuitBreakerConfig);
            }
            if (data.loggerConfig != null) {
                message.loggerConfig = LoggerConfig.fromObject(data.loggerConfig);
            }
            return message;
        }
        toObject() {
            const data: {
                pix?: ReturnType<typeof PIXServiceConfig.prototype.toObject>;
                ttlConfig?: ReturnType<typeof TTLConfig.prototype.toObject>;
                circuitBreakerConfig?: ReturnType<typeof CircuitBreakerConfig.prototype.toObject>;
                loggerConfig?: ReturnType<typeof LoggerConfig.prototype.toObject>;
            } = {};
            if (this.pix != null) {
                data.pix = this.pix.toObject();
            }
            if (this.ttlConfig != null) {
                data.ttlConfig = this.ttlConfig.toObject();
            }
            if (this.circuitBreakerConfig != null) {
                data.circuitBreakerConfig = this.circuitBreakerConfig.toObject();
            }
            if (this.loggerConfig != null) {
                data.loggerConfig = this.loggerConfig.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPix)
                writer.writeMessage(2, this.pix, () => this.pix.serialize(writer));
            if (this.hasTtlConfig)
                writer.writeMessage(8, this.ttlConfig, () => this.ttlConfig.serialize(writer));
            if (this.hasCircuitBreakerConfig)
                writer.writeMessage(9, this.circuitBreakerConfig, () => this.circuitBreakerConfig.serialize(writer));
            if (this.hasLoggerConfig)
                writer.writeMessage(10, this.loggerConfig, () => this.loggerConfig.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateConfigRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateConfigRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 2:
                        reader.readMessage(message.pix, () => message.pix = PIXServiceConfig.deserialize(reader));
                        break;
                    case 8:
                        reader.readMessage(message.ttlConfig, () => message.ttlConfig = TTLConfig.deserialize(reader));
                        break;
                    case 9:
                        reader.readMessage(message.circuitBreakerConfig, () => message.circuitBreakerConfig = CircuitBreakerConfig.deserialize(reader));
                        break;
                    case 10:
                        reader.readMessage(message.loggerConfig, () => message.loggerConfig = LoggerConfig.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateConfigRequest {
            return UpdateConfigRequest.deserialize(bytes);
        }
    }
    export class UpdateConfigResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): UpdateConfigResponse {
            const message = new UpdateConfigResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateConfigResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateConfigResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateConfigResponse {
            return UpdateConfigResponse.deserialize(bytes);
        }
    }
    export class GetConfigRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): GetConfigRequest {
            const message = new GetConfigRequest({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetConfigRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetConfigRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetConfigRequest {
            return GetConfigRequest.deserialize(bytes);
        }
    }
    export class GetConfigResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            pix?: PIXServiceConfig;
            ttlConfig?: TTLConfig;
            circuitBreakerConfig?: CircuitBreakerConfig;
            loggerConfig?: LoggerConfig;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("pix" in data && data.pix != undefined) {
                    this.pix = data.pix;
                }
                if ("ttlConfig" in data && data.ttlConfig != undefined) {
                    this.ttlConfig = data.ttlConfig;
                }
                if ("circuitBreakerConfig" in data && data.circuitBreakerConfig != undefined) {
                    this.circuitBreakerConfig = data.circuitBreakerConfig;
                }
                if ("loggerConfig" in data && data.loggerConfig != undefined) {
                    this.loggerConfig = data.loggerConfig;
                }
            }
        }
        get pix() {
            return pb_1.Message.getWrapperField(this, PIXServiceConfig, 2) as PIXServiceConfig;
        }
        set pix(value: PIXServiceConfig) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasPix() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get ttlConfig() {
            return pb_1.Message.getWrapperField(this, TTLConfig, 8) as TTLConfig;
        }
        set ttlConfig(value: TTLConfig) {
            pb_1.Message.setWrapperField(this, 8, value);
        }
        get hasTtlConfig() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get circuitBreakerConfig() {
            return pb_1.Message.getWrapperField(this, CircuitBreakerConfig, 9) as CircuitBreakerConfig;
        }
        set circuitBreakerConfig(value: CircuitBreakerConfig) {
            pb_1.Message.setWrapperField(this, 9, value);
        }
        get hasCircuitBreakerConfig() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get loggerConfig() {
            return pb_1.Message.getWrapperField(this, LoggerConfig, 10) as LoggerConfig;
        }
        set loggerConfig(value: LoggerConfig) {
            pb_1.Message.setWrapperField(this, 10, value);
        }
        get hasLoggerConfig() {
            return pb_1.Message.getField(this, 10) != null;
        }
        static fromObject(data: {
            pix?: ReturnType<typeof PIXServiceConfig.prototype.toObject>;
            ttlConfig?: ReturnType<typeof TTLConfig.prototype.toObject>;
            circuitBreakerConfig?: ReturnType<typeof CircuitBreakerConfig.prototype.toObject>;
            loggerConfig?: ReturnType<typeof LoggerConfig.prototype.toObject>;
        }): GetConfigResponse {
            const message = new GetConfigResponse({});
            if (data.pix != null) {
                message.pix = PIXServiceConfig.fromObject(data.pix);
            }
            if (data.ttlConfig != null) {
                message.ttlConfig = TTLConfig.fromObject(data.ttlConfig);
            }
            if (data.circuitBreakerConfig != null) {
                message.circuitBreakerConfig = CircuitBreakerConfig.fromObject(data.circuitBreakerConfig);
            }
            if (data.loggerConfig != null) {
                message.loggerConfig = LoggerConfig.fromObject(data.loggerConfig);
            }
            return message;
        }
        toObject() {
            const data: {
                pix?: ReturnType<typeof PIXServiceConfig.prototype.toObject>;
                ttlConfig?: ReturnType<typeof TTLConfig.prototype.toObject>;
                circuitBreakerConfig?: ReturnType<typeof CircuitBreakerConfig.prototype.toObject>;
                loggerConfig?: ReturnType<typeof LoggerConfig.prototype.toObject>;
            } = {};
            if (this.pix != null) {
                data.pix = this.pix.toObject();
            }
            if (this.ttlConfig != null) {
                data.ttlConfig = this.ttlConfig.toObject();
            }
            if (this.circuitBreakerConfig != null) {
                data.circuitBreakerConfig = this.circuitBreakerConfig.toObject();
            }
            if (this.loggerConfig != null) {
                data.loggerConfig = this.loggerConfig.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPix)
                writer.writeMessage(2, this.pix, () => this.pix.serialize(writer));
            if (this.hasTtlConfig)
                writer.writeMessage(8, this.ttlConfig, () => this.ttlConfig.serialize(writer));
            if (this.hasCircuitBreakerConfig)
                writer.writeMessage(9, this.circuitBreakerConfig, () => this.circuitBreakerConfig.serialize(writer));
            if (this.hasLoggerConfig)
                writer.writeMessage(10, this.loggerConfig, () => this.loggerConfig.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetConfigResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetConfigResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 2:
                        reader.readMessage(message.pix, () => message.pix = PIXServiceConfig.deserialize(reader));
                        break;
                    case 8:
                        reader.readMessage(message.ttlConfig, () => message.ttlConfig = TTLConfig.deserialize(reader));
                        break;
                    case 9:
                        reader.readMessage(message.circuitBreakerConfig, () => message.circuitBreakerConfig = CircuitBreakerConfig.deserialize(reader));
                        break;
                    case 10:
                        reader.readMessage(message.loggerConfig, () => message.loggerConfig = LoggerConfig.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetConfigResponse {
            return GetConfigResponse.deserialize(bytes);
        }
    }
    export class Money extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            amount?: number;
            currency?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("currency" in data && data.currency != undefined) {
                    this.currency = data.currency;
                }
            }
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get currency() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set currency(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            amount?: number;
            currency?: string;
        }): Money {
            const message = new Money({});
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.currency != null) {
                message.currency = data.currency;
            }
            return message;
        }
        toObject() {
            const data: {
                amount?: number;
                currency?: string;
            } = {};
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.currency != null) {
                data.currency = this.currency;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.amount != 0)
                writer.writeInt64(1, this.amount);
            if (this.currency.length)
                writer.writeString(2, this.currency);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Money {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Money();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.amount = reader.readInt64();
                        break;
                    case 2:
                        message.currency = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Money {
            return Money.deserialize(bytes);
        }
    }
    export class ProcessPaymentRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[10]];
        constructor(data?: any[] | ({
            organizationId?: string;
            workspaceId?: string;
            externalId?: string;
            amount?: Money;
            metadata?: Map<string, string>;
            customerInfo?: CustomerInfo;
            paymentType?: PaymentType;
            originService?: string;
            products?: Product[];
            expireIn?: number;
        } & (({
            nfNumber?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [9], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("externalId" in data && data.externalId != undefined) {
                    this.externalId = data.externalId;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("customerInfo" in data && data.customerInfo != undefined) {
                    this.customerInfo = data.customerInfo;
                }
                if ("paymentType" in data && data.paymentType != undefined) {
                    this.paymentType = data.paymentType;
                }
                if ("originService" in data && data.originService != undefined) {
                    this.originService = data.originService;
                }
                if ("products" in data && data.products != undefined) {
                    this.products = data.products;
                }
                if ("nfNumber" in data && data.nfNumber != undefined) {
                    this.nfNumber = data.nfNumber;
                }
                if ("expireIn" in data && data.expireIn != undefined) {
                    this.expireIn = data.expireIn;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get externalId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set externalId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get amount() {
            return pb_1.Message.getWrapperField(this, Money, 4) as Money;
        }
        set amount(value: Money) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasAmount() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get metadata() {
            return pb_1.Message.getField(this, 5) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 5, value as any);
        }
        get customerInfo() {
            return pb_1.Message.getWrapperField(this, CustomerInfo, 6) as CustomerInfo;
        }
        set customerInfo(value: CustomerInfo) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get hasCustomerInfo() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get paymentType() {
            return pb_1.Message.getWrapperField(this, PaymentType, 7) as PaymentType;
        }
        set paymentType(value: PaymentType) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get hasPaymentType() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get originService() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set originService(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        get products() {
            return pb_1.Message.getRepeatedWrapperField(this, Product, 9) as Product[];
        }
        set products(value: Product[]) {
            pb_1.Message.setRepeatedWrapperField(this, 9, value);
        }
        get nfNumber() {
            return pb_1.Message.getFieldWithDefault(this, 10, "") as string;
        }
        set nfNumber(value: string) {
            pb_1.Message.setOneofField(this, 10, this.#one_of_decls[0], value);
        }
        get hasNfNumber() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get expireIn() {
            return pb_1.Message.getFieldWithDefault(this, 11, 0) as number;
        }
        set expireIn(value: number) {
            pb_1.Message.setField(this, 11, value);
        }
        get _nf_number() {
            const cases: {
                [index: number]: "none" | "nfNumber";
            } = {
                0: "none",
                10: "nfNumber"
            };
            return cases[pb_1.Message.computeOneofCase(this, [10])];
        }
        static fromObject(data: {
            organizationId?: string;
            workspaceId?: string;
            externalId?: string;
            amount?: ReturnType<typeof Money.prototype.toObject>;
            metadata?: {
                [key: string]: string;
            };
            customerInfo?: ReturnType<typeof CustomerInfo.prototype.toObject>;
            paymentType?: ReturnType<typeof PaymentType.prototype.toObject>;
            originService?: string;
            products?: ReturnType<typeof Product.prototype.toObject>[];
            nfNumber?: string;
            expireIn?: number;
        }): ProcessPaymentRequest {
            const message = new ProcessPaymentRequest({});
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.externalId != null) {
                message.externalId = data.externalId;
            }
            if (data.amount != null) {
                message.amount = Money.fromObject(data.amount);
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.customerInfo != null) {
                message.customerInfo = CustomerInfo.fromObject(data.customerInfo);
            }
            if (data.paymentType != null) {
                message.paymentType = PaymentType.fromObject(data.paymentType);
            }
            if (data.originService != null) {
                message.originService = data.originService;
            }
            if (data.products != null) {
                message.products = data.products.map(item => Product.fromObject(item));
            }
            if (data.nfNumber != null) {
                message.nfNumber = data.nfNumber;
            }
            if (data.expireIn != null) {
                message.expireIn = data.expireIn;
            }
            return message;
        }
        toObject() {
            const data: {
                organizationId?: string;
                workspaceId?: string;
                externalId?: string;
                amount?: ReturnType<typeof Money.prototype.toObject>;
                metadata?: {
                    [key: string]: string;
                };
                customerInfo?: ReturnType<typeof CustomerInfo.prototype.toObject>;
                paymentType?: ReturnType<typeof PaymentType.prototype.toObject>;
                originService?: string;
                products?: ReturnType<typeof Product.prototype.toObject>[];
                nfNumber?: string;
                expireIn?: number;
            } = {};
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.externalId != null) {
                data.externalId = this.externalId;
            }
            if (this.amount != null) {
                data.amount = this.amount.toObject();
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.customerInfo != null) {
                data.customerInfo = this.customerInfo.toObject();
            }
            if (this.paymentType != null) {
                data.paymentType = this.paymentType.toObject();
            }
            if (this.originService != null) {
                data.originService = this.originService;
            }
            if (this.products != null) {
                data.products = this.products.map((item: Product) => item.toObject());
            }
            if (this.nfNumber != null) {
                data.nfNumber = this.nfNumber;
            }
            if (this.expireIn != null) {
                data.expireIn = this.expireIn;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.organizationId.length)
                writer.writeString(1, this.organizationId);
            if (this.workspaceId.length)
                writer.writeString(2, this.workspaceId);
            if (this.externalId.length)
                writer.writeString(3, this.externalId);
            if (this.hasAmount)
                writer.writeMessage(4, this.amount, () => this.amount.serialize(writer));
            for (const [key, value] of this.metadata) {
                writer.writeMessage(5, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.hasCustomerInfo)
                writer.writeMessage(6, this.customerInfo, () => this.customerInfo.serialize(writer));
            if (this.hasPaymentType)
                writer.writeMessage(7, this.paymentType, () => this.paymentType.serialize(writer));
            if (this.originService.length)
                writer.writeString(8, this.originService);
            if (this.products.length)
                writer.writeRepeatedMessage(9, this.products, (item: Product) => item.serialize(writer));
            if (this.hasNfNumber)
                writer.writeString(10, this.nfNumber);
            if (this.expireIn != 0)
                writer.writeInt64(11, this.expireIn);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ProcessPaymentRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ProcessPaymentRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.organizationId = reader.readString();
                        break;
                    case 2:
                        message.workspaceId = reader.readString();
                        break;
                    case 3:
                        message.externalId = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.amount, () => message.amount = Money.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 6:
                        reader.readMessage(message.customerInfo, () => message.customerInfo = CustomerInfo.deserialize(reader));
                        break;
                    case 7:
                        reader.readMessage(message.paymentType, () => message.paymentType = PaymentType.deserialize(reader));
                        break;
                    case 8:
                        message.originService = reader.readString();
                        break;
                    case 9:
                        reader.readMessage(message.products, () => pb_1.Message.addToRepeatedWrapperField(message, 9, Product.deserialize(reader), Product));
                        break;
                    case 10:
                        message.nfNumber = reader.readString();
                        break;
                    case 11:
                        message.expireIn = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ProcessPaymentRequest {
            return ProcessPaymentRequest.deserialize(bytes);
        }
    }
    export class PIXPaymentType extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): PIXPaymentType {
            const message = new PIXPaymentType({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PIXPaymentType {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PIXPaymentType();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PIXPaymentType {
            return PIXPaymentType.deserialize(bytes);
        }
    }
    export class CommitmentPaymentType extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            commitmentNumber?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("commitmentNumber" in data && data.commitmentNumber != undefined) {
                    this.commitmentNumber = data.commitmentNumber;
                }
            }
        }
        get commitmentNumber() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set commitmentNumber(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            commitmentNumber?: string;
        }): CommitmentPaymentType {
            const message = new CommitmentPaymentType({});
            if (data.commitmentNumber != null) {
                message.commitmentNumber = data.commitmentNumber;
            }
            return message;
        }
        toObject() {
            const data: {
                commitmentNumber?: string;
            } = {};
            if (this.commitmentNumber != null) {
                data.commitmentNumber = this.commitmentNumber;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.commitmentNumber.length)
                writer.writeString(1, this.commitmentNumber);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CommitmentPaymentType {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CommitmentPaymentType();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.commitmentNumber = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CommitmentPaymentType {
            return CommitmentPaymentType.deserialize(bytes);
        }
    }
    export class BankSlipPaymentType extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): BankSlipPaymentType {
            const message = new BankSlipPaymentType({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): BankSlipPaymentType {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BankSlipPaymentType();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): BankSlipPaymentType {
            return BankSlipPaymentType.deserialize(bytes);
        }
    }
    export class CardPaymentType extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            installments?: number;
            type?: CardType;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("installments" in data && data.installments != undefined) {
                    this.installments = data.installments;
                }
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get installments() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set installments(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 3, CardType.CARD_TYPE_UNSPECIFIED) as CardType;
        }
        set type(value: CardType) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            id?: string;
            installments?: number;
            type?: CardType;
        }): CardPaymentType {
            const message = new CardPaymentType({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.installments != null) {
                message.installments = data.installments;
            }
            if (data.type != null) {
                message.type = data.type;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                installments?: number;
                type?: CardType;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.installments != null) {
                data.installments = this.installments;
            }
            if (this.type != null) {
                data.type = this.type;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.installments != 0)
                writer.writeInt32(2, this.installments);
            if (this.type != CardType.CARD_TYPE_UNSPECIFIED)
                writer.writeEnum(3, this.type);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CardPaymentType {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CardPaymentType();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.installments = reader.readInt32();
                        break;
                    case 3:
                        message.type = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CardPaymentType {
            return CardPaymentType.deserialize(bytes);
        }
    }
    export class BankSlipAndPixPaymentType extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): BankSlipAndPixPaymentType {
            const message = new BankSlipAndPixPaymentType({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): BankSlipAndPixPaymentType {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BankSlipAndPixPaymentType();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): BankSlipAndPixPaymentType {
            return BankSlipAndPixPaymentType.deserialize(bytes);
        }
    }
    export class CustomerInfo extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            address?: Address;
            document?: string;
            name?: string;
            email?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("address" in data && data.address != undefined) {
                    this.address = data.address;
                }
                if ("document" in data && data.document != undefined) {
                    this.document = data.document;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get address() {
            return pb_1.Message.getWrapperField(this, Address, 2) as Address;
        }
        set address(value: Address) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasAddress() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get document() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set document(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            id?: string;
            address?: ReturnType<typeof Address.prototype.toObject>;
            document?: string;
            name?: string;
            email?: string;
        }): CustomerInfo {
            const message = new CustomerInfo({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.address != null) {
                message.address = Address.fromObject(data.address);
            }
            if (data.document != null) {
                message.document = data.document;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                address?: ReturnType<typeof Address.prototype.toObject>;
                document?: string;
                name?: string;
                email?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.address != null) {
                data.address = this.address.toObject();
            }
            if (this.document != null) {
                data.document = this.document;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.hasAddress)
                writer.writeMessage(2, this.address, () => this.address.serialize(writer));
            if (this.document.length)
                writer.writeString(3, this.document);
            if (this.name.length)
                writer.writeString(4, this.name);
            if (this.email.length)
                writer.writeString(5, this.email);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CustomerInfo {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CustomerInfo();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.address, () => message.address = Address.deserialize(reader));
                        break;
                    case 3:
                        message.document = reader.readString();
                        break;
                    case 4:
                        message.name = reader.readString();
                        break;
                    case 5:
                        message.email = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CustomerInfo {
            return CustomerInfo.deserialize(bytes);
        }
    }
    export class PIXPaymentDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): PIXPaymentDetails {
            const message = new PIXPaymentDetails({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PIXPaymentDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PIXPaymentDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PIXPaymentDetails {
            return PIXPaymentDetails.deserialize(bytes);
        }
    }
    export class BankSlipPaymentDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): BankSlipPaymentDetails {
            const message = new BankSlipPaymentDetails({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): BankSlipPaymentDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BankSlipPaymentDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): BankSlipPaymentDetails {
            return BankSlipPaymentDetails.deserialize(bytes);
        }
    }
    export class BankSlipAndPixPaymentDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            barcode?: string;
            keyCodePix?: string;
            linkKeyPix?: string;
            pdfUrl?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("barcode" in data && data.barcode != undefined) {
                    this.barcode = data.barcode;
                }
                if ("keyCodePix" in data && data.keyCodePix != undefined) {
                    this.keyCodePix = data.keyCodePix;
                }
                if ("linkKeyPix" in data && data.linkKeyPix != undefined) {
                    this.linkKeyPix = data.linkKeyPix;
                }
                if ("pdfUrl" in data && data.pdfUrl != undefined) {
                    this.pdfUrl = data.pdfUrl;
                }
            }
        }
        get barcode() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set barcode(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get keyCodePix() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set keyCodePix(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get linkKeyPix() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set linkKeyPix(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get pdfUrl() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set pdfUrl(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            barcode?: string;
            keyCodePix?: string;
            linkKeyPix?: string;
            pdfUrl?: string;
        }): BankSlipAndPixPaymentDetails {
            const message = new BankSlipAndPixPaymentDetails({});
            if (data.barcode != null) {
                message.barcode = data.barcode;
            }
            if (data.keyCodePix != null) {
                message.keyCodePix = data.keyCodePix;
            }
            if (data.linkKeyPix != null) {
                message.linkKeyPix = data.linkKeyPix;
            }
            if (data.pdfUrl != null) {
                message.pdfUrl = data.pdfUrl;
            }
            return message;
        }
        toObject() {
            const data: {
                barcode?: string;
                keyCodePix?: string;
                linkKeyPix?: string;
                pdfUrl?: string;
            } = {};
            if (this.barcode != null) {
                data.barcode = this.barcode;
            }
            if (this.keyCodePix != null) {
                data.keyCodePix = this.keyCodePix;
            }
            if (this.linkKeyPix != null) {
                data.linkKeyPix = this.linkKeyPix;
            }
            if (this.pdfUrl != null) {
                data.pdfUrl = this.pdfUrl;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.barcode.length)
                writer.writeString(1, this.barcode);
            if (this.keyCodePix.length)
                writer.writeString(2, this.keyCodePix);
            if (this.linkKeyPix.length)
                writer.writeString(3, this.linkKeyPix);
            if (this.pdfUrl.length)
                writer.writeString(4, this.pdfUrl);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): BankSlipAndPixPaymentDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BankSlipAndPixPaymentDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.barcode = reader.readString();
                        break;
                    case 2:
                        message.keyCodePix = reader.readString();
                        break;
                    case 3:
                        message.linkKeyPix = reader.readString();
                        break;
                    case 4:
                        message.pdfUrl = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): BankSlipAndPixPaymentDetails {
            return BankSlipAndPixPaymentDetails.deserialize(bytes);
        }
    }
    export class AutoSettlementPaymentDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): AutoSettlementPaymentDetails {
            const message = new AutoSettlementPaymentDetails({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): AutoSettlementPaymentDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AutoSettlementPaymentDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): AutoSettlementPaymentDetails {
            return AutoSettlementPaymentDetails.deserialize(bytes);
        }
    }
    export class CommitmentDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            commitmentNumber?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("commitmentNumber" in data && data.commitmentNumber != undefined) {
                    this.commitmentNumber = data.commitmentNumber;
                }
            }
        }
        get commitmentNumber() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set commitmentNumber(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            commitmentNumber?: string;
        }): CommitmentDetails {
            const message = new CommitmentDetails({});
            if (data.commitmentNumber != null) {
                message.commitmentNumber = data.commitmentNumber;
            }
            return message;
        }
        toObject() {
            const data: {
                commitmentNumber?: string;
            } = {};
            if (this.commitmentNumber != null) {
                data.commitmentNumber = this.commitmentNumber;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.commitmentNumber.length)
                writer.writeString(1, this.commitmentNumber);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CommitmentDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CommitmentDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.commitmentNumber = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CommitmentDetails {
            return CommitmentDetails.deserialize(bytes);
        }
    }
    export class CardPaymentDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            status?: PaymentStatus;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
            }
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 1, PaymentStatus.PAYMENT_STATUS_UNSPECIFIED) as PaymentStatus;
        }
        set status(value: PaymentStatus) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            status?: PaymentStatus;
        }): CardPaymentDetails {
            const message = new CardPaymentDetails({});
            if (data.status != null) {
                message.status = data.status;
            }
            return message;
        }
        toObject() {
            const data: {
                status?: PaymentStatus;
            } = {};
            if (this.status != null) {
                data.status = this.status;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.status != PaymentStatus.PAYMENT_STATUS_UNSPECIFIED)
                writer.writeEnum(1, this.status);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CardPaymentDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CardPaymentDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.status = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CardPaymentDetails {
            return CardPaymentDetails.deserialize(bytes);
        }
    }
    export class AutoSettlementPaymentType extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): AutoSettlementPaymentType {
            const message = new AutoSettlementPaymentType({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): AutoSettlementPaymentType {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AutoSettlementPaymentType();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): AutoSettlementPaymentType {
            return AutoSettlementPaymentType.deserialize(bytes);
        }
    }
    export class PaymentType extends pb_1.Message {
        #one_of_decls: number[][] = [[7, 8, 9, 10, 11, 12]];
        constructor(data?: any[] | ({} & (({
            pix?: PIXPaymentType;
            bankSlip?: never;
            card?: never;
            bankSlipAndPix?: never;
            commitment?: never;
            autoSettlement?: never;
        } | {
            pix?: never;
            bankSlip?: BankSlipPaymentType;
            card?: never;
            bankSlipAndPix?: never;
            commitment?: never;
            autoSettlement?: never;
        } | {
            pix?: never;
            bankSlip?: never;
            card?: CardPaymentType;
            bankSlipAndPix?: never;
            commitment?: never;
            autoSettlement?: never;
        } | {
            pix?: never;
            bankSlip?: never;
            card?: never;
            bankSlipAndPix?: BankSlipAndPixPaymentType;
            commitment?: never;
            autoSettlement?: never;
        } | {
            pix?: never;
            bankSlip?: never;
            card?: never;
            bankSlipAndPix?: never;
            commitment?: CommitmentPaymentType;
            autoSettlement?: never;
        } | {
            pix?: never;
            bankSlip?: never;
            card?: never;
            bankSlipAndPix?: never;
            commitment?: never;
            autoSettlement?: AutoSettlementPaymentType;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("pix" in data && data.pix != undefined) {
                    this.pix = data.pix;
                }
                if ("bankSlip" in data && data.bankSlip != undefined) {
                    this.bankSlip = data.bankSlip;
                }
                if ("card" in data && data.card != undefined) {
                    this.card = data.card;
                }
                if ("bankSlipAndPix" in data && data.bankSlipAndPix != undefined) {
                    this.bankSlipAndPix = data.bankSlipAndPix;
                }
                if ("commitment" in data && data.commitment != undefined) {
                    this.commitment = data.commitment;
                }
                if ("autoSettlement" in data && data.autoSettlement != undefined) {
                    this.autoSettlement = data.autoSettlement;
                }
            }
        }
        get pix() {
            return pb_1.Message.getWrapperField(this, PIXPaymentType, 7) as PIXPaymentType;
        }
        set pix(value: PIXPaymentType) {
            pb_1.Message.setOneofWrapperField(this, 7, this.#one_of_decls[0], value);
        }
        get hasPix() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get bankSlip() {
            return pb_1.Message.getWrapperField(this, BankSlipPaymentType, 8) as BankSlipPaymentType;
        }
        set bankSlip(value: BankSlipPaymentType) {
            pb_1.Message.setOneofWrapperField(this, 8, this.#one_of_decls[0], value);
        }
        get hasBankSlip() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get card() {
            return pb_1.Message.getWrapperField(this, CardPaymentType, 9) as CardPaymentType;
        }
        set card(value: CardPaymentType) {
            pb_1.Message.setOneofWrapperField(this, 9, this.#one_of_decls[0], value);
        }
        get hasCard() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get bankSlipAndPix() {
            return pb_1.Message.getWrapperField(this, BankSlipAndPixPaymentType, 10) as BankSlipAndPixPaymentType;
        }
        set bankSlipAndPix(value: BankSlipAndPixPaymentType) {
            pb_1.Message.setOneofWrapperField(this, 10, this.#one_of_decls[0], value);
        }
        get hasBankSlipAndPix() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get commitment() {
            return pb_1.Message.getWrapperField(this, CommitmentPaymentType, 11) as CommitmentPaymentType;
        }
        set commitment(value: CommitmentPaymentType) {
            pb_1.Message.setOneofWrapperField(this, 11, this.#one_of_decls[0], value);
        }
        get hasCommitment() {
            return pb_1.Message.getField(this, 11) != null;
        }
        get autoSettlement() {
            return pb_1.Message.getWrapperField(this, AutoSettlementPaymentType, 12) as AutoSettlementPaymentType;
        }
        set autoSettlement(value: AutoSettlementPaymentType) {
            pb_1.Message.setOneofWrapperField(this, 12, this.#one_of_decls[0], value);
        }
        get hasAutoSettlement() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get payment_type() {
            const cases: {
                [index: number]: "none" | "pix" | "bankSlip" | "card" | "bankSlipAndPix" | "commitment" | "autoSettlement";
            } = {
                0: "none",
                7: "pix",
                8: "bankSlip",
                9: "card",
                10: "bankSlipAndPix",
                11: "commitment",
                12: "autoSettlement"
            };
            return cases[pb_1.Message.computeOneofCase(this, [7, 8, 9, 10, 11, 12])];
        }
        static fromObject(data: {
            pix?: ReturnType<typeof PIXPaymentType.prototype.toObject>;
            bankSlip?: ReturnType<typeof BankSlipPaymentType.prototype.toObject>;
            card?: ReturnType<typeof CardPaymentType.prototype.toObject>;
            bankSlipAndPix?: ReturnType<typeof BankSlipAndPixPaymentType.prototype.toObject>;
            commitment?: ReturnType<typeof CommitmentPaymentType.prototype.toObject>;
            autoSettlement?: ReturnType<typeof AutoSettlementPaymentType.prototype.toObject>;
        }): PaymentType {
            const message = new PaymentType({});
            if (data.pix != null) {
                message.pix = PIXPaymentType.fromObject(data.pix);
            }
            if (data.bankSlip != null) {
                message.bankSlip = BankSlipPaymentType.fromObject(data.bankSlip);
            }
            if (data.card != null) {
                message.card = CardPaymentType.fromObject(data.card);
            }
            if (data.bankSlipAndPix != null) {
                message.bankSlipAndPix = BankSlipAndPixPaymentType.fromObject(data.bankSlipAndPix);
            }
            if (data.commitment != null) {
                message.commitment = CommitmentPaymentType.fromObject(data.commitment);
            }
            if (data.autoSettlement != null) {
                message.autoSettlement = AutoSettlementPaymentType.fromObject(data.autoSettlement);
            }
            return message;
        }
        toObject() {
            const data: {
                pix?: ReturnType<typeof PIXPaymentType.prototype.toObject>;
                bankSlip?: ReturnType<typeof BankSlipPaymentType.prototype.toObject>;
                card?: ReturnType<typeof CardPaymentType.prototype.toObject>;
                bankSlipAndPix?: ReturnType<typeof BankSlipAndPixPaymentType.prototype.toObject>;
                commitment?: ReturnType<typeof CommitmentPaymentType.prototype.toObject>;
                autoSettlement?: ReturnType<typeof AutoSettlementPaymentType.prototype.toObject>;
            } = {};
            if (this.pix != null) {
                data.pix = this.pix.toObject();
            }
            if (this.bankSlip != null) {
                data.bankSlip = this.bankSlip.toObject();
            }
            if (this.card != null) {
                data.card = this.card.toObject();
            }
            if (this.bankSlipAndPix != null) {
                data.bankSlipAndPix = this.bankSlipAndPix.toObject();
            }
            if (this.commitment != null) {
                data.commitment = this.commitment.toObject();
            }
            if (this.autoSettlement != null) {
                data.autoSettlement = this.autoSettlement.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPix)
                writer.writeMessage(7, this.pix, () => this.pix.serialize(writer));
            if (this.hasBankSlip)
                writer.writeMessage(8, this.bankSlip, () => this.bankSlip.serialize(writer));
            if (this.hasCard)
                writer.writeMessage(9, this.card, () => this.card.serialize(writer));
            if (this.hasBankSlipAndPix)
                writer.writeMessage(10, this.bankSlipAndPix, () => this.bankSlipAndPix.serialize(writer));
            if (this.hasCommitment)
                writer.writeMessage(11, this.commitment, () => this.commitment.serialize(writer));
            if (this.hasAutoSettlement)
                writer.writeMessage(12, this.autoSettlement, () => this.autoSettlement.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaymentType {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PaymentType();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 7:
                        reader.readMessage(message.pix, () => message.pix = PIXPaymentType.deserialize(reader));
                        break;
                    case 8:
                        reader.readMessage(message.bankSlip, () => message.bankSlip = BankSlipPaymentType.deserialize(reader));
                        break;
                    case 9:
                        reader.readMessage(message.card, () => message.card = CardPaymentType.deserialize(reader));
                        break;
                    case 10:
                        reader.readMessage(message.bankSlipAndPix, () => message.bankSlipAndPix = BankSlipAndPixPaymentType.deserialize(reader));
                        break;
                    case 11:
                        reader.readMessage(message.commitment, () => message.commitment = CommitmentPaymentType.deserialize(reader));
                        break;
                    case 12:
                        reader.readMessage(message.autoSettlement, () => message.autoSettlement = AutoSettlementPaymentType.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PaymentType {
            return PaymentType.deserialize(bytes);
        }
    }
    export class Address extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            street?: string;
            number?: string;
            complement?: string;
            neighborhood?: string;
            city?: string;
            state?: string;
            country?: string;
            zipCode?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("street" in data && data.street != undefined) {
                    this.street = data.street;
                }
                if ("number" in data && data.number != undefined) {
                    this.number = data.number;
                }
                if ("complement" in data && data.complement != undefined) {
                    this.complement = data.complement;
                }
                if ("neighborhood" in data && data.neighborhood != undefined) {
                    this.neighborhood = data.neighborhood;
                }
                if ("city" in data && data.city != undefined) {
                    this.city = data.city;
                }
                if ("state" in data && data.state != undefined) {
                    this.state = data.state;
                }
                if ("country" in data && data.country != undefined) {
                    this.country = data.country;
                }
                if ("zipCode" in data && data.zipCode != undefined) {
                    this.zipCode = data.zipCode;
                }
            }
        }
        get street() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set street(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get number() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set number(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get complement() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set complement(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get neighborhood() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set neighborhood(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get city() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set city(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get state() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set state(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get country() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set country(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get zipCode() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set zipCode(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            street?: string;
            number?: string;
            complement?: string;
            neighborhood?: string;
            city?: string;
            state?: string;
            country?: string;
            zipCode?: string;
        }): Address {
            const message = new Address({});
            if (data.street != null) {
                message.street = data.street;
            }
            if (data.number != null) {
                message.number = data.number;
            }
            if (data.complement != null) {
                message.complement = data.complement;
            }
            if (data.neighborhood != null) {
                message.neighborhood = data.neighborhood;
            }
            if (data.city != null) {
                message.city = data.city;
            }
            if (data.state != null) {
                message.state = data.state;
            }
            if (data.country != null) {
                message.country = data.country;
            }
            if (data.zipCode != null) {
                message.zipCode = data.zipCode;
            }
            return message;
        }
        toObject() {
            const data: {
                street?: string;
                number?: string;
                complement?: string;
                neighborhood?: string;
                city?: string;
                state?: string;
                country?: string;
                zipCode?: string;
            } = {};
            if (this.street != null) {
                data.street = this.street;
            }
            if (this.number != null) {
                data.number = this.number;
            }
            if (this.complement != null) {
                data.complement = this.complement;
            }
            if (this.neighborhood != null) {
                data.neighborhood = this.neighborhood;
            }
            if (this.city != null) {
                data.city = this.city;
            }
            if (this.state != null) {
                data.state = this.state;
            }
            if (this.country != null) {
                data.country = this.country;
            }
            if (this.zipCode != null) {
                data.zipCode = this.zipCode;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.street.length)
                writer.writeString(1, this.street);
            if (this.number.length)
                writer.writeString(2, this.number);
            if (this.complement.length)
                writer.writeString(3, this.complement);
            if (this.neighborhood.length)
                writer.writeString(4, this.neighborhood);
            if (this.city.length)
                writer.writeString(5, this.city);
            if (this.state.length)
                writer.writeString(6, this.state);
            if (this.country.length)
                writer.writeString(7, this.country);
            if (this.zipCode.length)
                writer.writeString(8, this.zipCode);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Address {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Address();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.street = reader.readString();
                        break;
                    case 2:
                        message.number = reader.readString();
                        break;
                    case 3:
                        message.complement = reader.readString();
                        break;
                    case 4:
                        message.neighborhood = reader.readString();
                        break;
                    case 5:
                        message.city = reader.readString();
                        break;
                    case 6:
                        message.state = reader.readString();
                        break;
                    case 7:
                        message.country = reader.readString();
                        break;
                    case 8:
                        message.zipCode = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Address {
            return Address.deserialize(bytes);
        }
    }
    export class ProcessPaymentResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            payment?: Payment;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("payment" in data && data.payment != undefined) {
                    this.payment = data.payment;
                }
            }
        }
        get payment() {
            return pb_1.Message.getWrapperField(this, Payment, 1) as Payment;
        }
        set payment(value: Payment) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasPayment() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            payment?: ReturnType<typeof Payment.prototype.toObject>;
        }): ProcessPaymentResponse {
            const message = new ProcessPaymentResponse({});
            if (data.payment != null) {
                message.payment = Payment.fromObject(data.payment);
            }
            return message;
        }
        toObject() {
            const data: {
                payment?: ReturnType<typeof Payment.prototype.toObject>;
            } = {};
            if (this.payment != null) {
                data.payment = this.payment.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPayment)
                writer.writeMessage(1, this.payment, () => this.payment.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ProcessPaymentResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ProcessPaymentResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.payment, () => message.payment = Payment.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ProcessPaymentResponse {
            return ProcessPaymentResponse.deserialize(bytes);
        }
    }
    export class Payment extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            organizationId?: string;
            workspaceId?: string;
            customer?: Customer;
            orderId?: string;
            type?: string;
            amount?: Money;
            status?: PaymentStatus;
            details?: PaymentDetails;
            createdAt?: dependency_1.google.protobuf.Timestamp;
            updatedAt?: dependency_1.google.protobuf.Timestamp;
            completedAt?: dependency_1.google.protobuf.Timestamp;
            expiresAt?: dependency_1.google.protobuf.Timestamp;
            metadata?: Map<string, string>;
            originService?: string;
            paymentStatusHistory?: PaymentStatusHistory[];
            authorizedAmount?: Money;
            receivedAmount?: Money;
            processingFee?: Money;
            chargebackAmount?: Money;
            totalOutflows?: Money;
            netAmount?: Money;
            products?: Product[];
            method?: PaymentMethod[];
            invoiceNumber?: string;
            attempts?: PaymentAttempt[];
            provider?: PaymentProvider;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [16, 23, 24, 26], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("customer" in data && data.customer != undefined) {
                    this.customer = data.customer;
                }
                if ("orderId" in data && data.orderId != undefined) {
                    this.orderId = data.orderId;
                }
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("details" in data && data.details != undefined) {
                    this.details = data.details;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("updatedAt" in data && data.updatedAt != undefined) {
                    this.updatedAt = data.updatedAt;
                }
                if ("completedAt" in data && data.completedAt != undefined) {
                    this.completedAt = data.completedAt;
                }
                if ("expiresAt" in data && data.expiresAt != undefined) {
                    this.expiresAt = data.expiresAt;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("originService" in data && data.originService != undefined) {
                    this.originService = data.originService;
                }
                if ("paymentStatusHistory" in data && data.paymentStatusHistory != undefined) {
                    this.paymentStatusHistory = data.paymentStatusHistory;
                }
                if ("authorizedAmount" in data && data.authorizedAmount != undefined) {
                    this.authorizedAmount = data.authorizedAmount;
                }
                if ("receivedAmount" in data && data.receivedAmount != undefined) {
                    this.receivedAmount = data.receivedAmount;
                }
                if ("processingFee" in data && data.processingFee != undefined) {
                    this.processingFee = data.processingFee;
                }
                if ("chargebackAmount" in data && data.chargebackAmount != undefined) {
                    this.chargebackAmount = data.chargebackAmount;
                }
                if ("totalOutflows" in data && data.totalOutflows != undefined) {
                    this.totalOutflows = data.totalOutflows;
                }
                if ("netAmount" in data && data.netAmount != undefined) {
                    this.netAmount = data.netAmount;
                }
                if ("products" in data && data.products != undefined) {
                    this.products = data.products;
                }
                if ("method" in data && data.method != undefined) {
                    this.method = data.method;
                }
                if ("invoiceNumber" in data && data.invoiceNumber != undefined) {
                    this.invoiceNumber = data.invoiceNumber;
                }
                if ("attempts" in data && data.attempts != undefined) {
                    this.attempts = data.attempts;
                }
                if ("provider" in data && data.provider != undefined) {
                    this.provider = data.provider;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get customer() {
            return pb_1.Message.getWrapperField(this, Customer, 4) as Customer;
        }
        set customer(value: Customer) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasCustomer() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get orderId() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set orderId(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set type(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get amount() {
            return pb_1.Message.getWrapperField(this, Money, 7) as Money;
        }
        set amount(value: Money) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get hasAmount() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 8, PaymentStatus.PAYMENT_STATUS_UNSPECIFIED) as PaymentStatus;
        }
        set status(value: PaymentStatus) {
            pb_1.Message.setField(this, 8, value);
        }
        get details() {
            return pb_1.Message.getWrapperField(this, PaymentDetails, 9) as PaymentDetails;
        }
        set details(value: PaymentDetails) {
            pb_1.Message.setWrapperField(this, 9, value);
        }
        get hasDetails() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 10) as dependency_1.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 10, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get updatedAt() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 11) as dependency_1.google.protobuf.Timestamp;
        }
        set updatedAt(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 11, value);
        }
        get hasUpdatedAt() {
            return pb_1.Message.getField(this, 11) != null;
        }
        get completedAt() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 12) as dependency_1.google.protobuf.Timestamp;
        }
        set completedAt(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 12, value);
        }
        get hasCompletedAt() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get expiresAt() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 13) as dependency_1.google.protobuf.Timestamp;
        }
        set expiresAt(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 13, value);
        }
        get hasExpiresAt() {
            return pb_1.Message.getField(this, 13) != null;
        }
        get metadata() {
            return pb_1.Message.getField(this, 14) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 14, value as any);
        }
        get originService() {
            return pb_1.Message.getFieldWithDefault(this, 15, "") as string;
        }
        set originService(value: string) {
            pb_1.Message.setField(this, 15, value);
        }
        get paymentStatusHistory() {
            return pb_1.Message.getRepeatedWrapperField(this, PaymentStatusHistory, 16) as PaymentStatusHistory[];
        }
        set paymentStatusHistory(value: PaymentStatusHistory[]) {
            pb_1.Message.setRepeatedWrapperField(this, 16, value);
        }
        get authorizedAmount() {
            return pb_1.Message.getWrapperField(this, Money, 17) as Money;
        }
        set authorizedAmount(value: Money) {
            pb_1.Message.setWrapperField(this, 17, value);
        }
        get hasAuthorizedAmount() {
            return pb_1.Message.getField(this, 17) != null;
        }
        get receivedAmount() {
            return pb_1.Message.getWrapperField(this, Money, 18) as Money;
        }
        set receivedAmount(value: Money) {
            pb_1.Message.setWrapperField(this, 18, value);
        }
        get hasReceivedAmount() {
            return pb_1.Message.getField(this, 18) != null;
        }
        get processingFee() {
            return pb_1.Message.getWrapperField(this, Money, 19) as Money;
        }
        set processingFee(value: Money) {
            pb_1.Message.setWrapperField(this, 19, value);
        }
        get hasProcessingFee() {
            return pb_1.Message.getField(this, 19) != null;
        }
        get chargebackAmount() {
            return pb_1.Message.getWrapperField(this, Money, 20) as Money;
        }
        set chargebackAmount(value: Money) {
            pb_1.Message.setWrapperField(this, 20, value);
        }
        get hasChargebackAmount() {
            return pb_1.Message.getField(this, 20) != null;
        }
        get totalOutflows() {
            return pb_1.Message.getWrapperField(this, Money, 21) as Money;
        }
        set totalOutflows(value: Money) {
            pb_1.Message.setWrapperField(this, 21, value);
        }
        get hasTotalOutflows() {
            return pb_1.Message.getField(this, 21) != null;
        }
        get netAmount() {
            return pb_1.Message.getWrapperField(this, Money, 22) as Money;
        }
        set netAmount(value: Money) {
            pb_1.Message.setWrapperField(this, 22, value);
        }
        get hasNetAmount() {
            return pb_1.Message.getField(this, 22) != null;
        }
        get products() {
            return pb_1.Message.getRepeatedWrapperField(this, Product, 23) as Product[];
        }
        set products(value: Product[]) {
            pb_1.Message.setRepeatedWrapperField(this, 23, value);
        }
        get method() {
            return pb_1.Message.getFieldWithDefault(this, 24, []) as PaymentMethod[];
        }
        set method(value: PaymentMethod[]) {
            pb_1.Message.setField(this, 24, value);
        }
        get invoiceNumber() {
            return pb_1.Message.getFieldWithDefault(this, 25, "") as string;
        }
        set invoiceNumber(value: string) {
            pb_1.Message.setField(this, 25, value);
        }
        get attempts() {
            return pb_1.Message.getRepeatedWrapperField(this, PaymentAttempt, 26) as PaymentAttempt[];
        }
        set attempts(value: PaymentAttempt[]) {
            pb_1.Message.setRepeatedWrapperField(this, 26, value);
        }
        get provider() {
            return pb_1.Message.getFieldWithDefault(this, 27, PaymentProvider.PAYMENT_PROVIDER_UNKNOWN) as PaymentProvider;
        }
        set provider(value: PaymentProvider) {
            pb_1.Message.setField(this, 27, value);
        }
        static fromObject(data: {
            id?: string;
            organizationId?: string;
            workspaceId?: string;
            customer?: ReturnType<typeof Customer.prototype.toObject>;
            orderId?: string;
            type?: string;
            amount?: ReturnType<typeof Money.prototype.toObject>;
            status?: PaymentStatus;
            details?: ReturnType<typeof PaymentDetails.prototype.toObject>;
            createdAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            updatedAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            completedAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            expiresAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            metadata?: {
                [key: string]: string;
            };
            originService?: string;
            paymentStatusHistory?: ReturnType<typeof PaymentStatusHistory.prototype.toObject>[];
            authorizedAmount?: ReturnType<typeof Money.prototype.toObject>;
            receivedAmount?: ReturnType<typeof Money.prototype.toObject>;
            processingFee?: ReturnType<typeof Money.prototype.toObject>;
            chargebackAmount?: ReturnType<typeof Money.prototype.toObject>;
            totalOutflows?: ReturnType<typeof Money.prototype.toObject>;
            netAmount?: ReturnType<typeof Money.prototype.toObject>;
            products?: ReturnType<typeof Product.prototype.toObject>[];
            method?: PaymentMethod[];
            invoiceNumber?: string;
            attempts?: ReturnType<typeof PaymentAttempt.prototype.toObject>[];
            provider?: PaymentProvider;
        }): Payment {
            const message = new Payment({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.customer != null) {
                message.customer = Customer.fromObject(data.customer);
            }
            if (data.orderId != null) {
                message.orderId = data.orderId;
            }
            if (data.type != null) {
                message.type = data.type;
            }
            if (data.amount != null) {
                message.amount = Money.fromObject(data.amount);
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.details != null) {
                message.details = PaymentDetails.fromObject(data.details);
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_1.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.updatedAt != null) {
                message.updatedAt = dependency_1.google.protobuf.Timestamp.fromObject(data.updatedAt);
            }
            if (data.completedAt != null) {
                message.completedAt = dependency_1.google.protobuf.Timestamp.fromObject(data.completedAt);
            }
            if (data.expiresAt != null) {
                message.expiresAt = dependency_1.google.protobuf.Timestamp.fromObject(data.expiresAt);
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.originService != null) {
                message.originService = data.originService;
            }
            if (data.paymentStatusHistory != null) {
                message.paymentStatusHistory = data.paymentStatusHistory.map(item => PaymentStatusHistory.fromObject(item));
            }
            if (data.authorizedAmount != null) {
                message.authorizedAmount = Money.fromObject(data.authorizedAmount);
            }
            if (data.receivedAmount != null) {
                message.receivedAmount = Money.fromObject(data.receivedAmount);
            }
            if (data.processingFee != null) {
                message.processingFee = Money.fromObject(data.processingFee);
            }
            if (data.chargebackAmount != null) {
                message.chargebackAmount = Money.fromObject(data.chargebackAmount);
            }
            if (data.totalOutflows != null) {
                message.totalOutflows = Money.fromObject(data.totalOutflows);
            }
            if (data.netAmount != null) {
                message.netAmount = Money.fromObject(data.netAmount);
            }
            if (data.products != null) {
                message.products = data.products.map(item => Product.fromObject(item));
            }
            if (data.method != null) {
                message.method = data.method;
            }
            if (data.invoiceNumber != null) {
                message.invoiceNumber = data.invoiceNumber;
            }
            if (data.attempts != null) {
                message.attempts = data.attempts.map(item => PaymentAttempt.fromObject(item));
            }
            if (data.provider != null) {
                message.provider = data.provider;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                organizationId?: string;
                workspaceId?: string;
                customer?: ReturnType<typeof Customer.prototype.toObject>;
                orderId?: string;
                type?: string;
                amount?: ReturnType<typeof Money.prototype.toObject>;
                status?: PaymentStatus;
                details?: ReturnType<typeof PaymentDetails.prototype.toObject>;
                createdAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                updatedAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                completedAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                expiresAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                metadata?: {
                    [key: string]: string;
                };
                originService?: string;
                paymentStatusHistory?: ReturnType<typeof PaymentStatusHistory.prototype.toObject>[];
                authorizedAmount?: ReturnType<typeof Money.prototype.toObject>;
                receivedAmount?: ReturnType<typeof Money.prototype.toObject>;
                processingFee?: ReturnType<typeof Money.prototype.toObject>;
                chargebackAmount?: ReturnType<typeof Money.prototype.toObject>;
                totalOutflows?: ReturnType<typeof Money.prototype.toObject>;
                netAmount?: ReturnType<typeof Money.prototype.toObject>;
                products?: ReturnType<typeof Product.prototype.toObject>[];
                method?: PaymentMethod[];
                invoiceNumber?: string;
                attempts?: ReturnType<typeof PaymentAttempt.prototype.toObject>[];
                provider?: PaymentProvider;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.customer != null) {
                data.customer = this.customer.toObject();
            }
            if (this.orderId != null) {
                data.orderId = this.orderId;
            }
            if (this.type != null) {
                data.type = this.type;
            }
            if (this.amount != null) {
                data.amount = this.amount.toObject();
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.details != null) {
                data.details = this.details.toObject();
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.updatedAt != null) {
                data.updatedAt = this.updatedAt.toObject();
            }
            if (this.completedAt != null) {
                data.completedAt = this.completedAt.toObject();
            }
            if (this.expiresAt != null) {
                data.expiresAt = this.expiresAt.toObject();
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.originService != null) {
                data.originService = this.originService;
            }
            if (this.paymentStatusHistory != null) {
                data.paymentStatusHistory = this.paymentStatusHistory.map((item: PaymentStatusHistory) => item.toObject());
            }
            if (this.authorizedAmount != null) {
                data.authorizedAmount = this.authorizedAmount.toObject();
            }
            if (this.receivedAmount != null) {
                data.receivedAmount = this.receivedAmount.toObject();
            }
            if (this.processingFee != null) {
                data.processingFee = this.processingFee.toObject();
            }
            if (this.chargebackAmount != null) {
                data.chargebackAmount = this.chargebackAmount.toObject();
            }
            if (this.totalOutflows != null) {
                data.totalOutflows = this.totalOutflows.toObject();
            }
            if (this.netAmount != null) {
                data.netAmount = this.netAmount.toObject();
            }
            if (this.products != null) {
                data.products = this.products.map((item: Product) => item.toObject());
            }
            if (this.method != null) {
                data.method = this.method;
            }
            if (this.invoiceNumber != null) {
                data.invoiceNumber = this.invoiceNumber;
            }
            if (this.attempts != null) {
                data.attempts = this.attempts.map((item: PaymentAttempt) => item.toObject());
            }
            if (this.provider != null) {
                data.provider = this.provider;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.organizationId.length)
                writer.writeString(2, this.organizationId);
            if (this.workspaceId.length)
                writer.writeString(3, this.workspaceId);
            if (this.hasCustomer)
                writer.writeMessage(4, this.customer, () => this.customer.serialize(writer));
            if (this.orderId.length)
                writer.writeString(5, this.orderId);
            if (this.type.length)
                writer.writeString(6, this.type);
            if (this.hasAmount)
                writer.writeMessage(7, this.amount, () => this.amount.serialize(writer));
            if (this.status != PaymentStatus.PAYMENT_STATUS_UNSPECIFIED)
                writer.writeEnum(8, this.status);
            if (this.hasDetails)
                writer.writeMessage(9, this.details, () => this.details.serialize(writer));
            if (this.hasCreatedAt)
                writer.writeMessage(10, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.hasUpdatedAt)
                writer.writeMessage(11, this.updatedAt, () => this.updatedAt.serialize(writer));
            if (this.hasCompletedAt)
                writer.writeMessage(12, this.completedAt, () => this.completedAt.serialize(writer));
            if (this.hasExpiresAt)
                writer.writeMessage(13, this.expiresAt, () => this.expiresAt.serialize(writer));
            for (const [key, value] of this.metadata) {
                writer.writeMessage(14, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.originService.length)
                writer.writeString(15, this.originService);
            if (this.paymentStatusHistory.length)
                writer.writeRepeatedMessage(16, this.paymentStatusHistory, (item: PaymentStatusHistory) => item.serialize(writer));
            if (this.hasAuthorizedAmount)
                writer.writeMessage(17, this.authorizedAmount, () => this.authorizedAmount.serialize(writer));
            if (this.hasReceivedAmount)
                writer.writeMessage(18, this.receivedAmount, () => this.receivedAmount.serialize(writer));
            if (this.hasProcessingFee)
                writer.writeMessage(19, this.processingFee, () => this.processingFee.serialize(writer));
            if (this.hasChargebackAmount)
                writer.writeMessage(20, this.chargebackAmount, () => this.chargebackAmount.serialize(writer));
            if (this.hasTotalOutflows)
                writer.writeMessage(21, this.totalOutflows, () => this.totalOutflows.serialize(writer));
            if (this.hasNetAmount)
                writer.writeMessage(22, this.netAmount, () => this.netAmount.serialize(writer));
            if (this.products.length)
                writer.writeRepeatedMessage(23, this.products, (item: Product) => item.serialize(writer));
            if (this.method.length)
                writer.writePackedEnum(24, this.method);
            if (this.invoiceNumber.length)
                writer.writeString(25, this.invoiceNumber);
            if (this.attempts.length)
                writer.writeRepeatedMessage(26, this.attempts, (item: PaymentAttempt) => item.serialize(writer));
            if (this.provider != PaymentProvider.PAYMENT_PROVIDER_UNKNOWN)
                writer.writeEnum(27, this.provider);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Payment {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Payment();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.organizationId = reader.readString();
                        break;
                    case 3:
                        message.workspaceId = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.customer, () => message.customer = Customer.deserialize(reader));
                        break;
                    case 5:
                        message.orderId = reader.readString();
                        break;
                    case 6:
                        message.type = reader.readString();
                        break;
                    case 7:
                        reader.readMessage(message.amount, () => message.amount = Money.deserialize(reader));
                        break;
                    case 8:
                        message.status = reader.readEnum();
                        break;
                    case 9:
                        reader.readMessage(message.details, () => message.details = PaymentDetails.deserialize(reader));
                        break;
                    case 10:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 11:
                        reader.readMessage(message.updatedAt, () => message.updatedAt = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 12:
                        reader.readMessage(message.completedAt, () => message.completedAt = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 13:
                        reader.readMessage(message.expiresAt, () => message.expiresAt = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 14:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 15:
                        message.originService = reader.readString();
                        break;
                    case 16:
                        reader.readMessage(message.paymentStatusHistory, () => pb_1.Message.addToRepeatedWrapperField(message, 16, PaymentStatusHistory.deserialize(reader), PaymentStatusHistory));
                        break;
                    case 17:
                        reader.readMessage(message.authorizedAmount, () => message.authorizedAmount = Money.deserialize(reader));
                        break;
                    case 18:
                        reader.readMessage(message.receivedAmount, () => message.receivedAmount = Money.deserialize(reader));
                        break;
                    case 19:
                        reader.readMessage(message.processingFee, () => message.processingFee = Money.deserialize(reader));
                        break;
                    case 20:
                        reader.readMessage(message.chargebackAmount, () => message.chargebackAmount = Money.deserialize(reader));
                        break;
                    case 21:
                        reader.readMessage(message.totalOutflows, () => message.totalOutflows = Money.deserialize(reader));
                        break;
                    case 22:
                        reader.readMessage(message.netAmount, () => message.netAmount = Money.deserialize(reader));
                        break;
                    case 23:
                        reader.readMessage(message.products, () => pb_1.Message.addToRepeatedWrapperField(message, 23, Product.deserialize(reader), Product));
                        break;
                    case 24:
                        message.method = reader.readPackedEnum();
                        break;
                    case 25:
                        message.invoiceNumber = reader.readString();
                        break;
                    case 26:
                        reader.readMessage(message.attempts, () => pb_1.Message.addToRepeatedWrapperField(message, 26, PaymentAttempt.deserialize(reader), PaymentAttempt));
                        break;
                    case 27:
                        message.provider = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Payment {
            return Payment.deserialize(bytes);
        }
    }
    export class PaymentAttempt extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            status?: PaymentStatus;
            method?: PaymentMethod;
            cardType?: CardType;
            cardLastFour?: string;
            errorCode?: string;
            errorMessage?: string;
            createdAt?: dependency_1.google.protobuf.Timestamp;
            completedAt?: dependency_1.google.protobuf.Timestamp;
            cardNumberMaskedBin?: string;
            providerErrorCode?: string;
            providerRawError?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("method" in data && data.method != undefined) {
                    this.method = data.method;
                }
                if ("cardType" in data && data.cardType != undefined) {
                    this.cardType = data.cardType;
                }
                if ("cardLastFour" in data && data.cardLastFour != undefined) {
                    this.cardLastFour = data.cardLastFour;
                }
                if ("errorCode" in data && data.errorCode != undefined) {
                    this.errorCode = data.errorCode;
                }
                if ("errorMessage" in data && data.errorMessage != undefined) {
                    this.errorMessage = data.errorMessage;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("completedAt" in data && data.completedAt != undefined) {
                    this.completedAt = data.completedAt;
                }
                if ("cardNumberMaskedBin" in data && data.cardNumberMaskedBin != undefined) {
                    this.cardNumberMaskedBin = data.cardNumberMaskedBin;
                }
                if ("providerErrorCode" in data && data.providerErrorCode != undefined) {
                    this.providerErrorCode = data.providerErrorCode;
                }
                if ("providerRawError" in data && data.providerRawError != undefined) {
                    this.providerRawError = data.providerRawError;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 2, PaymentStatus.PAYMENT_STATUS_UNSPECIFIED) as PaymentStatus;
        }
        set status(value: PaymentStatus) {
            pb_1.Message.setField(this, 2, value);
        }
        get method() {
            return pb_1.Message.getFieldWithDefault(this, 3, PaymentMethod.PAYMENT_METHOD_UNSPECIFIED) as PaymentMethod;
        }
        set method(value: PaymentMethod) {
            pb_1.Message.setField(this, 3, value);
        }
        get cardType() {
            return pb_1.Message.getFieldWithDefault(this, 4, CardType.CARD_TYPE_UNSPECIFIED) as CardType;
        }
        set cardType(value: CardType) {
            pb_1.Message.setField(this, 4, value);
        }
        get cardLastFour() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set cardLastFour(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get errorCode() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set errorCode(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get errorMessage() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set errorMessage(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 8) as dependency_1.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 8, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get completedAt() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 9) as dependency_1.google.protobuf.Timestamp;
        }
        set completedAt(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 9, value);
        }
        get hasCompletedAt() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get cardNumberMaskedBin() {
            return pb_1.Message.getFieldWithDefault(this, 10, "") as string;
        }
        set cardNumberMaskedBin(value: string) {
            pb_1.Message.setField(this, 10, value);
        }
        get providerErrorCode() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set providerErrorCode(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get providerRawError() {
            return pb_1.Message.getFieldWithDefault(this, 12, "") as string;
        }
        set providerRawError(value: string) {
            pb_1.Message.setField(this, 12, value);
        }
        static fromObject(data: {
            id?: string;
            status?: PaymentStatus;
            method?: PaymentMethod;
            cardType?: CardType;
            cardLastFour?: string;
            errorCode?: string;
            errorMessage?: string;
            createdAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            completedAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            cardNumberMaskedBin?: string;
            providerErrorCode?: string;
            providerRawError?: string;
        }): PaymentAttempt {
            const message = new PaymentAttempt({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.method != null) {
                message.method = data.method;
            }
            if (data.cardType != null) {
                message.cardType = data.cardType;
            }
            if (data.cardLastFour != null) {
                message.cardLastFour = data.cardLastFour;
            }
            if (data.errorCode != null) {
                message.errorCode = data.errorCode;
            }
            if (data.errorMessage != null) {
                message.errorMessage = data.errorMessage;
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_1.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.completedAt != null) {
                message.completedAt = dependency_1.google.protobuf.Timestamp.fromObject(data.completedAt);
            }
            if (data.cardNumberMaskedBin != null) {
                message.cardNumberMaskedBin = data.cardNumberMaskedBin;
            }
            if (data.providerErrorCode != null) {
                message.providerErrorCode = data.providerErrorCode;
            }
            if (data.providerRawError != null) {
                message.providerRawError = data.providerRawError;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                status?: PaymentStatus;
                method?: PaymentMethod;
                cardType?: CardType;
                cardLastFour?: string;
                errorCode?: string;
                errorMessage?: string;
                createdAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                completedAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                cardNumberMaskedBin?: string;
                providerErrorCode?: string;
                providerRawError?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.method != null) {
                data.method = this.method;
            }
            if (this.cardType != null) {
                data.cardType = this.cardType;
            }
            if (this.cardLastFour != null) {
                data.cardLastFour = this.cardLastFour;
            }
            if (this.errorCode != null) {
                data.errorCode = this.errorCode;
            }
            if (this.errorMessage != null) {
                data.errorMessage = this.errorMessage;
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.completedAt != null) {
                data.completedAt = this.completedAt.toObject();
            }
            if (this.cardNumberMaskedBin != null) {
                data.cardNumberMaskedBin = this.cardNumberMaskedBin;
            }
            if (this.providerErrorCode != null) {
                data.providerErrorCode = this.providerErrorCode;
            }
            if (this.providerRawError != null) {
                data.providerRawError = this.providerRawError;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.status != PaymentStatus.PAYMENT_STATUS_UNSPECIFIED)
                writer.writeEnum(2, this.status);
            if (this.method != PaymentMethod.PAYMENT_METHOD_UNSPECIFIED)
                writer.writeEnum(3, this.method);
            if (this.cardType != CardType.CARD_TYPE_UNSPECIFIED)
                writer.writeEnum(4, this.cardType);
            if (this.cardLastFour.length)
                writer.writeString(5, this.cardLastFour);
            if (this.errorCode.length)
                writer.writeString(6, this.errorCode);
            if (this.errorMessage.length)
                writer.writeString(7, this.errorMessage);
            if (this.hasCreatedAt)
                writer.writeMessage(8, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.hasCompletedAt)
                writer.writeMessage(9, this.completedAt, () => this.completedAt.serialize(writer));
            if (this.cardNumberMaskedBin.length)
                writer.writeString(10, this.cardNumberMaskedBin);
            if (this.providerErrorCode.length)
                writer.writeString(11, this.providerErrorCode);
            if (this.providerRawError.length)
                writer.writeString(12, this.providerRawError);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaymentAttempt {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PaymentAttempt();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.status = reader.readEnum();
                        break;
                    case 3:
                        message.method = reader.readEnum();
                        break;
                    case 4:
                        message.cardType = reader.readEnum();
                        break;
                    case 5:
                        message.cardLastFour = reader.readString();
                        break;
                    case 6:
                        message.errorCode = reader.readString();
                        break;
                    case 7:
                        message.errorMessage = reader.readString();
                        break;
                    case 8:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 9:
                        reader.readMessage(message.completedAt, () => message.completedAt = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 10:
                        message.cardNumberMaskedBin = reader.readString();
                        break;
                    case 11:
                        message.providerErrorCode = reader.readString();
                        break;
                    case 12:
                        message.providerRawError = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PaymentAttempt {
            return PaymentAttempt.deserialize(bytes);
        }
    }
    export class Product extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            name?: string;
            type?: ProductType;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 3, ProductType.PRODUCT_TYPE_UNSPECIFIED) as ProductType;
        }
        set type(value: ProductType) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            id?: string;
            name?: string;
            type?: ProductType;
        }): Product {
            const message = new Product({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.type != null) {
                message.type = data.type;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                name?: string;
                type?: ProductType;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.type != null) {
                data.type = this.type;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.name.length)
                writer.writeString(2, this.name);
            if (this.type != ProductType.PRODUCT_TYPE_UNSPECIFIED)
                writer.writeEnum(3, this.type);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Product {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Product();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.name = reader.readString();
                        break;
                    case 3:
                        message.type = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Product {
            return Product.deserialize(bytes);
        }
    }
    export class Customer extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            name?: string;
            email?: string;
            document?: string;
            externalId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("document" in data && data.document != undefined) {
                    this.document = data.document;
                }
                if ("externalId" in data && data.externalId != undefined) {
                    this.externalId = data.externalId;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get document() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set document(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get externalId() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set externalId(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            id?: string;
            name?: string;
            email?: string;
            document?: string;
            externalId?: string;
        }): Customer {
            const message = new Customer({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.document != null) {
                message.document = data.document;
            }
            if (data.externalId != null) {
                message.externalId = data.externalId;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                name?: string;
                email?: string;
                document?: string;
                externalId?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.document != null) {
                data.document = this.document;
            }
            if (this.externalId != null) {
                data.externalId = this.externalId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.name.length)
                writer.writeString(2, this.name);
            if (this.email.length)
                writer.writeString(3, this.email);
            if (this.document.length)
                writer.writeString(4, this.document);
            if (this.externalId.length)
                writer.writeString(5, this.externalId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Customer {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Customer();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.name = reader.readString();
                        break;
                    case 3:
                        message.email = reader.readString();
                        break;
                    case 4:
                        message.document = reader.readString();
                        break;
                    case 5:
                        message.externalId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Customer {
            return Customer.deserialize(bytes);
        }
    }
    export class PaymentStatusHistory extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            status?: PaymentStatus;
            updatedAt?: dependency_1.google.protobuf.Timestamp;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("updatedAt" in data && data.updatedAt != undefined) {
                    this.updatedAt = data.updatedAt;
                }
            }
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 1, PaymentStatus.PAYMENT_STATUS_UNSPECIFIED) as PaymentStatus;
        }
        set status(value: PaymentStatus) {
            pb_1.Message.setField(this, 1, value);
        }
        get updatedAt() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 2) as dependency_1.google.protobuf.Timestamp;
        }
        set updatedAt(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasUpdatedAt() {
            return pb_1.Message.getField(this, 2) != null;
        }
        static fromObject(data: {
            status?: PaymentStatus;
            updatedAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
        }): PaymentStatusHistory {
            const message = new PaymentStatusHistory({});
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.updatedAt != null) {
                message.updatedAt = dependency_1.google.protobuf.Timestamp.fromObject(data.updatedAt);
            }
            return message;
        }
        toObject() {
            const data: {
                status?: PaymentStatus;
                updatedAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.updatedAt != null) {
                data.updatedAt = this.updatedAt.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.status != PaymentStatus.PAYMENT_STATUS_UNSPECIFIED)
                writer.writeEnum(1, this.status);
            if (this.hasUpdatedAt)
                writer.writeMessage(2, this.updatedAt, () => this.updatedAt.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaymentStatusHistory {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PaymentStatusHistory();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.status = reader.readEnum();
                        break;
                    case 2:
                        reader.readMessage(message.updatedAt, () => message.updatedAt = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PaymentStatusHistory {
            return PaymentStatusHistory.deserialize(bytes);
        }
    }
    export class PaymentDetails extends pb_1.Message {
        #one_of_decls: number[][] = [[1, 2, 3, 4, 5, 6]];
        constructor(data?: any[] | ({} & (({
            pix?: PixDetails;
            bankSlip?: never;
            card?: never;
            bankSlipAndPixPaymentDetails?: never;
            commitmentDetails?: never;
            autoSettlementDetails?: never;
        } | {
            pix?: never;
            bankSlip?: BankSlipDetails;
            card?: never;
            bankSlipAndPixPaymentDetails?: never;
            commitmentDetails?: never;
            autoSettlementDetails?: never;
        } | {
            pix?: never;
            bankSlip?: never;
            card?: CardDetails;
            bankSlipAndPixPaymentDetails?: never;
            commitmentDetails?: never;
            autoSettlementDetails?: never;
        } | {
            pix?: never;
            bankSlip?: never;
            card?: never;
            bankSlipAndPixPaymentDetails?: BankSlipAndPixPaymentDetails;
            commitmentDetails?: never;
            autoSettlementDetails?: never;
        } | {
            pix?: never;
            bankSlip?: never;
            card?: never;
            bankSlipAndPixPaymentDetails?: never;
            commitmentDetails?: CommitmentDetails;
            autoSettlementDetails?: never;
        } | {
            pix?: never;
            bankSlip?: never;
            card?: never;
            bankSlipAndPixPaymentDetails?: never;
            commitmentDetails?: never;
            autoSettlementDetails?: AutoSettlementPaymentDetails;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("pix" in data && data.pix != undefined) {
                    this.pix = data.pix;
                }
                if ("bankSlip" in data && data.bankSlip != undefined) {
                    this.bankSlip = data.bankSlip;
                }
                if ("card" in data && data.card != undefined) {
                    this.card = data.card;
                }
                if ("bankSlipAndPixPaymentDetails" in data && data.bankSlipAndPixPaymentDetails != undefined) {
                    this.bankSlipAndPixPaymentDetails = data.bankSlipAndPixPaymentDetails;
                }
                if ("commitmentDetails" in data && data.commitmentDetails != undefined) {
                    this.commitmentDetails = data.commitmentDetails;
                }
                if ("autoSettlementDetails" in data && data.autoSettlementDetails != undefined) {
                    this.autoSettlementDetails = data.autoSettlementDetails;
                }
            }
        }
        get pix() {
            return pb_1.Message.getWrapperField(this, PixDetails, 1) as PixDetails;
        }
        set pix(value: PixDetails) {
            pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
        }
        get hasPix() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get bankSlip() {
            return pb_1.Message.getWrapperField(this, BankSlipDetails, 2) as BankSlipDetails;
        }
        set bankSlip(value: BankSlipDetails) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
        }
        get hasBankSlip() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get card() {
            return pb_1.Message.getWrapperField(this, CardDetails, 3) as CardDetails;
        }
        set card(value: CardDetails) {
            pb_1.Message.setOneofWrapperField(this, 3, this.#one_of_decls[0], value);
        }
        get hasCard() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get bankSlipAndPixPaymentDetails() {
            return pb_1.Message.getWrapperField(this, BankSlipAndPixPaymentDetails, 4) as BankSlipAndPixPaymentDetails;
        }
        set bankSlipAndPixPaymentDetails(value: BankSlipAndPixPaymentDetails) {
            pb_1.Message.setOneofWrapperField(this, 4, this.#one_of_decls[0], value);
        }
        get hasBankSlipAndPixPaymentDetails() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get commitmentDetails() {
            return pb_1.Message.getWrapperField(this, CommitmentDetails, 5) as CommitmentDetails;
        }
        set commitmentDetails(value: CommitmentDetails) {
            pb_1.Message.setOneofWrapperField(this, 5, this.#one_of_decls[0], value);
        }
        get hasCommitmentDetails() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get autoSettlementDetails() {
            return pb_1.Message.getWrapperField(this, AutoSettlementPaymentDetails, 6) as AutoSettlementPaymentDetails;
        }
        set autoSettlementDetails(value: AutoSettlementPaymentDetails) {
            pb_1.Message.setOneofWrapperField(this, 6, this.#one_of_decls[0], value);
        }
        get hasAutoSettlementDetails() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get details() {
            const cases: {
                [index: number]: "none" | "pix" | "bankSlip" | "card" | "bankSlipAndPixPaymentDetails" | "commitmentDetails" | "autoSettlementDetails";
            } = {
                0: "none",
                1: "pix",
                2: "bankSlip",
                3: "card",
                4: "bankSlipAndPixPaymentDetails",
                5: "commitmentDetails",
                6: "autoSettlementDetails"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 2, 3, 4, 5, 6])];
        }
        static fromObject(data: {
            pix?: ReturnType<typeof PixDetails.prototype.toObject>;
            bankSlip?: ReturnType<typeof BankSlipDetails.prototype.toObject>;
            card?: ReturnType<typeof CardDetails.prototype.toObject>;
            bankSlipAndPixPaymentDetails?: ReturnType<typeof BankSlipAndPixPaymentDetails.prototype.toObject>;
            commitmentDetails?: ReturnType<typeof CommitmentDetails.prototype.toObject>;
            autoSettlementDetails?: ReturnType<typeof AutoSettlementPaymentDetails.prototype.toObject>;
        }): PaymentDetails {
            const message = new PaymentDetails({});
            if (data.pix != null) {
                message.pix = PixDetails.fromObject(data.pix);
            }
            if (data.bankSlip != null) {
                message.bankSlip = BankSlipDetails.fromObject(data.bankSlip);
            }
            if (data.card != null) {
                message.card = CardDetails.fromObject(data.card);
            }
            if (data.bankSlipAndPixPaymentDetails != null) {
                message.bankSlipAndPixPaymentDetails = BankSlipAndPixPaymentDetails.fromObject(data.bankSlipAndPixPaymentDetails);
            }
            if (data.commitmentDetails != null) {
                message.commitmentDetails = CommitmentDetails.fromObject(data.commitmentDetails);
            }
            if (data.autoSettlementDetails != null) {
                message.autoSettlementDetails = AutoSettlementPaymentDetails.fromObject(data.autoSettlementDetails);
            }
            return message;
        }
        toObject() {
            const data: {
                pix?: ReturnType<typeof PixDetails.prototype.toObject>;
                bankSlip?: ReturnType<typeof BankSlipDetails.prototype.toObject>;
                card?: ReturnType<typeof CardDetails.prototype.toObject>;
                bankSlipAndPixPaymentDetails?: ReturnType<typeof BankSlipAndPixPaymentDetails.prototype.toObject>;
                commitmentDetails?: ReturnType<typeof CommitmentDetails.prototype.toObject>;
                autoSettlementDetails?: ReturnType<typeof AutoSettlementPaymentDetails.prototype.toObject>;
            } = {};
            if (this.pix != null) {
                data.pix = this.pix.toObject();
            }
            if (this.bankSlip != null) {
                data.bankSlip = this.bankSlip.toObject();
            }
            if (this.card != null) {
                data.card = this.card.toObject();
            }
            if (this.bankSlipAndPixPaymentDetails != null) {
                data.bankSlipAndPixPaymentDetails = this.bankSlipAndPixPaymentDetails.toObject();
            }
            if (this.commitmentDetails != null) {
                data.commitmentDetails = this.commitmentDetails.toObject();
            }
            if (this.autoSettlementDetails != null) {
                data.autoSettlementDetails = this.autoSettlementDetails.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPix)
                writer.writeMessage(1, this.pix, () => this.pix.serialize(writer));
            if (this.hasBankSlip)
                writer.writeMessage(2, this.bankSlip, () => this.bankSlip.serialize(writer));
            if (this.hasCard)
                writer.writeMessage(3, this.card, () => this.card.serialize(writer));
            if (this.hasBankSlipAndPixPaymentDetails)
                writer.writeMessage(4, this.bankSlipAndPixPaymentDetails, () => this.bankSlipAndPixPaymentDetails.serialize(writer));
            if (this.hasCommitmentDetails)
                writer.writeMessage(5, this.commitmentDetails, () => this.commitmentDetails.serialize(writer));
            if (this.hasAutoSettlementDetails)
                writer.writeMessage(6, this.autoSettlementDetails, () => this.autoSettlementDetails.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaymentDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PaymentDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.pix, () => message.pix = PixDetails.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.bankSlip, () => message.bankSlip = BankSlipDetails.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message.card, () => message.card = CardDetails.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.bankSlipAndPixPaymentDetails, () => message.bankSlipAndPixPaymentDetails = BankSlipAndPixPaymentDetails.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message.commitmentDetails, () => message.commitmentDetails = CommitmentDetails.deserialize(reader));
                        break;
                    case 6:
                        reader.readMessage(message.autoSettlementDetails, () => message.autoSettlementDetails = AutoSettlementPaymentDetails.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PaymentDetails {
            return PaymentDetails.deserialize(bytes);
        }
    }
    export class PixDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            qrCode?: string;
            pixKey?: string;
            pixKeyType?: string;
            endToEndId?: string;
            txId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("qrCode" in data && data.qrCode != undefined) {
                    this.qrCode = data.qrCode;
                }
                if ("pixKey" in data && data.pixKey != undefined) {
                    this.pixKey = data.pixKey;
                }
                if ("pixKeyType" in data && data.pixKeyType != undefined) {
                    this.pixKeyType = data.pixKeyType;
                }
                if ("endToEndId" in data && data.endToEndId != undefined) {
                    this.endToEndId = data.endToEndId;
                }
                if ("txId" in data && data.txId != undefined) {
                    this.txId = data.txId;
                }
            }
        }
        get qrCode() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set qrCode(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get pixKey() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set pixKey(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get pixKeyType() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set pixKeyType(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get endToEndId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set endToEndId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get txId() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set txId(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            qrCode?: string;
            pixKey?: string;
            pixKeyType?: string;
            endToEndId?: string;
            txId?: string;
        }): PixDetails {
            const message = new PixDetails({});
            if (data.qrCode != null) {
                message.qrCode = data.qrCode;
            }
            if (data.pixKey != null) {
                message.pixKey = data.pixKey;
            }
            if (data.pixKeyType != null) {
                message.pixKeyType = data.pixKeyType;
            }
            if (data.endToEndId != null) {
                message.endToEndId = data.endToEndId;
            }
            if (data.txId != null) {
                message.txId = data.txId;
            }
            return message;
        }
        toObject() {
            const data: {
                qrCode?: string;
                pixKey?: string;
                pixKeyType?: string;
                endToEndId?: string;
                txId?: string;
            } = {};
            if (this.qrCode != null) {
                data.qrCode = this.qrCode;
            }
            if (this.pixKey != null) {
                data.pixKey = this.pixKey;
            }
            if (this.pixKeyType != null) {
                data.pixKeyType = this.pixKeyType;
            }
            if (this.endToEndId != null) {
                data.endToEndId = this.endToEndId;
            }
            if (this.txId != null) {
                data.txId = this.txId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.qrCode.length)
                writer.writeString(1, this.qrCode);
            if (this.pixKey.length)
                writer.writeString(2, this.pixKey);
            if (this.pixKeyType.length)
                writer.writeString(3, this.pixKeyType);
            if (this.endToEndId.length)
                writer.writeString(4, this.endToEndId);
            if (this.txId.length)
                writer.writeString(5, this.txId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PixDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PixDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.qrCode = reader.readString();
                        break;
                    case 2:
                        message.pixKey = reader.readString();
                        break;
                    case 3:
                        message.pixKeyType = reader.readString();
                        break;
                    case 4:
                        message.endToEndId = reader.readString();
                        break;
                    case 5:
                        message.txId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PixDetails {
            return PixDetails.deserialize(bytes);
        }
    }
    export class BankSlipDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            boletoNumber?: string;
            barcode?: string;
            digitableLine?: string;
            expiresAt?: dependency_1.google.protobuf.Timestamp;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("boletoNumber" in data && data.boletoNumber != undefined) {
                    this.boletoNumber = data.boletoNumber;
                }
                if ("barcode" in data && data.barcode != undefined) {
                    this.barcode = data.barcode;
                }
                if ("digitableLine" in data && data.digitableLine != undefined) {
                    this.digitableLine = data.digitableLine;
                }
                if ("expiresAt" in data && data.expiresAt != undefined) {
                    this.expiresAt = data.expiresAt;
                }
            }
        }
        get boletoNumber() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set boletoNumber(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get barcode() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set barcode(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get digitableLine() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set digitableLine(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get expiresAt() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 4) as dependency_1.google.protobuf.Timestamp;
        }
        set expiresAt(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasExpiresAt() {
            return pb_1.Message.getField(this, 4) != null;
        }
        static fromObject(data: {
            boletoNumber?: string;
            barcode?: string;
            digitableLine?: string;
            expiresAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
        }): BankSlipDetails {
            const message = new BankSlipDetails({});
            if (data.boletoNumber != null) {
                message.boletoNumber = data.boletoNumber;
            }
            if (data.barcode != null) {
                message.barcode = data.barcode;
            }
            if (data.digitableLine != null) {
                message.digitableLine = data.digitableLine;
            }
            if (data.expiresAt != null) {
                message.expiresAt = dependency_1.google.protobuf.Timestamp.fromObject(data.expiresAt);
            }
            return message;
        }
        toObject() {
            const data: {
                boletoNumber?: string;
                barcode?: string;
                digitableLine?: string;
                expiresAt?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.boletoNumber != null) {
                data.boletoNumber = this.boletoNumber;
            }
            if (this.barcode != null) {
                data.barcode = this.barcode;
            }
            if (this.digitableLine != null) {
                data.digitableLine = this.digitableLine;
            }
            if (this.expiresAt != null) {
                data.expiresAt = this.expiresAt.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.boletoNumber.length)
                writer.writeString(1, this.boletoNumber);
            if (this.barcode.length)
                writer.writeString(2, this.barcode);
            if (this.digitableLine.length)
                writer.writeString(3, this.digitableLine);
            if (this.hasExpiresAt)
                writer.writeMessage(4, this.expiresAt, () => this.expiresAt.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): BankSlipDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BankSlipDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.boletoNumber = reader.readString();
                        break;
                    case 2:
                        message.barcode = reader.readString();
                        break;
                    case 3:
                        message.digitableLine = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.expiresAt, () => message.expiresAt = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): BankSlipDetails {
            return BankSlipDetails.deserialize(bytes);
        }
    }
    export class CardDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            lastFourDigits?: string;
            brand?: dependency_3.tokenizer.v1.Brand;
            authCode?: string;
            nsu?: string;
            tid?: string;
            installments?: number;
            type?: CardType;
            numberMaskBin?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("lastFourDigits" in data && data.lastFourDigits != undefined) {
                    this.lastFourDigits = data.lastFourDigits;
                }
                if ("brand" in data && data.brand != undefined) {
                    this.brand = data.brand;
                }
                if ("authCode" in data && data.authCode != undefined) {
                    this.authCode = data.authCode;
                }
                if ("nsu" in data && data.nsu != undefined) {
                    this.nsu = data.nsu;
                }
                if ("tid" in data && data.tid != undefined) {
                    this.tid = data.tid;
                }
                if ("installments" in data && data.installments != undefined) {
                    this.installments = data.installments;
                }
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
                if ("numberMaskBin" in data && data.numberMaskBin != undefined) {
                    this.numberMaskBin = data.numberMaskBin;
                }
            }
        }
        get lastFourDigits() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set lastFourDigits(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get brand() {
            return pb_1.Message.getFieldWithDefault(this, 2, dependency_3.tokenizer.v1.Brand.BRAND_UNSPECIFIED) as dependency_3.tokenizer.v1.Brand;
        }
        set brand(value: dependency_3.tokenizer.v1.Brand) {
            pb_1.Message.setField(this, 2, value);
        }
        get authCode() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set authCode(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get nsu() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set nsu(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get tid() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set tid(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get installments() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set installments(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 7, CardType.CARD_TYPE_UNSPECIFIED) as CardType;
        }
        set type(value: CardType) {
            pb_1.Message.setField(this, 7, value);
        }
        get numberMaskBin() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set numberMaskBin(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            lastFourDigits?: string;
            brand?: dependency_3.tokenizer.v1.Brand;
            authCode?: string;
            nsu?: string;
            tid?: string;
            installments?: number;
            type?: CardType;
            numberMaskBin?: string;
        }): CardDetails {
            const message = new CardDetails({});
            if (data.lastFourDigits != null) {
                message.lastFourDigits = data.lastFourDigits;
            }
            if (data.brand != null) {
                message.brand = data.brand;
            }
            if (data.authCode != null) {
                message.authCode = data.authCode;
            }
            if (data.nsu != null) {
                message.nsu = data.nsu;
            }
            if (data.tid != null) {
                message.tid = data.tid;
            }
            if (data.installments != null) {
                message.installments = data.installments;
            }
            if (data.type != null) {
                message.type = data.type;
            }
            if (data.numberMaskBin != null) {
                message.numberMaskBin = data.numberMaskBin;
            }
            return message;
        }
        toObject() {
            const data: {
                lastFourDigits?: string;
                brand?: dependency_3.tokenizer.v1.Brand;
                authCode?: string;
                nsu?: string;
                tid?: string;
                installments?: number;
                type?: CardType;
                numberMaskBin?: string;
            } = {};
            if (this.lastFourDigits != null) {
                data.lastFourDigits = this.lastFourDigits;
            }
            if (this.brand != null) {
                data.brand = this.brand;
            }
            if (this.authCode != null) {
                data.authCode = this.authCode;
            }
            if (this.nsu != null) {
                data.nsu = this.nsu;
            }
            if (this.tid != null) {
                data.tid = this.tid;
            }
            if (this.installments != null) {
                data.installments = this.installments;
            }
            if (this.type != null) {
                data.type = this.type;
            }
            if (this.numberMaskBin != null) {
                data.numberMaskBin = this.numberMaskBin;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.lastFourDigits.length)
                writer.writeString(1, this.lastFourDigits);
            if (this.brand != dependency_3.tokenizer.v1.Brand.BRAND_UNSPECIFIED)
                writer.writeEnum(2, this.brand);
            if (this.authCode.length)
                writer.writeString(3, this.authCode);
            if (this.nsu.length)
                writer.writeString(4, this.nsu);
            if (this.tid.length)
                writer.writeString(5, this.tid);
            if (this.installments != 0)
                writer.writeInt32(6, this.installments);
            if (this.type != CardType.CARD_TYPE_UNSPECIFIED)
                writer.writeEnum(7, this.type);
            if (this.numberMaskBin.length)
                writer.writeString(8, this.numberMaskBin);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CardDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CardDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.lastFourDigits = reader.readString();
                        break;
                    case 2:
                        message.brand = reader.readEnum();
                        break;
                    case 3:
                        message.authCode = reader.readString();
                        break;
                    case 4:
                        message.nsu = reader.readString();
                        break;
                    case 5:
                        message.tid = reader.readString();
                        break;
                    case 6:
                        message.installments = reader.readInt32();
                        break;
                    case 7:
                        message.type = reader.readEnum();
                        break;
                    case 8:
                        message.numberMaskBin = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CardDetails {
            return CardDetails.deserialize(bytes);
        }
    }
    export class GetPaymentRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            paymentId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("paymentId" in data && data.paymentId != undefined) {
                    this.paymentId = data.paymentId;
                }
            }
        }
        get paymentId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set paymentId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            paymentId?: string;
        }): GetPaymentRequest {
            const message = new GetPaymentRequest({});
            if (data.paymentId != null) {
                message.paymentId = data.paymentId;
            }
            return message;
        }
        toObject() {
            const data: {
                paymentId?: string;
            } = {};
            if (this.paymentId != null) {
                data.paymentId = this.paymentId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.paymentId.length)
                writer.writeString(1, this.paymentId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPaymentRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetPaymentRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.paymentId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetPaymentRequest {
            return GetPaymentRequest.deserialize(bytes);
        }
    }
    export class GetPaymentResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            payment?: Payment;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("payment" in data && data.payment != undefined) {
                    this.payment = data.payment;
                }
            }
        }
        get payment() {
            return pb_1.Message.getWrapperField(this, Payment, 1) as Payment;
        }
        set payment(value: Payment) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasPayment() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            payment?: ReturnType<typeof Payment.prototype.toObject>;
        }): GetPaymentResponse {
            const message = new GetPaymentResponse({});
            if (data.payment != null) {
                message.payment = Payment.fromObject(data.payment);
            }
            return message;
        }
        toObject() {
            const data: {
                payment?: ReturnType<typeof Payment.prototype.toObject>;
            } = {};
            if (this.payment != null) {
                data.payment = this.payment.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPayment)
                writer.writeMessage(1, this.payment, () => this.payment.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPaymentResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetPaymentResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.payment, () => message.payment = Payment.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetPaymentResponse {
            return GetPaymentResponse.deserialize(bytes);
        }
    }
    export class GetPaymentByOrderIDRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            orderId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("orderId" in data && data.orderId != undefined) {
                    this.orderId = data.orderId;
                }
            }
        }
        get orderId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set orderId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            orderId?: string;
        }): GetPaymentByOrderIDRequest {
            const message = new GetPaymentByOrderIDRequest({});
            if (data.orderId != null) {
                message.orderId = data.orderId;
            }
            return message;
        }
        toObject() {
            const data: {
                orderId?: string;
            } = {};
            if (this.orderId != null) {
                data.orderId = this.orderId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.orderId.length)
                writer.writeString(1, this.orderId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPaymentByOrderIDRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetPaymentByOrderIDRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.orderId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetPaymentByOrderIDRequest {
            return GetPaymentByOrderIDRequest.deserialize(bytes);
        }
    }
    export class GetPaymentByOrderIDResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            payment?: Payment;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("payment" in data && data.payment != undefined) {
                    this.payment = data.payment;
                }
            }
        }
        get payment() {
            return pb_1.Message.getWrapperField(this, Payment, 1) as Payment;
        }
        set payment(value: Payment) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasPayment() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            payment?: ReturnType<typeof Payment.prototype.toObject>;
        }): GetPaymentByOrderIDResponse {
            const message = new GetPaymentByOrderIDResponse({});
            if (data.payment != null) {
                message.payment = Payment.fromObject(data.payment);
            }
            return message;
        }
        toObject() {
            const data: {
                payment?: ReturnType<typeof Payment.prototype.toObject>;
            } = {};
            if (this.payment != null) {
                data.payment = this.payment.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPayment)
                writer.writeMessage(1, this.payment, () => this.payment.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPaymentByOrderIDResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetPaymentByOrderIDResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.payment, () => message.payment = Payment.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetPaymentByOrderIDResponse {
            return GetPaymentByOrderIDResponse.deserialize(bytes);
        }
    }
    export class ListPaymentsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            organizationId?: string;
            workspaceId?: string;
            customerId?: string;
            status?: PaymentStatus[];
            startDate?: dependency_1.google.protobuf.Timestamp;
            endDate?: dependency_1.google.protobuf.Timestamp;
            pageSize?: number;
            page?: number;
            orderId?: string;
            paymentType?: PaymentType[];
            productId?: string[];
            customerUsername?: string;
            method?: PaymentMethod[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4, 11, 12, 14], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("customerId" in data && data.customerId != undefined) {
                    this.customerId = data.customerId;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("startDate" in data && data.startDate != undefined) {
                    this.startDate = data.startDate;
                }
                if ("endDate" in data && data.endDate != undefined) {
                    this.endDate = data.endDate;
                }
                if ("pageSize" in data && data.pageSize != undefined) {
                    this.pageSize = data.pageSize;
                }
                if ("page" in data && data.page != undefined) {
                    this.page = data.page;
                }
                if ("orderId" in data && data.orderId != undefined) {
                    this.orderId = data.orderId;
                }
                if ("paymentType" in data && data.paymentType != undefined) {
                    this.paymentType = data.paymentType;
                }
                if ("productId" in data && data.productId != undefined) {
                    this.productId = data.productId;
                }
                if ("customerUsername" in data && data.customerUsername != undefined) {
                    this.customerUsername = data.customerUsername;
                }
                if ("method" in data && data.method != undefined) {
                    this.method = data.method;
                }
            }
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get customerId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set customerId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 4, []) as PaymentStatus[];
        }
        set status(value: PaymentStatus[]) {
            pb_1.Message.setField(this, 4, value);
        }
        get startDate() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 6) as dependency_1.google.protobuf.Timestamp;
        }
        set startDate(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get hasStartDate() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get endDate() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 7) as dependency_1.google.protobuf.Timestamp;
        }
        set endDate(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get hasEndDate() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get pageSize() {
            return pb_1.Message.getFieldWithDefault(this, 8, 0) as number;
        }
        set pageSize(value: number) {
            pb_1.Message.setField(this, 8, value);
        }
        get page() {
            return pb_1.Message.getFieldWithDefault(this, 9, 0) as number;
        }
        set page(value: number) {
            pb_1.Message.setField(this, 9, value);
        }
        get orderId() {
            return pb_1.Message.getFieldWithDefault(this, 10, "") as string;
        }
        set orderId(value: string) {
            pb_1.Message.setField(this, 10, value);
        }
        get paymentType() {
            return pb_1.Message.getRepeatedWrapperField(this, PaymentType, 11) as PaymentType[];
        }
        set paymentType(value: PaymentType[]) {
            pb_1.Message.setRepeatedWrapperField(this, 11, value);
        }
        get productId() {
            return pb_1.Message.getFieldWithDefault(this, 12, []) as string[];
        }
        set productId(value: string[]) {
            pb_1.Message.setField(this, 12, value);
        }
        get customerUsername() {
            return pb_1.Message.getFieldWithDefault(this, 13, "") as string;
        }
        set customerUsername(value: string) {
            pb_1.Message.setField(this, 13, value);
        }
        get method() {
            return pb_1.Message.getFieldWithDefault(this, 14, []) as PaymentMethod[];
        }
        set method(value: PaymentMethod[]) {
            pb_1.Message.setField(this, 14, value);
        }
        static fromObject(data: {
            organizationId?: string;
            workspaceId?: string;
            customerId?: string;
            status?: PaymentStatus[];
            startDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            endDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            pageSize?: number;
            page?: number;
            orderId?: string;
            paymentType?: ReturnType<typeof PaymentType.prototype.toObject>[];
            productId?: string[];
            customerUsername?: string;
            method?: PaymentMethod[];
        }): ListPaymentsRequest {
            const message = new ListPaymentsRequest({});
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.customerId != null) {
                message.customerId = data.customerId;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.startDate != null) {
                message.startDate = dependency_1.google.protobuf.Timestamp.fromObject(data.startDate);
            }
            if (data.endDate != null) {
                message.endDate = dependency_1.google.protobuf.Timestamp.fromObject(data.endDate);
            }
            if (data.pageSize != null) {
                message.pageSize = data.pageSize;
            }
            if (data.page != null) {
                message.page = data.page;
            }
            if (data.orderId != null) {
                message.orderId = data.orderId;
            }
            if (data.paymentType != null) {
                message.paymentType = data.paymentType.map(item => PaymentType.fromObject(item));
            }
            if (data.productId != null) {
                message.productId = data.productId;
            }
            if (data.customerUsername != null) {
                message.customerUsername = data.customerUsername;
            }
            if (data.method != null) {
                message.method = data.method;
            }
            return message;
        }
        toObject() {
            const data: {
                organizationId?: string;
                workspaceId?: string;
                customerId?: string;
                status?: PaymentStatus[];
                startDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                endDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                pageSize?: number;
                page?: number;
                orderId?: string;
                paymentType?: ReturnType<typeof PaymentType.prototype.toObject>[];
                productId?: string[];
                customerUsername?: string;
                method?: PaymentMethod[];
            } = {};
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.customerId != null) {
                data.customerId = this.customerId;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.startDate != null) {
                data.startDate = this.startDate.toObject();
            }
            if (this.endDate != null) {
                data.endDate = this.endDate.toObject();
            }
            if (this.pageSize != null) {
                data.pageSize = this.pageSize;
            }
            if (this.page != null) {
                data.page = this.page;
            }
            if (this.orderId != null) {
                data.orderId = this.orderId;
            }
            if (this.paymentType != null) {
                data.paymentType = this.paymentType.map((item: PaymentType) => item.toObject());
            }
            if (this.productId != null) {
                data.productId = this.productId;
            }
            if (this.customerUsername != null) {
                data.customerUsername = this.customerUsername;
            }
            if (this.method != null) {
                data.method = this.method;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.organizationId.length)
                writer.writeString(1, this.organizationId);
            if (this.workspaceId.length)
                writer.writeString(2, this.workspaceId);
            if (this.customerId.length)
                writer.writeString(3, this.customerId);
            if (this.status.length)
                writer.writePackedEnum(4, this.status);
            if (this.hasStartDate)
                writer.writeMessage(6, this.startDate, () => this.startDate.serialize(writer));
            if (this.hasEndDate)
                writer.writeMessage(7, this.endDate, () => this.endDate.serialize(writer));
            if (this.pageSize != 0)
                writer.writeInt32(8, this.pageSize);
            if (this.page != 0)
                writer.writeInt32(9, this.page);
            if (this.orderId.length)
                writer.writeString(10, this.orderId);
            if (this.paymentType.length)
                writer.writeRepeatedMessage(11, this.paymentType, (item: PaymentType) => item.serialize(writer));
            if (this.productId.length)
                writer.writeRepeatedString(12, this.productId);
            if (this.customerUsername.length)
                writer.writeString(13, this.customerUsername);
            if (this.method.length)
                writer.writePackedEnum(14, this.method);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListPaymentsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListPaymentsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.organizationId = reader.readString();
                        break;
                    case 2:
                        message.workspaceId = reader.readString();
                        break;
                    case 3:
                        message.customerId = reader.readString();
                        break;
                    case 4:
                        message.status = reader.readPackedEnum();
                        break;
                    case 6:
                        reader.readMessage(message.startDate, () => message.startDate = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 7:
                        reader.readMessage(message.endDate, () => message.endDate = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 8:
                        message.pageSize = reader.readInt32();
                        break;
                    case 9:
                        message.page = reader.readInt32();
                        break;
                    case 10:
                        message.orderId = reader.readString();
                        break;
                    case 11:
                        reader.readMessage(message.paymentType, () => pb_1.Message.addToRepeatedWrapperField(message, 11, PaymentType.deserialize(reader), PaymentType));
                        break;
                    case 12:
                        pb_1.Message.addToRepeatedField(message, 12, reader.readString());
                        break;
                    case 13:
                        message.customerUsername = reader.readString();
                        break;
                    case 14:
                        message.method = reader.readPackedEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListPaymentsRequest {
            return ListPaymentsRequest.deserialize(bytes);
        }
    }
    export class ListPaymentsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            payments?: Payment[];
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("payments" in data && data.payments != undefined) {
                    this.payments = data.payments;
                }
                if ("totalCount" in data && data.totalCount != undefined) {
                    this.totalCount = data.totalCount;
                }
                if ("totalPages" in data && data.totalPages != undefined) {
                    this.totalPages = data.totalPages;
                }
                if ("hasNext" in data && data.hasNext != undefined) {
                    this.hasNext = data.hasNext;
                }
                if ("hasPrev" in data && data.hasPrev != undefined) {
                    this.hasPrev = data.hasPrev;
                }
            }
        }
        get payments() {
            return pb_1.Message.getRepeatedWrapperField(this, Payment, 1) as Payment[];
        }
        set payments(value: Payment[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        get totalCount() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set totalCount(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get totalPages() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set totalPages(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get hasNext() {
            return pb_1.Message.getFieldWithDefault(this, 4, false) as boolean;
        }
        set hasNext(value: boolean) {
            pb_1.Message.setField(this, 4, value);
        }
        get hasPrev() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set hasPrev(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            payments?: ReturnType<typeof Payment.prototype.toObject>[];
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
        }): ListPaymentsResponse {
            const message = new ListPaymentsResponse({});
            if (data.payments != null) {
                message.payments = data.payments.map(item => Payment.fromObject(item));
            }
            if (data.totalCount != null) {
                message.totalCount = data.totalCount;
            }
            if (data.totalPages != null) {
                message.totalPages = data.totalPages;
            }
            if (data.hasNext != null) {
                message.hasNext = data.hasNext;
            }
            if (data.hasPrev != null) {
                message.hasPrev = data.hasPrev;
            }
            return message;
        }
        toObject() {
            const data: {
                payments?: ReturnType<typeof Payment.prototype.toObject>[];
                totalCount?: number;
                totalPages?: number;
                hasNext?: boolean;
                hasPrev?: boolean;
            } = {};
            if (this.payments != null) {
                data.payments = this.payments.map((item: Payment) => item.toObject());
            }
            if (this.totalCount != null) {
                data.totalCount = this.totalCount;
            }
            if (this.totalPages != null) {
                data.totalPages = this.totalPages;
            }
            if (this.hasNext != null) {
                data.hasNext = this.hasNext;
            }
            if (this.hasPrev != null) {
                data.hasPrev = this.hasPrev;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.payments.length)
                writer.writeRepeatedMessage(1, this.payments, (item: Payment) => item.serialize(writer));
            if (this.totalCount != 0)
                writer.writeInt32(2, this.totalCount);
            if (this.totalPages != 0)
                writer.writeInt32(3, this.totalPages);
            if (this.hasNext != false)
                writer.writeBool(4, this.hasNext);
            if (this.hasPrev != false)
                writer.writeBool(5, this.hasPrev);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListPaymentsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListPaymentsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.payments, () => pb_1.Message.addToRepeatedWrapperField(message, 1, Payment.deserialize(reader), Payment));
                        break;
                    case 2:
                        message.totalCount = reader.readInt32();
                        break;
                    case 3:
                        message.totalPages = reader.readInt32();
                        break;
                    case 4:
                        message.hasNext = reader.readBool();
                        break;
                    case 5:
                        message.hasPrev = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListPaymentsResponse {
            return ListPaymentsResponse.deserialize(bytes);
        }
    }
    export class ListMyPaymentsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            status?: PaymentStatus[];
            startDate?: dependency_1.google.protobuf.Timestamp;
            endDate?: dependency_1.google.protobuf.Timestamp;
            pageSize?: number;
            page?: number;
            paymentType?: PaymentType[];
            productId?: string[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1, 6, 7], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("startDate" in data && data.startDate != undefined) {
                    this.startDate = data.startDate;
                }
                if ("endDate" in data && data.endDate != undefined) {
                    this.endDate = data.endDate;
                }
                if ("pageSize" in data && data.pageSize != undefined) {
                    this.pageSize = data.pageSize;
                }
                if ("page" in data && data.page != undefined) {
                    this.page = data.page;
                }
                if ("paymentType" in data && data.paymentType != undefined) {
                    this.paymentType = data.paymentType;
                }
                if ("productId" in data && data.productId != undefined) {
                    this.productId = data.productId;
                }
            }
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 1, []) as PaymentStatus[];
        }
        set status(value: PaymentStatus[]) {
            pb_1.Message.setField(this, 1, value);
        }
        get startDate() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 2) as dependency_1.google.protobuf.Timestamp;
        }
        set startDate(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasStartDate() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get endDate() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 3) as dependency_1.google.protobuf.Timestamp;
        }
        set endDate(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasEndDate() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get pageSize() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set pageSize(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get page() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set page(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get paymentType() {
            return pb_1.Message.getRepeatedWrapperField(this, PaymentType, 6) as PaymentType[];
        }
        set paymentType(value: PaymentType[]) {
            pb_1.Message.setRepeatedWrapperField(this, 6, value);
        }
        get productId() {
            return pb_1.Message.getFieldWithDefault(this, 7, []) as string[];
        }
        set productId(value: string[]) {
            pb_1.Message.setField(this, 7, value);
        }
        static fromObject(data: {
            status?: PaymentStatus[];
            startDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            endDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            pageSize?: number;
            page?: number;
            paymentType?: ReturnType<typeof PaymentType.prototype.toObject>[];
            productId?: string[];
        }): ListMyPaymentsRequest {
            const message = new ListMyPaymentsRequest({});
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.startDate != null) {
                message.startDate = dependency_1.google.protobuf.Timestamp.fromObject(data.startDate);
            }
            if (data.endDate != null) {
                message.endDate = dependency_1.google.protobuf.Timestamp.fromObject(data.endDate);
            }
            if (data.pageSize != null) {
                message.pageSize = data.pageSize;
            }
            if (data.page != null) {
                message.page = data.page;
            }
            if (data.paymentType != null) {
                message.paymentType = data.paymentType.map(item => PaymentType.fromObject(item));
            }
            if (data.productId != null) {
                message.productId = data.productId;
            }
            return message;
        }
        toObject() {
            const data: {
                status?: PaymentStatus[];
                startDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                endDate?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                pageSize?: number;
                page?: number;
                paymentType?: ReturnType<typeof PaymentType.prototype.toObject>[];
                productId?: string[];
            } = {};
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.startDate != null) {
                data.startDate = this.startDate.toObject();
            }
            if (this.endDate != null) {
                data.endDate = this.endDate.toObject();
            }
            if (this.pageSize != null) {
                data.pageSize = this.pageSize;
            }
            if (this.page != null) {
                data.page = this.page;
            }
            if (this.paymentType != null) {
                data.paymentType = this.paymentType.map((item: PaymentType) => item.toObject());
            }
            if (this.productId != null) {
                data.productId = this.productId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.status.length)
                writer.writePackedEnum(1, this.status);
            if (this.hasStartDate)
                writer.writeMessage(2, this.startDate, () => this.startDate.serialize(writer));
            if (this.hasEndDate)
                writer.writeMessage(3, this.endDate, () => this.endDate.serialize(writer));
            if (this.pageSize != 0)
                writer.writeInt32(4, this.pageSize);
            if (this.page != 0)
                writer.writeInt32(5, this.page);
            if (this.paymentType.length)
                writer.writeRepeatedMessage(6, this.paymentType, (item: PaymentType) => item.serialize(writer));
            if (this.productId.length)
                writer.writeRepeatedString(7, this.productId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListMyPaymentsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListMyPaymentsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.status = reader.readPackedEnum();
                        break;
                    case 2:
                        reader.readMessage(message.startDate, () => message.startDate = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message.endDate, () => message.endDate = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 4:
                        message.pageSize = reader.readInt32();
                        break;
                    case 5:
                        message.page = reader.readInt32();
                        break;
                    case 6:
                        reader.readMessage(message.paymentType, () => pb_1.Message.addToRepeatedWrapperField(message, 6, PaymentType.deserialize(reader), PaymentType));
                        break;
                    case 7:
                        pb_1.Message.addToRepeatedField(message, 7, reader.readString());
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListMyPaymentsRequest {
            return ListMyPaymentsRequest.deserialize(bytes);
        }
    }
    export class ListMyPaymentsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            payments?: Payment[];
            count?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("payments" in data && data.payments != undefined) {
                    this.payments = data.payments;
                }
                if ("count" in data && data.count != undefined) {
                    this.count = data.count;
                }
            }
        }
        get payments() {
            return pb_1.Message.getRepeatedWrapperField(this, Payment, 1) as Payment[];
        }
        set payments(value: Payment[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        get count() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set count(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            payments?: ReturnType<typeof Payment.prototype.toObject>[];
            count?: number;
        }): ListMyPaymentsResponse {
            const message = new ListMyPaymentsResponse({});
            if (data.payments != null) {
                message.payments = data.payments.map(item => Payment.fromObject(item));
            }
            if (data.count != null) {
                message.count = data.count;
            }
            return message;
        }
        toObject() {
            const data: {
                payments?: ReturnType<typeof Payment.prototype.toObject>[];
                count?: number;
            } = {};
            if (this.payments != null) {
                data.payments = this.payments.map((item: Payment) => item.toObject());
            }
            if (this.count != null) {
                data.count = this.count;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.payments.length)
                writer.writeRepeatedMessage(1, this.payments, (item: Payment) => item.serialize(writer));
            if (this.count != 0)
                writer.writeInt64(2, this.count);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListMyPaymentsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListMyPaymentsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.payments, () => pb_1.Message.addToRepeatedWrapperField(message, 1, Payment.deserialize(reader), Payment));
                        break;
                    case 2:
                        message.count = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListMyPaymentsResponse {
            return ListMyPaymentsResponse.deserialize(bytes);
        }
    }
    export class ProcessRefundRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            paymentId?: string;
            amount?: Money;
            metadata?: Map<string, string>;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("paymentId" in data && data.paymentId != undefined) {
                    this.paymentId = data.paymentId;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get paymentId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set paymentId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get amount() {
            return pb_1.Message.getWrapperField(this, Money, 2) as Money;
        }
        set amount(value: Money) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasAmount() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get metadata() {
            return pb_1.Message.getField(this, 3) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 3, value as any);
        }
        static fromObject(data: {
            paymentId?: string;
            amount?: ReturnType<typeof Money.prototype.toObject>;
            metadata?: {
                [key: string]: string;
            };
        }): ProcessRefundRequest {
            const message = new ProcessRefundRequest({});
            if (data.paymentId != null) {
                message.paymentId = data.paymentId;
            }
            if (data.amount != null) {
                message.amount = Money.fromObject(data.amount);
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            return message;
        }
        toObject() {
            const data: {
                paymentId?: string;
                amount?: ReturnType<typeof Money.prototype.toObject>;
                metadata?: {
                    [key: string]: string;
                };
            } = {};
            if (this.paymentId != null) {
                data.paymentId = this.paymentId;
            }
            if (this.amount != null) {
                data.amount = this.amount.toObject();
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.paymentId.length)
                writer.writeString(1, this.paymentId);
            if (this.hasAmount)
                writer.writeMessage(2, this.amount, () => this.amount.serialize(writer));
            for (const [key, value] of this.metadata) {
                writer.writeMessage(3, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ProcessRefundRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ProcessRefundRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.paymentId = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.amount, () => message.amount = Money.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ProcessRefundRequest {
            return ProcessRefundRequest.deserialize(bytes);
        }
    }
    export class ProcessRefundResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            payment?: Payment;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("payment" in data && data.payment != undefined) {
                    this.payment = data.payment;
                }
            }
        }
        get payment() {
            return pb_1.Message.getWrapperField(this, Payment, 1) as Payment;
        }
        set payment(value: Payment) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasPayment() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            payment?: ReturnType<typeof Payment.prototype.toObject>;
        }): ProcessRefundResponse {
            const message = new ProcessRefundResponse({});
            if (data.payment != null) {
                message.payment = Payment.fromObject(data.payment);
            }
            return message;
        }
        toObject() {
            const data: {
                payment?: ReturnType<typeof Payment.prototype.toObject>;
            } = {};
            if (this.payment != null) {
                data.payment = this.payment.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPayment)
                writer.writeMessage(1, this.payment, () => this.payment.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ProcessRefundResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ProcessRefundResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.payment, () => message.payment = Payment.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ProcessRefundResponse {
            return ProcessRefundResponse.deserialize(bytes);
        }
    }
    export class SaveCardRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            customerId?: string;
            cardNumber?: string;
            expirationMonth?: number;
            expirationYear?: number;
            cardHolderName?: string;
            cardCvv?: string;
            saveCard?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("customerId" in data && data.customerId != undefined) {
                    this.customerId = data.customerId;
                }
                if ("cardNumber" in data && data.cardNumber != undefined) {
                    this.cardNumber = data.cardNumber;
                }
                if ("expirationMonth" in data && data.expirationMonth != undefined) {
                    this.expirationMonth = data.expirationMonth;
                }
                if ("expirationYear" in data && data.expirationYear != undefined) {
                    this.expirationYear = data.expirationYear;
                }
                if ("cardHolderName" in data && data.cardHolderName != undefined) {
                    this.cardHolderName = data.cardHolderName;
                }
                if ("cardCvv" in data && data.cardCvv != undefined) {
                    this.cardCvv = data.cardCvv;
                }
                if ("saveCard" in data && data.saveCard != undefined) {
                    this.saveCard = data.saveCard;
                }
            }
        }
        get customerId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set customerId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get cardNumber() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set cardNumber(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get expirationMonth() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set expirationMonth(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get expirationYear() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set expirationYear(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get cardHolderName() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set cardHolderName(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get cardCvv() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set cardCvv(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get saveCard() {
            return pb_1.Message.getFieldWithDefault(this, 7, false) as boolean;
        }
        set saveCard(value: boolean) {
            pb_1.Message.setField(this, 7, value);
        }
        static fromObject(data: {
            customerId?: string;
            cardNumber?: string;
            expirationMonth?: number;
            expirationYear?: number;
            cardHolderName?: string;
            cardCvv?: string;
            saveCard?: boolean;
        }): SaveCardRequest {
            const message = new SaveCardRequest({});
            if (data.customerId != null) {
                message.customerId = data.customerId;
            }
            if (data.cardNumber != null) {
                message.cardNumber = data.cardNumber;
            }
            if (data.expirationMonth != null) {
                message.expirationMonth = data.expirationMonth;
            }
            if (data.expirationYear != null) {
                message.expirationYear = data.expirationYear;
            }
            if (data.cardHolderName != null) {
                message.cardHolderName = data.cardHolderName;
            }
            if (data.cardCvv != null) {
                message.cardCvv = data.cardCvv;
            }
            if (data.saveCard != null) {
                message.saveCard = data.saveCard;
            }
            return message;
        }
        toObject() {
            const data: {
                customerId?: string;
                cardNumber?: string;
                expirationMonth?: number;
                expirationYear?: number;
                cardHolderName?: string;
                cardCvv?: string;
                saveCard?: boolean;
            } = {};
            if (this.customerId != null) {
                data.customerId = this.customerId;
            }
            if (this.cardNumber != null) {
                data.cardNumber = this.cardNumber;
            }
            if (this.expirationMonth != null) {
                data.expirationMonth = this.expirationMonth;
            }
            if (this.expirationYear != null) {
                data.expirationYear = this.expirationYear;
            }
            if (this.cardHolderName != null) {
                data.cardHolderName = this.cardHolderName;
            }
            if (this.cardCvv != null) {
                data.cardCvv = this.cardCvv;
            }
            if (this.saveCard != null) {
                data.saveCard = this.saveCard;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.customerId.length)
                writer.writeString(1, this.customerId);
            if (this.cardNumber.length)
                writer.writeString(2, this.cardNumber);
            if (this.expirationMonth != 0)
                writer.writeInt32(3, this.expirationMonth);
            if (this.expirationYear != 0)
                writer.writeInt32(4, this.expirationYear);
            if (this.cardHolderName.length)
                writer.writeString(5, this.cardHolderName);
            if (this.cardCvv.length)
                writer.writeString(6, this.cardCvv);
            if (this.saveCard != false)
                writer.writeBool(7, this.saveCard);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SaveCardRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SaveCardRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.customerId = reader.readString();
                        break;
                    case 2:
                        message.cardNumber = reader.readString();
                        break;
                    case 3:
                        message.expirationMonth = reader.readInt32();
                        break;
                    case 4:
                        message.expirationYear = reader.readInt32();
                        break;
                    case 5:
                        message.cardHolderName = reader.readString();
                        break;
                    case 6:
                        message.cardCvv = reader.readString();
                        break;
                    case 7:
                        message.saveCard = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SaveCardRequest {
            return SaveCardRequest.deserialize(bytes);
        }
    }
    export class SaveCardResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            cardId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("cardId" in data && data.cardId != undefined) {
                    this.cardId = data.cardId;
                }
            }
        }
        get cardId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set cardId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            cardId?: string;
        }): SaveCardResponse {
            const message = new SaveCardResponse({});
            if (data.cardId != null) {
                message.cardId = data.cardId;
            }
            return message;
        }
        toObject() {
            const data: {
                cardId?: string;
            } = {};
            if (this.cardId != null) {
                data.cardId = this.cardId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.cardId.length)
                writer.writeString(1, this.cardId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SaveCardResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SaveCardResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.cardId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SaveCardResponse {
            return SaveCardResponse.deserialize(bytes);
        }
    }
    export class ListCardsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            customerId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("customerId" in data && data.customerId != undefined) {
                    this.customerId = data.customerId;
                }
            }
        }
        get customerId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set customerId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            customerId?: string;
        }): ListCardsRequest {
            const message = new ListCardsRequest({});
            if (data.customerId != null) {
                message.customerId = data.customerId;
            }
            return message;
        }
        toObject() {
            const data: {
                customerId?: string;
            } = {};
            if (this.customerId != null) {
                data.customerId = this.customerId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.customerId.length)
                writer.writeString(1, this.customerId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListCardsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListCardsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.customerId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListCardsRequest {
            return ListCardsRequest.deserialize(bytes);
        }
    }
    export class ListCardsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            cards?: Card[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("cards" in data && data.cards != undefined) {
                    this.cards = data.cards;
                }
            }
        }
        get cards() {
            return pb_1.Message.getRepeatedWrapperField(this, Card, 1) as Card[];
        }
        set cards(value: Card[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data: {
            cards?: ReturnType<typeof Card.prototype.toObject>[];
        }): ListCardsResponse {
            const message = new ListCardsResponse({});
            if (data.cards != null) {
                message.cards = data.cards.map(item => Card.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                cards?: ReturnType<typeof Card.prototype.toObject>[];
            } = {};
            if (this.cards != null) {
                data.cards = this.cards.map((item: Card) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.cards.length)
                writer.writeRepeatedMessage(1, this.cards, (item: Card) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListCardsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListCardsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.cards, () => pb_1.Message.addToRepeatedWrapperField(message, 1, Card.deserialize(reader), Card));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListCardsResponse {
            return ListCardsResponse.deserialize(bytes);
        }
    }
    export class Card extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            cardId?: string;
            lastFourDigits?: string;
            brand?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("cardId" in data && data.cardId != undefined) {
                    this.cardId = data.cardId;
                }
                if ("lastFourDigits" in data && data.lastFourDigits != undefined) {
                    this.lastFourDigits = data.lastFourDigits;
                }
                if ("brand" in data && data.brand != undefined) {
                    this.brand = data.brand;
                }
            }
        }
        get cardId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set cardId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get lastFourDigits() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set lastFourDigits(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get brand() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set brand(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            cardId?: string;
            lastFourDigits?: string;
            brand?: string;
        }): Card {
            const message = new Card({});
            if (data.cardId != null) {
                message.cardId = data.cardId;
            }
            if (data.lastFourDigits != null) {
                message.lastFourDigits = data.lastFourDigits;
            }
            if (data.brand != null) {
                message.brand = data.brand;
            }
            return message;
        }
        toObject() {
            const data: {
                cardId?: string;
                lastFourDigits?: string;
                brand?: string;
            } = {};
            if (this.cardId != null) {
                data.cardId = this.cardId;
            }
            if (this.lastFourDigits != null) {
                data.lastFourDigits = this.lastFourDigits;
            }
            if (this.brand != null) {
                data.brand = this.brand;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.cardId.length)
                writer.writeString(1, this.cardId);
            if (this.lastFourDigits.length)
                writer.writeString(2, this.lastFourDigits);
            if (this.brand.length)
                writer.writeString(3, this.brand);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Card {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Card();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.cardId = reader.readString();
                        break;
                    case 2:
                        message.lastFourDigits = reader.readString();
                        break;
                    case 3:
                        message.brand = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Card {
            return Card.deserialize(bytes);
        }
    }
    export class DeleteCardRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            cardId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("cardId" in data && data.cardId != undefined) {
                    this.cardId = data.cardId;
                }
            }
        }
        get cardId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set cardId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            cardId?: string;
        }): DeleteCardRequest {
            const message = new DeleteCardRequest({});
            if (data.cardId != null) {
                message.cardId = data.cardId;
            }
            return message;
        }
        toObject() {
            const data: {
                cardId?: string;
            } = {};
            if (this.cardId != null) {
                data.cardId = this.cardId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.cardId.length)
                writer.writeString(1, this.cardId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteCardRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteCardRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.cardId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteCardRequest {
            return DeleteCardRequest.deserialize(bytes);
        }
    }
    export class DeleteCardResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): DeleteCardResponse {
            const message = new DeleteCardResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteCardResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteCardResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteCardResponse {
            return DeleteCardResponse.deserialize(bytes);
        }
    }
    export class PaymentStatusChange extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            paymentId?: string;
            status?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("paymentId" in data && data.paymentId != undefined) {
                    this.paymentId = data.paymentId;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
            }
        }
        get paymentId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set paymentId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set status(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            paymentId?: string;
            status?: string;
        }): PaymentStatusChange {
            const message = new PaymentStatusChange({});
            if (data.paymentId != null) {
                message.paymentId = data.paymentId;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            return message;
        }
        toObject() {
            const data: {
                paymentId?: string;
                status?: string;
            } = {};
            if (this.paymentId != null) {
                data.paymentId = this.paymentId;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.paymentId.length)
                writer.writeString(1, this.paymentId);
            if (this.status.length)
                writer.writeString(2, this.status);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaymentStatusChange {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PaymentStatusChange();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.paymentId = reader.readString();
                        break;
                    case 2:
                        message.status = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PaymentStatusChange {
            return PaymentStatusChange.deserialize(bytes);
        }
    }
    export class WebhookStarkBankRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            type?: string;
            subscription?: string;
            workspaceId?: string;
            event?: EventDetails;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
                if ("subscription" in data && data.subscription != undefined) {
                    this.subscription = data.subscription;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("event" in data && data.event != undefined) {
                    this.event = data.event;
                }
            }
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set type(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get subscription() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set subscription(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get event() {
            return pb_1.Message.getWrapperField(this, EventDetails, 4) as EventDetails;
        }
        set event(value: EventDetails) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasEvent() {
            return pb_1.Message.getField(this, 4) != null;
        }
        static fromObject(data: {
            type?: string;
            subscription?: string;
            workspaceId?: string;
            event?: ReturnType<typeof EventDetails.prototype.toObject>;
        }): WebhookStarkBankRequest {
            const message = new WebhookStarkBankRequest({});
            if (data.type != null) {
                message.type = data.type;
            }
            if (data.subscription != null) {
                message.subscription = data.subscription;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.event != null) {
                message.event = EventDetails.fromObject(data.event);
            }
            return message;
        }
        toObject() {
            const data: {
                type?: string;
                subscription?: string;
                workspaceId?: string;
                event?: ReturnType<typeof EventDetails.prototype.toObject>;
            } = {};
            if (this.type != null) {
                data.type = this.type;
            }
            if (this.subscription != null) {
                data.subscription = this.subscription;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.event != null) {
                data.event = this.event.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.type.length)
                writer.writeString(1, this.type);
            if (this.subscription.length)
                writer.writeString(2, this.subscription);
            if (this.workspaceId.length)
                writer.writeString(3, this.workspaceId);
            if (this.hasEvent)
                writer.writeMessage(4, this.event, () => this.event.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WebhookStarkBankRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WebhookStarkBankRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.type = reader.readString();
                        break;
                    case 2:
                        message.subscription = reader.readString();
                        break;
                    case 3:
                        message.workspaceId = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.event, () => message.event = EventDetails.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): WebhookStarkBankRequest {
            return WebhookStarkBankRequest.deserialize(bytes);
        }
    }
    export class WebhookStarkBankResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            status?: string;
            message?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("message" in data && data.message != undefined) {
                    this.message = data.message;
                }
            }
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set status(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get message() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set message(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            status?: string;
            message?: string;
        }): WebhookStarkBankResponse {
            const message = new WebhookStarkBankResponse({});
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.message != null) {
                message.message = data.message;
            }
            return message;
        }
        toObject() {
            const data: {
                status?: string;
                message?: string;
            } = {};
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.message != null) {
                data.message = this.message;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.status.length)
                writer.writeString(1, this.status);
            if (this.message.length)
                writer.writeString(2, this.message);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WebhookStarkBankResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WebhookStarkBankResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.status = reader.readString();
                        break;
                    case 2:
                        message.message = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): WebhookStarkBankResponse {
            return WebhookStarkBankResponse.deserialize(bytes);
        }
    }
    export class PixTransaction extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            endToEndId?: string;
            txid?: string;
            valor?: string;
            horario?: string;
            infoPagador?: string;
            devolucoes?: Devolucao[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [6], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("endToEndId" in data && data.endToEndId != undefined) {
                    this.endToEndId = data.endToEndId;
                }
                if ("txid" in data && data.txid != undefined) {
                    this.txid = data.txid;
                }
                if ("valor" in data && data.valor != undefined) {
                    this.valor = data.valor;
                }
                if ("horario" in data && data.horario != undefined) {
                    this.horario = data.horario;
                }
                if ("infoPagador" in data && data.infoPagador != undefined) {
                    this.infoPagador = data.infoPagador;
                }
                if ("devolucoes" in data && data.devolucoes != undefined) {
                    this.devolucoes = data.devolucoes;
                }
            }
        }
        get endToEndId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set endToEndId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get txid() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set txid(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get valor() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set valor(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get horario() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set horario(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get infoPagador() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set infoPagador(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get devolucoes() {
            return pb_1.Message.getRepeatedWrapperField(this, Devolucao, 6) as Devolucao[];
        }
        set devolucoes(value: Devolucao[]) {
            pb_1.Message.setRepeatedWrapperField(this, 6, value);
        }
        static fromObject(data: {
            endToEndId?: string;
            txid?: string;
            valor?: string;
            horario?: string;
            infoPagador?: string;
            devolucoes?: ReturnType<typeof Devolucao.prototype.toObject>[];
        }): PixTransaction {
            const message = new PixTransaction({});
            if (data.endToEndId != null) {
                message.endToEndId = data.endToEndId;
            }
            if (data.txid != null) {
                message.txid = data.txid;
            }
            if (data.valor != null) {
                message.valor = data.valor;
            }
            if (data.horario != null) {
                message.horario = data.horario;
            }
            if (data.infoPagador != null) {
                message.infoPagador = data.infoPagador;
            }
            if (data.devolucoes != null) {
                message.devolucoes = data.devolucoes.map(item => Devolucao.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                endToEndId?: string;
                txid?: string;
                valor?: string;
                horario?: string;
                infoPagador?: string;
                devolucoes?: ReturnType<typeof Devolucao.prototype.toObject>[];
            } = {};
            if (this.endToEndId != null) {
                data.endToEndId = this.endToEndId;
            }
            if (this.txid != null) {
                data.txid = this.txid;
            }
            if (this.valor != null) {
                data.valor = this.valor;
            }
            if (this.horario != null) {
                data.horario = this.horario;
            }
            if (this.infoPagador != null) {
                data.infoPagador = this.infoPagador;
            }
            if (this.devolucoes != null) {
                data.devolucoes = this.devolucoes.map((item: Devolucao) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.endToEndId.length)
                writer.writeString(1, this.endToEndId);
            if (this.txid.length)
                writer.writeString(2, this.txid);
            if (this.valor.length)
                writer.writeString(3, this.valor);
            if (this.horario.length)
                writer.writeString(4, this.horario);
            if (this.infoPagador.length)
                writer.writeString(5, this.infoPagador);
            if (this.devolucoes.length)
                writer.writeRepeatedMessage(6, this.devolucoes, (item: Devolucao) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PixTransaction {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PixTransaction();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.endToEndId = reader.readString();
                        break;
                    case 2:
                        message.txid = reader.readString();
                        break;
                    case 3:
                        message.valor = reader.readString();
                        break;
                    case 4:
                        message.horario = reader.readString();
                        break;
                    case 5:
                        message.infoPagador = reader.readString();
                        break;
                    case 6:
                        reader.readMessage(message.devolucoes, () => pb_1.Message.addToRepeatedWrapperField(message, 6, Devolucao.deserialize(reader), Devolucao));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PixTransaction {
            return PixTransaction.deserialize(bytes);
        }
    }
    export class Devolucao extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            valor?: string;
            status?: string;
            horario?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("valor" in data && data.valor != undefined) {
                    this.valor = data.valor;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("horario" in data && data.horario != undefined) {
                    this.horario = data.horario;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get valor() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set valor(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set status(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get horario() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set horario(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            id?: string;
            valor?: string;
            status?: string;
            horario?: string;
        }): Devolucao {
            const message = new Devolucao({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.valor != null) {
                message.valor = data.valor;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.horario != null) {
                message.horario = data.horario;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                valor?: string;
                status?: string;
                horario?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.valor != null) {
                data.valor = this.valor;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.horario != null) {
                data.horario = this.horario;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.valor.length)
                writer.writeString(2, this.valor);
            if (this.status.length)
                writer.writeString(3, this.status);
            if (this.horario.length)
                writer.writeString(4, this.horario);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Devolucao {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Devolucao();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.valor = reader.readString();
                        break;
                    case 3:
                        message.status = reader.readString();
                        break;
                    case 4:
                        message.horario = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Devolucao {
            return Devolucao.deserialize(bytes);
        }
    }
    export class WebhookBradescoPIXRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            pix?: PixTransaction[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("pix" in data && data.pix != undefined) {
                    this.pix = data.pix;
                }
            }
        }
        get pix() {
            return pb_1.Message.getRepeatedWrapperField(this, PixTransaction, 1) as PixTransaction[];
        }
        set pix(value: PixTransaction[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data: {
            pix?: ReturnType<typeof PixTransaction.prototype.toObject>[];
        }): WebhookBradescoPIXRequest {
            const message = new WebhookBradescoPIXRequest({});
            if (data.pix != null) {
                message.pix = data.pix.map(item => PixTransaction.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                pix?: ReturnType<typeof PixTransaction.prototype.toObject>[];
            } = {};
            if (this.pix != null) {
                data.pix = this.pix.map((item: PixTransaction) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.pix.length)
                writer.writeRepeatedMessage(1, this.pix, (item: PixTransaction) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WebhookBradescoPIXRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WebhookBradescoPIXRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.pix, () => pb_1.Message.addToRepeatedWrapperField(message, 1, PixTransaction.deserialize(reader), PixTransaction));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): WebhookBradescoPIXRequest {
            return WebhookBradescoPIXRequest.deserialize(bytes);
        }
    }
    export class WebhookBradescoPIXResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            status?: string;
            message?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("message" in data && data.message != undefined) {
                    this.message = data.message;
                }
            }
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set status(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get message() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set message(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            status?: string;
            message?: string;
        }): WebhookBradescoPIXResponse {
            const message = new WebhookBradescoPIXResponse({});
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.message != null) {
                message.message = data.message;
            }
            return message;
        }
        toObject() {
            const data: {
                status?: string;
                message?: string;
            } = {};
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.message != null) {
                data.message = this.message;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.status.length)
                writer.writeString(1, this.status);
            if (this.message.length)
                writer.writeString(2, this.message);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WebhookBradescoPIXResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WebhookBradescoPIXResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.status = reader.readString();
                        break;
                    case 2:
                        message.message = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): WebhookBradescoPIXResponse {
            return WebhookBradescoPIXResponse.deserialize(bytes);
        }
    }
    export class EventDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            created?: string;
            id?: string;
            log?: EventLog;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("created" in data && data.created != undefined) {
                    this.created = data.created;
                }
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("log" in data && data.log != undefined) {
                    this.log = data.log;
                }
            }
        }
        get created() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set created(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get log() {
            return pb_1.Message.getWrapperField(this, EventLog, 3) as EventLog;
        }
        set log(value: EventLog) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasLog() {
            return pb_1.Message.getField(this, 3) != null;
        }
        static fromObject(data: {
            created?: string;
            id?: string;
            log?: ReturnType<typeof EventLog.prototype.toObject>;
        }): EventDetails {
            const message = new EventDetails({});
            if (data.created != null) {
                message.created = data.created;
            }
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.log != null) {
                message.log = EventLog.fromObject(data.log);
            }
            return message;
        }
        toObject() {
            const data: {
                created?: string;
                id?: string;
                log?: ReturnType<typeof EventLog.prototype.toObject>;
            } = {};
            if (this.created != null) {
                data.created = this.created;
            }
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.log != null) {
                data.log = this.log.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.created.length)
                writer.writeString(1, this.created);
            if (this.id.length)
                writer.writeString(2, this.id);
            if (this.hasLog)
                writer.writeMessage(3, this.log, () => this.log.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): EventDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new EventDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.created = reader.readString();
                        break;
                    case 2:
                        message.id = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.log, () => message.log = EventLog.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): EventDetails {
            return EventDetails.deserialize(bytes);
        }
    }
    export class EventLog extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            authentication?: string;
            created?: string;
            errors?: string[];
            id?: string;
            invoice?: InvoiceDetails;
            type?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("authentication" in data && data.authentication != undefined) {
                    this.authentication = data.authentication;
                }
                if ("created" in data && data.created != undefined) {
                    this.created = data.created;
                }
                if ("errors" in data && data.errors != undefined) {
                    this.errors = data.errors;
                }
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("invoice" in data && data.invoice != undefined) {
                    this.invoice = data.invoice;
                }
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
            }
        }
        get authentication() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set authentication(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get created() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set created(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get errors() {
            return pb_1.Message.getFieldWithDefault(this, 3, []) as string[];
        }
        set errors(value: string[]) {
            pb_1.Message.setField(this, 3, value);
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get invoice() {
            return pb_1.Message.getWrapperField(this, InvoiceDetails, 5) as InvoiceDetails;
        }
        set invoice(value: InvoiceDetails) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get hasInvoice() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set type(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        static fromObject(data: {
            authentication?: string;
            created?: string;
            errors?: string[];
            id?: string;
            invoice?: ReturnType<typeof InvoiceDetails.prototype.toObject>;
            type?: string;
        }): EventLog {
            const message = new EventLog({});
            if (data.authentication != null) {
                message.authentication = data.authentication;
            }
            if (data.created != null) {
                message.created = data.created;
            }
            if (data.errors != null) {
                message.errors = data.errors;
            }
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.invoice != null) {
                message.invoice = InvoiceDetails.fromObject(data.invoice);
            }
            if (data.type != null) {
                message.type = data.type;
            }
            return message;
        }
        toObject() {
            const data: {
                authentication?: string;
                created?: string;
                errors?: string[];
                id?: string;
                invoice?: ReturnType<typeof InvoiceDetails.prototype.toObject>;
                type?: string;
            } = {};
            if (this.authentication != null) {
                data.authentication = this.authentication;
            }
            if (this.created != null) {
                data.created = this.created;
            }
            if (this.errors != null) {
                data.errors = this.errors;
            }
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.invoice != null) {
                data.invoice = this.invoice.toObject();
            }
            if (this.type != null) {
                data.type = this.type;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.authentication.length)
                writer.writeString(1, this.authentication);
            if (this.created.length)
                writer.writeString(2, this.created);
            if (this.errors.length)
                writer.writeRepeatedString(3, this.errors);
            if (this.id.length)
                writer.writeString(4, this.id);
            if (this.hasInvoice)
                writer.writeMessage(5, this.invoice, () => this.invoice.serialize(writer));
            if (this.type.length)
                writer.writeString(6, this.type);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): EventLog {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new EventLog();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.authentication = reader.readString();
                        break;
                    case 2:
                        message.created = reader.readString();
                        break;
                    case 3:
                        pb_1.Message.addToRepeatedField(message, 3, reader.readString());
                        break;
                    case 4:
                        message.id = reader.readString();
                        break;
                    case 5:
                        reader.readMessage(message.invoice, () => message.invoice = InvoiceDetails.deserialize(reader));
                        break;
                    case 6:
                        message.type = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): EventLog {
            return EventLog.deserialize(bytes);
        }
    }
    export class InvoiceDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            amount?: number;
            brcode?: string;
            created?: string;
            descriptions?: string[];
            discountAmount?: number;
            discounts?: Discount[];
            displayDescription?: string;
            due?: string;
            expiration?: number;
            fee?: number;
            fine?: number;
            fineAmount?: number;
            id?: string;
            interest?: number;
            interestAmount?: number;
            link?: string;
            name?: string;
            nominalAmount?: number;
            pdf?: string;
            rules?: Rule[];
            splits?: Split[];
            status?: string;
            tags?: string[];
            taxId?: string;
            transactionIds?: string[];
            updated?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4, 6, 20, 21, 23, 25], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("brcode" in data && data.brcode != undefined) {
                    this.brcode = data.brcode;
                }
                if ("created" in data && data.created != undefined) {
                    this.created = data.created;
                }
                if ("descriptions" in data && data.descriptions != undefined) {
                    this.descriptions = data.descriptions;
                }
                if ("discountAmount" in data && data.discountAmount != undefined) {
                    this.discountAmount = data.discountAmount;
                }
                if ("discounts" in data && data.discounts != undefined) {
                    this.discounts = data.discounts;
                }
                if ("displayDescription" in data && data.displayDescription != undefined) {
                    this.displayDescription = data.displayDescription;
                }
                if ("due" in data && data.due != undefined) {
                    this.due = data.due;
                }
                if ("expiration" in data && data.expiration != undefined) {
                    this.expiration = data.expiration;
                }
                if ("fee" in data && data.fee != undefined) {
                    this.fee = data.fee;
                }
                if ("fine" in data && data.fine != undefined) {
                    this.fine = data.fine;
                }
                if ("fineAmount" in data && data.fineAmount != undefined) {
                    this.fineAmount = data.fineAmount;
                }
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("interest" in data && data.interest != undefined) {
                    this.interest = data.interest;
                }
                if ("interestAmount" in data && data.interestAmount != undefined) {
                    this.interestAmount = data.interestAmount;
                }
                if ("link" in data && data.link != undefined) {
                    this.link = data.link;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("nominalAmount" in data && data.nominalAmount != undefined) {
                    this.nominalAmount = data.nominalAmount;
                }
                if ("pdf" in data && data.pdf != undefined) {
                    this.pdf = data.pdf;
                }
                if ("rules" in data && data.rules != undefined) {
                    this.rules = data.rules;
                }
                if ("splits" in data && data.splits != undefined) {
                    this.splits = data.splits;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("tags" in data && data.tags != undefined) {
                    this.tags = data.tags;
                }
                if ("taxId" in data && data.taxId != undefined) {
                    this.taxId = data.taxId;
                }
                if ("transactionIds" in data && data.transactionIds != undefined) {
                    this.transactionIds = data.transactionIds;
                }
                if ("updated" in data && data.updated != undefined) {
                    this.updated = data.updated;
                }
            }
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get brcode() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set brcode(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get created() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set created(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get descriptions() {
            return pb_1.Message.getFieldWithDefault(this, 4, []) as string[];
        }
        set descriptions(value: string[]) {
            pb_1.Message.setField(this, 4, value);
        }
        get discountAmount() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set discountAmount(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get discounts() {
            return pb_1.Message.getRepeatedWrapperField(this, Discount, 6) as Discount[];
        }
        set discounts(value: Discount[]) {
            pb_1.Message.setRepeatedWrapperField(this, 6, value);
        }
        get displayDescription() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set displayDescription(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get due() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set due(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        get expiration() {
            return pb_1.Message.getFieldWithDefault(this, 9, 0) as number;
        }
        set expiration(value: number) {
            pb_1.Message.setField(this, 9, value);
        }
        get fee() {
            return pb_1.Message.getFieldWithDefault(this, 10, 0) as number;
        }
        set fee(value: number) {
            pb_1.Message.setField(this, 10, value);
        }
        get fine() {
            return pb_1.Message.getFieldWithDefault(this, 11, 0) as number;
        }
        set fine(value: number) {
            pb_1.Message.setField(this, 11, value);
        }
        get fineAmount() {
            return pb_1.Message.getFieldWithDefault(this, 12, 0) as number;
        }
        set fineAmount(value: number) {
            pb_1.Message.setField(this, 12, value);
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 13, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 13, value);
        }
        get interest() {
            return pb_1.Message.getFieldWithDefault(this, 14, 0) as number;
        }
        set interest(value: number) {
            pb_1.Message.setField(this, 14, value);
        }
        get interestAmount() {
            return pb_1.Message.getFieldWithDefault(this, 15, 0) as number;
        }
        set interestAmount(value: number) {
            pb_1.Message.setField(this, 15, value);
        }
        get link() {
            return pb_1.Message.getFieldWithDefault(this, 16, "") as string;
        }
        set link(value: string) {
            pb_1.Message.setField(this, 16, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 17, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 17, value);
        }
        get nominalAmount() {
            return pb_1.Message.getFieldWithDefault(this, 18, 0) as number;
        }
        set nominalAmount(value: number) {
            pb_1.Message.setField(this, 18, value);
        }
        get pdf() {
            return pb_1.Message.getFieldWithDefault(this, 19, "") as string;
        }
        set pdf(value: string) {
            pb_1.Message.setField(this, 19, value);
        }
        get rules() {
            return pb_1.Message.getRepeatedWrapperField(this, Rule, 20) as Rule[];
        }
        set rules(value: Rule[]) {
            pb_1.Message.setRepeatedWrapperField(this, 20, value);
        }
        get splits() {
            return pb_1.Message.getRepeatedWrapperField(this, Split, 21) as Split[];
        }
        set splits(value: Split[]) {
            pb_1.Message.setRepeatedWrapperField(this, 21, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 22, "") as string;
        }
        set status(value: string) {
            pb_1.Message.setField(this, 22, value);
        }
        get tags() {
            return pb_1.Message.getFieldWithDefault(this, 23, []) as string[];
        }
        set tags(value: string[]) {
            pb_1.Message.setField(this, 23, value);
        }
        get taxId() {
            return pb_1.Message.getFieldWithDefault(this, 24, "") as string;
        }
        set taxId(value: string) {
            pb_1.Message.setField(this, 24, value);
        }
        get transactionIds() {
            return pb_1.Message.getFieldWithDefault(this, 25, []) as string[];
        }
        set transactionIds(value: string[]) {
            pb_1.Message.setField(this, 25, value);
        }
        get updated() {
            return pb_1.Message.getFieldWithDefault(this, 26, "") as string;
        }
        set updated(value: string) {
            pb_1.Message.setField(this, 26, value);
        }
        static fromObject(data: {
            amount?: number;
            brcode?: string;
            created?: string;
            descriptions?: string[];
            discountAmount?: number;
            discounts?: ReturnType<typeof Discount.prototype.toObject>[];
            displayDescription?: string;
            due?: string;
            expiration?: number;
            fee?: number;
            fine?: number;
            fineAmount?: number;
            id?: string;
            interest?: number;
            interestAmount?: number;
            link?: string;
            name?: string;
            nominalAmount?: number;
            pdf?: string;
            rules?: ReturnType<typeof Rule.prototype.toObject>[];
            splits?: ReturnType<typeof Split.prototype.toObject>[];
            status?: string;
            tags?: string[];
            taxId?: string;
            transactionIds?: string[];
            updated?: string;
        }): InvoiceDetails {
            const message = new InvoiceDetails({});
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.brcode != null) {
                message.brcode = data.brcode;
            }
            if (data.created != null) {
                message.created = data.created;
            }
            if (data.descriptions != null) {
                message.descriptions = data.descriptions;
            }
            if (data.discountAmount != null) {
                message.discountAmount = data.discountAmount;
            }
            if (data.discounts != null) {
                message.discounts = data.discounts.map(item => Discount.fromObject(item));
            }
            if (data.displayDescription != null) {
                message.displayDescription = data.displayDescription;
            }
            if (data.due != null) {
                message.due = data.due;
            }
            if (data.expiration != null) {
                message.expiration = data.expiration;
            }
            if (data.fee != null) {
                message.fee = data.fee;
            }
            if (data.fine != null) {
                message.fine = data.fine;
            }
            if (data.fineAmount != null) {
                message.fineAmount = data.fineAmount;
            }
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.interest != null) {
                message.interest = data.interest;
            }
            if (data.interestAmount != null) {
                message.interestAmount = data.interestAmount;
            }
            if (data.link != null) {
                message.link = data.link;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.nominalAmount != null) {
                message.nominalAmount = data.nominalAmount;
            }
            if (data.pdf != null) {
                message.pdf = data.pdf;
            }
            if (data.rules != null) {
                message.rules = data.rules.map(item => Rule.fromObject(item));
            }
            if (data.splits != null) {
                message.splits = data.splits.map(item => Split.fromObject(item));
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.tags != null) {
                message.tags = data.tags;
            }
            if (data.taxId != null) {
                message.taxId = data.taxId;
            }
            if (data.transactionIds != null) {
                message.transactionIds = data.transactionIds;
            }
            if (data.updated != null) {
                message.updated = data.updated;
            }
            return message;
        }
        toObject() {
            const data: {
                amount?: number;
                brcode?: string;
                created?: string;
                descriptions?: string[];
                discountAmount?: number;
                discounts?: ReturnType<typeof Discount.prototype.toObject>[];
                displayDescription?: string;
                due?: string;
                expiration?: number;
                fee?: number;
                fine?: number;
                fineAmount?: number;
                id?: string;
                interest?: number;
                interestAmount?: number;
                link?: string;
                name?: string;
                nominalAmount?: number;
                pdf?: string;
                rules?: ReturnType<typeof Rule.prototype.toObject>[];
                splits?: ReturnType<typeof Split.prototype.toObject>[];
                status?: string;
                tags?: string[];
                taxId?: string;
                transactionIds?: string[];
                updated?: string;
            } = {};
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.brcode != null) {
                data.brcode = this.brcode;
            }
            if (this.created != null) {
                data.created = this.created;
            }
            if (this.descriptions != null) {
                data.descriptions = this.descriptions;
            }
            if (this.discountAmount != null) {
                data.discountAmount = this.discountAmount;
            }
            if (this.discounts != null) {
                data.discounts = this.discounts.map((item: Discount) => item.toObject());
            }
            if (this.displayDescription != null) {
                data.displayDescription = this.displayDescription;
            }
            if (this.due != null) {
                data.due = this.due;
            }
            if (this.expiration != null) {
                data.expiration = this.expiration;
            }
            if (this.fee != null) {
                data.fee = this.fee;
            }
            if (this.fine != null) {
                data.fine = this.fine;
            }
            if (this.fineAmount != null) {
                data.fineAmount = this.fineAmount;
            }
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.interest != null) {
                data.interest = this.interest;
            }
            if (this.interestAmount != null) {
                data.interestAmount = this.interestAmount;
            }
            if (this.link != null) {
                data.link = this.link;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.nominalAmount != null) {
                data.nominalAmount = this.nominalAmount;
            }
            if (this.pdf != null) {
                data.pdf = this.pdf;
            }
            if (this.rules != null) {
                data.rules = this.rules.map((item: Rule) => item.toObject());
            }
            if (this.splits != null) {
                data.splits = this.splits.map((item: Split) => item.toObject());
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.tags != null) {
                data.tags = this.tags;
            }
            if (this.taxId != null) {
                data.taxId = this.taxId;
            }
            if (this.transactionIds != null) {
                data.transactionIds = this.transactionIds;
            }
            if (this.updated != null) {
                data.updated = this.updated;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.amount != 0)
                writer.writeInt64(1, this.amount);
            if (this.brcode.length)
                writer.writeString(2, this.brcode);
            if (this.created.length)
                writer.writeString(3, this.created);
            if (this.descriptions.length)
                writer.writeRepeatedString(4, this.descriptions);
            if (this.discountAmount != 0)
                writer.writeInt64(5, this.discountAmount);
            if (this.discounts.length)
                writer.writeRepeatedMessage(6, this.discounts, (item: Discount) => item.serialize(writer));
            if (this.displayDescription.length)
                writer.writeString(7, this.displayDescription);
            if (this.due.length)
                writer.writeString(8, this.due);
            if (this.expiration != 0)
                writer.writeInt32(9, this.expiration);
            if (this.fee != 0)
                writer.writeInt32(10, this.fee);
            if (this.fine != 0)
                writer.writeInt32(11, this.fine);
            if (this.fineAmount != 0)
                writer.writeInt64(12, this.fineAmount);
            if (this.id.length)
                writer.writeString(13, this.id);
            if (this.interest != 0)
                writer.writeInt32(14, this.interest);
            if (this.interestAmount != 0)
                writer.writeInt64(15, this.interestAmount);
            if (this.link.length)
                writer.writeString(16, this.link);
            if (this.name.length)
                writer.writeString(17, this.name);
            if (this.nominalAmount != 0)
                writer.writeInt64(18, this.nominalAmount);
            if (this.pdf.length)
                writer.writeString(19, this.pdf);
            if (this.rules.length)
                writer.writeRepeatedMessage(20, this.rules, (item: Rule) => item.serialize(writer));
            if (this.splits.length)
                writer.writeRepeatedMessage(21, this.splits, (item: Split) => item.serialize(writer));
            if (this.status.length)
                writer.writeString(22, this.status);
            if (this.tags.length)
                writer.writeRepeatedString(23, this.tags);
            if (this.taxId.length)
                writer.writeString(24, this.taxId);
            if (this.transactionIds.length)
                writer.writeRepeatedString(25, this.transactionIds);
            if (this.updated.length)
                writer.writeString(26, this.updated);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): InvoiceDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new InvoiceDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.amount = reader.readInt64();
                        break;
                    case 2:
                        message.brcode = reader.readString();
                        break;
                    case 3:
                        message.created = reader.readString();
                        break;
                    case 4:
                        pb_1.Message.addToRepeatedField(message, 4, reader.readString());
                        break;
                    case 5:
                        message.discountAmount = reader.readInt64();
                        break;
                    case 6:
                        reader.readMessage(message.discounts, () => pb_1.Message.addToRepeatedWrapperField(message, 6, Discount.deserialize(reader), Discount));
                        break;
                    case 7:
                        message.displayDescription = reader.readString();
                        break;
                    case 8:
                        message.due = reader.readString();
                        break;
                    case 9:
                        message.expiration = reader.readInt32();
                        break;
                    case 10:
                        message.fee = reader.readInt32();
                        break;
                    case 11:
                        message.fine = reader.readInt32();
                        break;
                    case 12:
                        message.fineAmount = reader.readInt64();
                        break;
                    case 13:
                        message.id = reader.readString();
                        break;
                    case 14:
                        message.interest = reader.readInt32();
                        break;
                    case 15:
                        message.interestAmount = reader.readInt64();
                        break;
                    case 16:
                        message.link = reader.readString();
                        break;
                    case 17:
                        message.name = reader.readString();
                        break;
                    case 18:
                        message.nominalAmount = reader.readInt64();
                        break;
                    case 19:
                        message.pdf = reader.readString();
                        break;
                    case 20:
                        reader.readMessage(message.rules, () => pb_1.Message.addToRepeatedWrapperField(message, 20, Rule.deserialize(reader), Rule));
                        break;
                    case 21:
                        reader.readMessage(message.splits, () => pb_1.Message.addToRepeatedWrapperField(message, 21, Split.deserialize(reader), Split));
                        break;
                    case 22:
                        message.status = reader.readString();
                        break;
                    case 23:
                        pb_1.Message.addToRepeatedField(message, 23, reader.readString());
                        break;
                    case 24:
                        message.taxId = reader.readString();
                        break;
                    case 25:
                        pb_1.Message.addToRepeatedField(message, 25, reader.readString());
                        break;
                    case 26:
                        message.updated = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): InvoiceDetails {
            return InvoiceDetails.deserialize(bytes);
        }
    }
    export class Discount extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            description?: string;
            amount?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("description" in data && data.description != undefined) {
                    this.description = data.description;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
            }
        }
        get description() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set description(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            description?: string;
            amount?: number;
        }): Discount {
            const message = new Discount({});
            if (data.description != null) {
                message.description = data.description;
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            return message;
        }
        toObject() {
            const data: {
                description?: string;
                amount?: number;
            } = {};
            if (this.description != null) {
                data.description = this.description;
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.description.length)
                writer.writeString(1, this.description);
            if (this.amount != 0)
                writer.writeInt64(2, this.amount);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Discount {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Discount();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.description = reader.readString();
                        break;
                    case 2:
                        message.amount = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Discount {
            return Discount.deserialize(bytes);
        }
    }
    export class Rule extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            type?: string;
            parameter?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
                if ("parameter" in data && data.parameter != undefined) {
                    this.parameter = data.parameter;
                }
            }
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set type(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get parameter() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set parameter(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            type?: string;
            parameter?: string;
        }): Rule {
            const message = new Rule({});
            if (data.type != null) {
                message.type = data.type;
            }
            if (data.parameter != null) {
                message.parameter = data.parameter;
            }
            return message;
        }
        toObject() {
            const data: {
                type?: string;
                parameter?: string;
            } = {};
            if (this.type != null) {
                data.type = this.type;
            }
            if (this.parameter != null) {
                data.parameter = this.parameter;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.type.length)
                writer.writeString(1, this.type);
            if (this.parameter.length)
                writer.writeString(2, this.parameter);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Rule {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Rule();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.type = reader.readString();
                        break;
                    case 2:
                        message.parameter = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Rule {
            return Rule.deserialize(bytes);
        }
    }
    export class Split extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            accountId?: string;
            amount?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("accountId" in data && data.accountId != undefined) {
                    this.accountId = data.accountId;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
            }
        }
        get accountId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set accountId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            accountId?: string;
            amount?: number;
        }): Split {
            const message = new Split({});
            if (data.accountId != null) {
                message.accountId = data.accountId;
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            return message;
        }
        toObject() {
            const data: {
                accountId?: string;
                amount?: number;
            } = {};
            if (this.accountId != null) {
                data.accountId = this.accountId;
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.accountId.length)
                writer.writeString(1, this.accountId);
            if (this.amount != 0)
                writer.writeInt64(2, this.amount);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Split {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Split();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.accountId = reader.readString();
                        break;
                    case 2:
                        message.amount = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Split {
            return Split.deserialize(bytes);
        }
    }
    export abstract class UnimplementedPaymentsServiceService {
        static definition = {
            ProcessPayment: {
                path: "/payments.v1.PaymentsService/ProcessPayment",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ProcessPaymentRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ProcessPaymentRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ProcessPaymentResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ProcessPaymentResponse.deserialize(new Uint8Array(bytes))
            },
            GetPayment: {
                path: "/payments.v1.PaymentsService/GetPayment",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetPaymentRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetPaymentRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetPaymentResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetPaymentResponse.deserialize(new Uint8Array(bytes))
            },
            GetPaymentByOrderID: {
                path: "/payments.v1.PaymentsService/GetPaymentByOrderID",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetPaymentByOrderIDRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetPaymentByOrderIDRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetPaymentByOrderIDResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetPaymentByOrderIDResponse.deserialize(new Uint8Array(bytes))
            },
            ListPayments: {
                path: "/payments.v1.PaymentsService/ListPayments",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListPaymentsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListPaymentsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListPaymentsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListPaymentsResponse.deserialize(new Uint8Array(bytes))
            },
            ListMyPayments: {
                path: "/payments.v1.PaymentsService/ListMyPayments",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListMyPaymentsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListMyPaymentsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListMyPaymentsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListMyPaymentsResponse.deserialize(new Uint8Array(bytes))
            },
            ProcessRefund: {
                path: "/payments.v1.PaymentsService/ProcessRefund",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ProcessRefundRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ProcessRefundRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ProcessRefundResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ProcessRefundResponse.deserialize(new Uint8Array(bytes))
            },
            SaveCard: {
                path: "/payments.v1.PaymentsService/SaveCard",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: SaveCardRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => SaveCardRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: SaveCardResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => SaveCardResponse.deserialize(new Uint8Array(bytes))
            },
            ListCards: {
                path: "/payments.v1.PaymentsService/ListCards",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListCardsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListCardsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListCardsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListCardsResponse.deserialize(new Uint8Array(bytes))
            },
            DeleteCard: {
                path: "/payments.v1.PaymentsService/DeleteCard",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: DeleteCardRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => DeleteCardRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: DeleteCardResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => DeleteCardResponse.deserialize(new Uint8Array(bytes))
            },
            WebhookStarkBank: {
                path: "/payments.v1.PaymentsService/WebhookStarkBank",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: WebhookStarkBankRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => WebhookStarkBankRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: WebhookStarkBankResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => WebhookStarkBankResponse.deserialize(new Uint8Array(bytes))
            },
            WebhookBradescoPIX: {
                path: "/payments.v1.PaymentsService/WebhookBradescoPIX",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: WebhookBradescoPIXRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => WebhookBradescoPIXRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: WebhookBradescoPIXResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => WebhookBradescoPIXResponse.deserialize(new Uint8Array(bytes))
            },
            UpdateConfig: {
                path: "/payments.v1.PaymentsService/UpdateConfig",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: UpdateConfigRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => UpdateConfigRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: UpdateConfigResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => UpdateConfigResponse.deserialize(new Uint8Array(bytes))
            },
            GetConfig: {
                path: "/payments.v1.PaymentsService/GetConfig",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetConfigRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetConfigRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetConfigResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetConfigResponse.deserialize(new Uint8Array(bytes))
            },
            UpdatePayment: {
                path: "/payments.v1.PaymentsService/UpdatePayment",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: UpdatePaymentRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => UpdatePaymentRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: UpdatePaymentResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => UpdatePaymentResponse.deserialize(new Uint8Array(bytes))
            },
            StartReport: {
                path: "/payments.v1.PaymentsService/StartReport",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: StartReportRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => StartReportRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: StartReportResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => StartReportResponse.deserialize(new Uint8Array(bytes))
            },
            GetReport: {
                path: "/payments.v1.PaymentsService/GetReport",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetReportRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetReportRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetReportResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetReportResponse.deserialize(new Uint8Array(bytes))
            }
        };
        [method: string]: grpc_1.UntypedHandleCall;
        abstract ProcessPayment(call: grpc_1.ServerUnaryCall<ProcessPaymentRequest, ProcessPaymentResponse>, callback: grpc_1.sendUnaryData<ProcessPaymentResponse>): void;
        abstract GetPayment(call: grpc_1.ServerUnaryCall<GetPaymentRequest, GetPaymentResponse>, callback: grpc_1.sendUnaryData<GetPaymentResponse>): void;
        abstract GetPaymentByOrderID(call: grpc_1.ServerUnaryCall<GetPaymentByOrderIDRequest, GetPaymentByOrderIDResponse>, callback: grpc_1.sendUnaryData<GetPaymentByOrderIDResponse>): void;
        abstract ListPayments(call: grpc_1.ServerUnaryCall<ListPaymentsRequest, ListPaymentsResponse>, callback: grpc_1.sendUnaryData<ListPaymentsResponse>): void;
        abstract ListMyPayments(call: grpc_1.ServerUnaryCall<ListMyPaymentsRequest, ListMyPaymentsResponse>, callback: grpc_1.sendUnaryData<ListMyPaymentsResponse>): void;
        abstract ProcessRefund(call: grpc_1.ServerUnaryCall<ProcessRefundRequest, ProcessRefundResponse>, callback: grpc_1.sendUnaryData<ProcessRefundResponse>): void;
        abstract SaveCard(call: grpc_1.ServerUnaryCall<SaveCardRequest, SaveCardResponse>, callback: grpc_1.sendUnaryData<SaveCardResponse>): void;
        abstract ListCards(call: grpc_1.ServerUnaryCall<ListCardsRequest, ListCardsResponse>, callback: grpc_1.sendUnaryData<ListCardsResponse>): void;
        abstract DeleteCard(call: grpc_1.ServerUnaryCall<DeleteCardRequest, DeleteCardResponse>, callback: grpc_1.sendUnaryData<DeleteCardResponse>): void;
        abstract WebhookStarkBank(call: grpc_1.ServerUnaryCall<WebhookStarkBankRequest, WebhookStarkBankResponse>, callback: grpc_1.sendUnaryData<WebhookStarkBankResponse>): void;
        abstract WebhookBradescoPIX(call: grpc_1.ServerUnaryCall<WebhookBradescoPIXRequest, WebhookBradescoPIXResponse>, callback: grpc_1.sendUnaryData<WebhookBradescoPIXResponse>): void;
        abstract UpdateConfig(call: grpc_1.ServerUnaryCall<UpdateConfigRequest, UpdateConfigResponse>, callback: grpc_1.sendUnaryData<UpdateConfigResponse>): void;
        abstract GetConfig(call: grpc_1.ServerUnaryCall<GetConfigRequest, GetConfigResponse>, callback: grpc_1.sendUnaryData<GetConfigResponse>): void;
        abstract UpdatePayment(call: grpc_1.ServerUnaryCall<UpdatePaymentRequest, UpdatePaymentResponse>, callback: grpc_1.sendUnaryData<UpdatePaymentResponse>): void;
        abstract StartReport(call: grpc_1.ServerUnaryCall<StartReportRequest, StartReportResponse>, callback: grpc_1.sendUnaryData<StartReportResponse>): void;
        abstract GetReport(call: grpc_1.ServerUnaryCall<GetReportRequest, GetReportResponse>, callback: grpc_1.sendUnaryData<GetReportResponse>): void;
    }
    export class PaymentsServiceClient {
        private _address: string;
        private _client: grpc_web_1.GrpcWebClientBase;
        constructor(address: string, credentials?: Object, options?: grpc_web_1.GrpcWebClientBaseOptions) {
            if (!options)
                options = {};
            options.format = options.format || "text";
            this._address = address;
            this._client = new grpc_web_1.GrpcWebClientBase(options);
        }
        private static ProcessPayment = new grpc_web_1.MethodDescriptor<ProcessPaymentRequest, ProcessPaymentResponse>("/payments.v1.PaymentsService/ProcessPayment", grpc_web_1.MethodType.UNARY, ProcessPaymentRequest, ProcessPaymentResponse, (message: ProcessPaymentRequest) => message.serialize(), ProcessPaymentResponse.deserialize);
        ProcessPayment(message: ProcessPaymentRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ProcessPaymentRequest, ProcessPaymentResponse>(this._address + "/payments.v1.PaymentsService/ProcessPayment", message, metadata || {}, PaymentsServiceClient.ProcessPayment);
        }
        private static GetPayment = new grpc_web_1.MethodDescriptor<GetPaymentRequest, GetPaymentResponse>("/payments.v1.PaymentsService/GetPayment", grpc_web_1.MethodType.UNARY, GetPaymentRequest, GetPaymentResponse, (message: GetPaymentRequest) => message.serialize(), GetPaymentResponse.deserialize);
        GetPayment(message: GetPaymentRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetPaymentRequest, GetPaymentResponse>(this._address + "/payments.v1.PaymentsService/GetPayment", message, metadata || {}, PaymentsServiceClient.GetPayment);
        }
        private static GetPaymentByOrderID = new grpc_web_1.MethodDescriptor<GetPaymentByOrderIDRequest, GetPaymentByOrderIDResponse>("/payments.v1.PaymentsService/GetPaymentByOrderID", grpc_web_1.MethodType.UNARY, GetPaymentByOrderIDRequest, GetPaymentByOrderIDResponse, (message: GetPaymentByOrderIDRequest) => message.serialize(), GetPaymentByOrderIDResponse.deserialize);
        GetPaymentByOrderID(message: GetPaymentByOrderIDRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetPaymentByOrderIDRequest, GetPaymentByOrderIDResponse>(this._address + "/payments.v1.PaymentsService/GetPaymentByOrderID", message, metadata || {}, PaymentsServiceClient.GetPaymentByOrderID);
        }
        private static ListPayments = new grpc_web_1.MethodDescriptor<ListPaymentsRequest, ListPaymentsResponse>("/payments.v1.PaymentsService/ListPayments", grpc_web_1.MethodType.UNARY, ListPaymentsRequest, ListPaymentsResponse, (message: ListPaymentsRequest) => message.serialize(), ListPaymentsResponse.deserialize);
        ListPayments(message: ListPaymentsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListPaymentsRequest, ListPaymentsResponse>(this._address + "/payments.v1.PaymentsService/ListPayments", message, metadata || {}, PaymentsServiceClient.ListPayments);
        }
        private static ListMyPayments = new grpc_web_1.MethodDescriptor<ListMyPaymentsRequest, ListMyPaymentsResponse>("/payments.v1.PaymentsService/ListMyPayments", grpc_web_1.MethodType.UNARY, ListMyPaymentsRequest, ListMyPaymentsResponse, (message: ListMyPaymentsRequest) => message.serialize(), ListMyPaymentsResponse.deserialize);
        ListMyPayments(message: ListMyPaymentsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListMyPaymentsRequest, ListMyPaymentsResponse>(this._address + "/payments.v1.PaymentsService/ListMyPayments", message, metadata || {}, PaymentsServiceClient.ListMyPayments);
        }
        private static ProcessRefund = new grpc_web_1.MethodDescriptor<ProcessRefundRequest, ProcessRefundResponse>("/payments.v1.PaymentsService/ProcessRefund", grpc_web_1.MethodType.UNARY, ProcessRefundRequest, ProcessRefundResponse, (message: ProcessRefundRequest) => message.serialize(), ProcessRefundResponse.deserialize);
        ProcessRefund(message: ProcessRefundRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ProcessRefundRequest, ProcessRefundResponse>(this._address + "/payments.v1.PaymentsService/ProcessRefund", message, metadata || {}, PaymentsServiceClient.ProcessRefund);
        }
        private static SaveCard = new grpc_web_1.MethodDescriptor<SaveCardRequest, SaveCardResponse>("/payments.v1.PaymentsService/SaveCard", grpc_web_1.MethodType.UNARY, SaveCardRequest, SaveCardResponse, (message: SaveCardRequest) => message.serialize(), SaveCardResponse.deserialize);
        SaveCard(message: SaveCardRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<SaveCardRequest, SaveCardResponse>(this._address + "/payments.v1.PaymentsService/SaveCard", message, metadata || {}, PaymentsServiceClient.SaveCard);
        }
        private static ListCards = new grpc_web_1.MethodDescriptor<ListCardsRequest, ListCardsResponse>("/payments.v1.PaymentsService/ListCards", grpc_web_1.MethodType.UNARY, ListCardsRequest, ListCardsResponse, (message: ListCardsRequest) => message.serialize(), ListCardsResponse.deserialize);
        ListCards(message: ListCardsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListCardsRequest, ListCardsResponse>(this._address + "/payments.v1.PaymentsService/ListCards", message, metadata || {}, PaymentsServiceClient.ListCards);
        }
        private static DeleteCard = new grpc_web_1.MethodDescriptor<DeleteCardRequest, DeleteCardResponse>("/payments.v1.PaymentsService/DeleteCard", grpc_web_1.MethodType.UNARY, DeleteCardRequest, DeleteCardResponse, (message: DeleteCardRequest) => message.serialize(), DeleteCardResponse.deserialize);
        DeleteCard(message: DeleteCardRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<DeleteCardRequest, DeleteCardResponse>(this._address + "/payments.v1.PaymentsService/DeleteCard", message, metadata || {}, PaymentsServiceClient.DeleteCard);
        }
        private static WebhookStarkBank = new grpc_web_1.MethodDescriptor<WebhookStarkBankRequest, WebhookStarkBankResponse>("/payments.v1.PaymentsService/WebhookStarkBank", grpc_web_1.MethodType.UNARY, WebhookStarkBankRequest, WebhookStarkBankResponse, (message: WebhookStarkBankRequest) => message.serialize(), WebhookStarkBankResponse.deserialize);
        WebhookStarkBank(message: WebhookStarkBankRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<WebhookStarkBankRequest, WebhookStarkBankResponse>(this._address + "/payments.v1.PaymentsService/WebhookStarkBank", message, metadata || {}, PaymentsServiceClient.WebhookStarkBank);
        }
        private static WebhookBradescoPIX = new grpc_web_1.MethodDescriptor<WebhookBradescoPIXRequest, WebhookBradescoPIXResponse>("/payments.v1.PaymentsService/WebhookBradescoPIX", grpc_web_1.MethodType.UNARY, WebhookBradescoPIXRequest, WebhookBradescoPIXResponse, (message: WebhookBradescoPIXRequest) => message.serialize(), WebhookBradescoPIXResponse.deserialize);
        WebhookBradescoPIX(message: WebhookBradescoPIXRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<WebhookBradescoPIXRequest, WebhookBradescoPIXResponse>(this._address + "/payments.v1.PaymentsService/WebhookBradescoPIX", message, metadata || {}, PaymentsServiceClient.WebhookBradescoPIX);
        }
        private static UpdateConfig = new grpc_web_1.MethodDescriptor<UpdateConfigRequest, UpdateConfigResponse>("/payments.v1.PaymentsService/UpdateConfig", grpc_web_1.MethodType.UNARY, UpdateConfigRequest, UpdateConfigResponse, (message: UpdateConfigRequest) => message.serialize(), UpdateConfigResponse.deserialize);
        UpdateConfig(message: UpdateConfigRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<UpdateConfigRequest, UpdateConfigResponse>(this._address + "/payments.v1.PaymentsService/UpdateConfig", message, metadata || {}, PaymentsServiceClient.UpdateConfig);
        }
        private static GetConfig = new grpc_web_1.MethodDescriptor<GetConfigRequest, GetConfigResponse>("/payments.v1.PaymentsService/GetConfig", grpc_web_1.MethodType.UNARY, GetConfigRequest, GetConfigResponse, (message: GetConfigRequest) => message.serialize(), GetConfigResponse.deserialize);
        GetConfig(message: GetConfigRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetConfigRequest, GetConfigResponse>(this._address + "/payments.v1.PaymentsService/GetConfig", message, metadata || {}, PaymentsServiceClient.GetConfig);
        }
        private static UpdatePayment = new grpc_web_1.MethodDescriptor<UpdatePaymentRequest, UpdatePaymentResponse>("/payments.v1.PaymentsService/UpdatePayment", grpc_web_1.MethodType.UNARY, UpdatePaymentRequest, UpdatePaymentResponse, (message: UpdatePaymentRequest) => message.serialize(), UpdatePaymentResponse.deserialize);
        UpdatePayment(message: UpdatePaymentRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<UpdatePaymentRequest, UpdatePaymentResponse>(this._address + "/payments.v1.PaymentsService/UpdatePayment", message, metadata || {}, PaymentsServiceClient.UpdatePayment);
        }
        private static StartReport = new grpc_web_1.MethodDescriptor<StartReportRequest, StartReportResponse>("/payments.v1.PaymentsService/StartReport", grpc_web_1.MethodType.UNARY, StartReportRequest, StartReportResponse, (message: StartReportRequest) => message.serialize(), StartReportResponse.deserialize);
        StartReport(message: StartReportRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<StartReportRequest, StartReportResponse>(this._address + "/payments.v1.PaymentsService/StartReport", message, metadata || {}, PaymentsServiceClient.StartReport);
        }
        private static GetReport = new grpc_web_1.MethodDescriptor<GetReportRequest, GetReportResponse>("/payments.v1.PaymentsService/GetReport", grpc_web_1.MethodType.UNARY, GetReportRequest, GetReportResponse, (message: GetReportRequest) => message.serialize(), GetReportResponse.deserialize);
        GetReport(message: GetReportRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetReportRequest, GetReportResponse>(this._address + "/payments.v1.PaymentsService/GetReport", message, metadata || {}, PaymentsServiceClient.GetReport);
        }
    }
}
